var faqData = {
  'A70 Max': {
    nav: [`Preguntas previas a la venta`, `Inicio rápido`, `Mantenimiento y cuidado`],
    nav_desc: [
      `Lo que debes saber antes de comprar`,
      `Tus primeros pasos simplificados (Para principiantes) `,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      // Category 1: Pre-Sale Questions
      [
        {
          Q: `¿Puede la máquina grabar o cortar metal?`,
          A: `Sí, puede grabar ciertos metales, incluyendo aluminio anodizado, latón, acero inoxidable y hierro. También puede cortar láminas delgadas de acero inoxidable de hasta 0.05mm.`,
        },
        {
          Q: `¿Puede la máquina grabar superficies curvas?`,
          A: `Sí, puede grabar superficies curvas regulares, como tazas y botellas térmicas. Recomendamos usar nuestros accesorios rotativos: R1-B (V2), R2-B (V2), R6, R8 o R8 PRO.`,
          video_url: ['https://youtu.be/zJSUY9wM60c'],
        },
        {
          Q: `¿Cuáles son los ajustes recomendados para grabar o cortar cuero?`,
          A: `Por favor, consulta la Tabla de Parámetros de Grabado de 70W para configuraciones detalladas. (La tabla está disponible en la unidad USB incluida, en la página oficial de AtomStack, o a través de nuestro equipo de atención al cliente.)<br/>
  
  Importante<br/>
  
  Consejo: Para evitar que los bordes se quemen o se inflamen al cortar cuero, sugerimos el enfoque de “corte rápido en varias pasadas”: usa alta velocidad con alta potencia, o baja velocidad con baja potencia.<br/>
  
  `,
        },
        {
          Q: `¿Qué ventajas tiene este dispositivo sobre otras máquinas de la misma potencia?`,
          A: `La serie A70 es el primer grabador láser de luz azul de 70W del mundo, ofreciendo un aumento del 30–50% en la capacidad de corte total. Soporta grabado creativo a alta velocidad de hasta 24,000mm/min (400mm/s) y realiza autoenfoque en solo 8 segundos para un arranque más rápido.<br/>
  
  Puntos destacados del producto:<br/>
  
  Corte potente: Puede cortar acrílico oscuro de 1–26mm, MDF de 1–12mm, pino de 1–25mm y láminas de acero inoxidable de 0.05mm.<br/>
  
  Área de trabajo grande:<br/>
  
  A70 PRO: 500×400mm (material máximo 600×645mm)<br/>
  
  A70 MAX: 850×800mm<br/>
  
  Nueva estructura de movimiento: Las guías dobles de eje en los tres ejes con bajo centro de gravedad aseguran operación estable, silenciosa y de alta velocidad, ideal para trabajos pesados.<br/>
  
  Operación sin conexión: La placa base inteligente de segunda generación y la pantalla táctil permiten operar sin computadora ni teléfono.<br/>
  
  Asistencia de aire de alto flujo: Hasta 60L/min de flujo de aire garantizan cortes limpios sin amarillamiento y prolongan la vida útil del módulo láser.<br/>
  
  Aplicaciones versátiles: Adecuado para cobre, cerámica, acrílico negro, carpintería, arte y manualidades, DIY, señalización, marcado de metales y diseño de moda.<br/>
  
  Dual de enfoque: Soporta enfoque manual y automático, completándose en 8 segundos.<br/>
  
  Alarma automática de llamas: Detiene la operación y activa una alerta si se detectan llamas o chispas.<br/>
  
  Sistema de enfriamiento inteligente: La campana de aire de doble capa se activa automáticamente durante el corte para mejorar la extracción de humo y el enfriamiento.<br/>
  
  Reanudación tras pérdida de energía: Permite continuar con proyectos no terminados después de un corte de energía.<br/>
  
  Amplia compatibilidad de accesorios: Compatible con cámaras, rodillos, barras de extensión, cintas transportadoras; el A70 PRO es compatible con una carcasa dedicada.`,
        },
        {
          Q: `¿Existe una carcasa compatible?`,
          A: `Actualmente, no hay una carcasa compatible disponible.`,
        },
        {
          Q: `¿Hay paneles tipo panal adecuados?`,
          A: `A70 MAX: puede usar dos paneles de panal F8 unidos<br/>
A70 PRO: puede usar un panel de panal F4<br/>
`,
        },
        {
          Q: `¿Se pueden usar dispositivos rotatorios?`,
          A: `Sí, se admiten los siguientes dispositivos rotatorios: R1-B (V2), R2-B (V2), R6, R8 y R8 PRO.<br/>
  
Simplemente conecta el cable secuencial del accesorio rotatorio al conector del motor del eje Y de la grabadora.<br/>

Nota importante: Todos los productos AtomStack utilizan un cable secuencial con un conector blanco. Los accesorios rotatorios serie V2 (R1 V2, R2 V2) fabricados antes del 12 de julio de 2024 no incluían este cable—por favor, contacta al servicio al cliente para obtener uno.`,
        },
        {
          Q: `¿Incluye asistencia de aire? ¿Cuál es el caudal y el nivel de ruido?`,
          A: `Sí, la máquina viene con asistencia de aire de doble bomba. Flujo de aire: ~60L/min; nivel de ruido: <60dB.`,
        },
        {
          Q: `¿Es compatible con módulos láser de otros modelos de AtomStack u otras marcas?`,
          A: `No, actualmente no es compatible.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_00c19a04-a6d9-45f6-add4-584b542abf2d.png?v=1763973345:Fig. 1]`,
        },
        {
          Q: `¿Puede usarse el módulo láser en grabadoras de otras marcas?`,
          A: `No, actualmente no es compatible.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_00c19a04-a6d9-45f6-add4-584b542abf2d.png?v=1763973345:Fig. 1]`,
        },
        {
          Q: `¿Puede conectarse a un router?`,
          A: `La máquina permite conectarse mediante la aplicación móvil (usando el hotspot de la máquina o Wi-Fi). El funcionamiento mediante la app es estable.<br/>

Sin embargo, el control remoto mediante dirección IP en LightBurn es inestable y puede afectar el resultado del grabado.<br/>

(La aplicación móvil puede descargarse desde la tienda de aplicaciones o la web oficial de AtomStack; la contraseña de conexión es 12345678.)<br/>

`,
        },
      ],
      // Category 2: Quick Start
      [
        {
          Q: `¿Cómo instalar la máquina?`,
          A: `Antes de la operación, lea cuidadosamente las Declaraciones de Seguridad y Advertencias al principio de este manual.`,
          video_url: ['https://youtu.be/Rs_fsbWDQS8', 'https://youtu.be/G30fGjS-zKc'],
        },
        {
          Q: `¿Cómo conectar la máquina?`,
          A: `Al utilizar LightBurn o LaserGRBL, ajuste la tasa de baudios a 115200.<br/>

El puerto COM correcto se puede encontrar en el Administrador de Dispositivos, normalmente etiquetado como USB-SERIAL CH340 (COM*). Seleccione el puerto correspondiente al número mostrado.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_fb0037b7-9816-4bcc-b8d4-94955e35009a.png?v=1764041816:Fig. 1]`,
          video_url: ['https://youtu.be/fHhCyWwuK08'],
        },
        {
          Q: `¿Cómo conectar la cámara?`,
          A: `Cobertura recomendada de la cámara: 400 × 400 mm. Limitación para la Serie A70:<br/>

La cámara no puede cubrir completamente el área de trabajo de la serie A70. Sólo se puede utilizar un área de 400 × 400 mm al operar la A70.<br/>

Área de operación y grabado:<br/>

Se deben usar coordenadas absolutas con la cámara.<br/>

Máquinas PRO: área de grabado de 500 × 400 mm<br/>

Máquinas MAX: área de grabado de 850 × 800 mm<br/>

`,
          video_url: ['https://youtu.be/qrC4iJ_FlsE'],
        },
        {
          Q: `¿Cómo conectar el accesorio rotatorio (R1-B(V2), R2-B(V2), R6, R8, R8 PRO)?`,
          A: `Todas las máquinas AtomStack requieren cables de conexión secuencial (daisy-chain).<br/>

Para configuraciones elevadas, use los pies de extensión roscados incluidos.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b26ca13f-fa93-430a-90fe-badd4a6b875e.png?v=1764042270:Fig. 1]`,
          video_url: ['https://youtu.be/zJSUY9wM60c'],
        },
        {
          Q: `¿Cómo usar el autoenfoque y el enfoque manual?`,
          A: `Se recomienda el autoenfoque. Alternativamente, use el módulo de enfoque para ajuste manual.<br/>

Alturas de enfoque recomendadas:<br/>

Grabado: 20 mm<br/>

Corte ≤ 20 mm de grosor: 15 mm<br/>

Corte > 20 mm de grosor (profundidad máxima): 8 mm<br/>

Comando de enfoque por software: [ESP500] (LightBurn / LaserGRBL)<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_37ccddb0-9162-47e9-a42e-915a531bb13e.png?v=1764048538:Fig. 1]`,
          video_url: ['https://youtu.be/HhFqlER4kRE'],
        },
        {
          Q: `¿Cómo establecer y posicionar el origen?`,
          A: `Consulte los tutoriales en video sobre ajuste de origen, posicionamiento y calibración del punto cruz.<br/>

Guías de movimiento:<br/>

Haga clic en "Inicio" para que la máquina regrese a la coordenada absoluta 0,0 antes de configurar el origen de trabajo.<br/>

No mueva la máquina manualmente; todos los movimientos deben realizarse desde el software.<br/>

Si la máquina se mueve manualmente, realice el home nuevamente antes de posicionar o reanudar el trabajo.<br/>

Uso del punto cruz:<br/>

El centro del punto cruz indica la posición inicial de emisión del láser.<br/>

Ante cualquier desviación, consulte el video de calibración del punto cruz.<br/>

`,
          video_url: ['https://youtu.be/otsELzA1mCs', 'https://youtu.be/IUibPdqX4Mk'],
        },
        {
          Q: `¿Cómo usar los sistemas de coordenadas del software?`,
          A: `Posición actual (Relativa): el láser comienza desde su ubicación actual. El cabezal láser puede posicionarse manualmente en el punto inicial deseado.<br/>

Origen del usuario (Desplazamiento): una posición inicial definida por el usuario para el trabajo. Vea el video sobre ajuste de origen para instrucciones.<br/>

Coordenadas absolutas: usa la posición 0,0 después del home como referencia. El láser inicia el trabajo según las coordenadas del archivo de diseño relativas al 0,0 de la máquina.<br/>

`,
          video_url: ['https://youtu.be/otsELzA1mCs '],
        },
        {
          Q: `¿Cómo probar los parámetros de grabado por software?`,
          A: `Se requiere una licencia legítima de LightBurn (versión 1.3.01 o superior) o AtomStack Studio para acceder a esta función.`,
          video_url: ['https://youtu.be/2qoXsp_kKCw', 'https://youtu.be/fHhCyWwuK08'],
        },
      ],
      // Category 3: Maintenance & Care
      [
        {
          Q: `¿Cómo limpiar la ventana láser y la lente de enfoque?`,
          A: `Las ventanas y lentes sucias pueden hacer que el láser enfoque sobre la propia lente, lo que puede dañar tanto la ventana como la lente de enfoque interna.<br/>

Procedimiento y herramientas de limpieza:<br/>

Agente de limpieza: Utilice etanol anhidro al 99% o un limpiador profesional para lentes ópticas. Evite solventes que contengan amoníaco o acetona.<br/>

Técnica de limpieza: Utilice un paño sin pelusa o un hisopo de algodón de calidad óptica, limpiando en una sola dirección continua (por ejemplo, en espiral del centro hacia afuera). Evite movimientos de vaivén para prevenir rayones.<br/>

Precaución con herramientas: No use hisopos de algodón normales, ya que pueden dejar fibras.<br/>

Revisión posterior: Inspeccione la lente bajo luz intensa para asegurarse de que no queden residuos, películas ni fibras.<br/>

Notas de mantenimiento:<br/>

Frecuencia: Diariamente para máquinas de uso intensivo; semanalmente para máquinas de bajo uso.<br/>

Importante: La lente de enfoque no es desmontable. No intente forzarla ni desmontarla. Retirar la ventana externa expone la lente de enfoque interna.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8a635657-a8a8-4da8-ae5b-b3528a9af82f.png?v=1764051791:Fig. 1]`,
          video_url: ['https://youtu.be/6lzFNbED9Hc'],
        },
        {
          Q: `¿Cómo limpiar el ventilador láser y la tarjeta del driver?`,
          A: `Ventilador láser: La acumulación de polvo reduce la eficiencia de enfriamiento, causando sobrecalentamiento, acortando la vida útil del láser o generando daños permanentes.<br/>

Tarjeta del driver: El polvo puede causar sobrecalentamiento, cortocircuito o quemar los componentes.<br/>

Método de limpieza recomendado:<br/>

Utilice aire comprimido o un pincel suave para quitar el polvo. Evite ejercer demasiada fuerza o usar líquidos.<br/>

`,
          video_url: ['https://youtu.be/ZoJFD4k1RIM'],
        },
        {
          Q: `¿Cómo limpiar y mantener el marco de la máquina?`,
          A: `La limpieza previene que el polvo o residuos entren en rieles o deslizadores, lo que podría afectar el movimiento o causar ruidos anormales.<br/>

Procedimiento:<br/>

Limpie el marco con etanol anhidro al 99%.<br/>

Después de limpiar, aplique grasa uniformemente en los rieles.<br/>

Grasa y frecuencia recomendadas:<br/>

Grasa: Grasa de litio blanca, grado 2/3<br/>

Temperatura < 15°C: Grado 2<br/>

Temperatura ≥ 15°C: Grado 3<br/>

Frecuencia: Cada 500 horas de uso<br/>

`,
          video_url: ['https://youtu.be/NNuQZsqwEXI'],
        },
        {
          Q: `¿Cómo limpiar el sistema de Air Assist (asistencia de aire)?`,
          A: `La asistencia de aire es esencial para el rendimiento de corte. El polvo que bloquea la entrada de la bomba puede causar sobrecalentamiento y fallo de la bomba.<br/>

Frecuencia: Máquinas de uso intensivo – mensual; máquinas de bajo uso – cada 3 meses.<br/>

`,
          video_url: ['https://youtu.be/0k50eGC9v4s'],
        },
        {
          Q: `¿Cómo preparar la máquina para almacenamiento prolongado?`,
          A: `Guarde la máquina en un lugar seco.<br/>

Evite la exposición prolongada a ambientes húmedos.<br/>

Encienda periódicamente para comprobar el funcionamiento.<br/>

`,
        },
        {
          Q: `¿Cuál es la temperatura de funcionamiento recomendada?`,
          A: `Temperatura óptima de trabajo: 0°C – 35°C`,
        },
        {
          Q: `¿Cómo limpiar o reemplazar una lente/ventana láser sucia o dañada?`,
          A: `Solución:<br/>

Ventana: Retire y limpie con alcohol anhidro al 99% o limpiador óptico. Evite solventes con amoníaco o acetona. Cambie la ventana si las manchas no se eliminan.<br/>

Lente de enfoque: No desmontable; nunca intente desensamblar. Si no puede limpiarse o está dañada, debe reemplazarse el láser completo.<br/>

Nota: La limpieza regular previene daños. Contacte al soporte con fotos de la lente, número de serie de la máquina y código de grabado si requiere reemplazo.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_224ec316-1f01-478f-839e-c94039066de3.png?v=1764054392:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_875f387d-34a9-43c1-ae77-6c7afc69032e.png?v=1764054441:Fig. 2]`,
          video_url: ['https://youtu.be/6lzFNbED9Hc'],
        },
        {
          Q: `¿Cómo solucionar la pérdida de potencia del corte láser?`,
          A: `Solución:<br/>

Desgaste normal: Ajuste la potencia o la velocidad para compensar.<br/>

Entorno: Mantenga la temperatura ≤35°C. Evite operaciones continuas a máxima potencia por más de 4 horas; deje enfriar 15 minutos cada 2 horas.<br/>

Configuración del software: Siga la tabla de parámetros; no cambie el valor máximo de S (1000).<br/>

Ventana/lente de enfoque: Limpie o reemplace (ver sección 1).<br/>

Polvo láser: Limpie ventilador y tarjeta del driver con cepillo suave.<br/>

Guía de aire: Revise el patrón del haz (se esperan 7 puntos rectangulares).<br/>

Si el problema persiste: Reemplace el láser; proporcione número de serie, código del láser y video de inspección.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bda9a17c-5070-4020-9155-9e47024f4b00.png?v=1764054813:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_224ec316-1f01-478f-839e-c94039066de3.png?v=1764054392:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_875f387d-34a9-43c1-ae77-6c7afc69032e.png?v=1764054441:Fig. 3]`,
          video_url: ['https://youtu.be/ZoJFD4k1RIM', 'https://youtu.be/HhFqlER4kRE'],
        },
        {
          Q: `¿Cómo solucionar cuando el láser se mueve pero no dispara?`,
          A: `Solución:<br/>

Verifique los parámetros del software.<br/>

Evite materiales reflectantes; pinte de negro si es necesario.<br/>

Compruebe conexión del cable láser, desconecte y reconecte.<br/>

Mida el voltaje de 3PIN para identificar si hay fallo en fuente, placa principal o módulo láser.<br/>

Revise el LED del driver para identificar problema en tubo o tarjeta.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_401775d8-90a8-4ecd-9817-c4e6f7e6dac3.png?v=1764055431:Fig. 1]`,
          video_url: [
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/-6xZna8qMU8',
            'https://youtu.be/BXZju0WW4hQ',
            'https://youtu.be/GxpTrYe8z00',
          ],
        },
        {
          Q: `¿Cómo solucionar operaciones que se detienen a la mitad y se reanudan tras reiniciar?`,
          A: `Solución:<br/>

Reinserte el cable TYPE-C.<br/>

En Windows 11, evite ejecutar el software en segundo plano.<br/>

Verifique el progreso en el software, limpie puertos USB, pruebe con otro cable/puerto.<br/>

Mida la salida de energía (20–25V & 30–37V).<br/>

Reinstale firmware.<br/>

Si persiste, cambie la placa principal.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_59e1b61f-6ef3-44b8-94b1-08e4b39d43d9.png?v=1764056042:Fig. 1]`,
          video_url: ['https://youtu.be/9GVAxLu9GFs', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar si el láser se detiene en cierta posición mientras se desplaza?`,
          A: `Solución: Revise el cable de conexión con la placa principal; si el láser dispara al devolverlo, reemplace el cable.`,
        },
        {
          Q: `¿Cómo solucionar fallas en el autoenfoque?`,
          A: `Solución:<br/>

Verifique el movimiento del eje Z mediante AtomStack Studio o LightBurn.<br/>

Ajuste estructura o cambie el motor Z si es necesario.<br/>

Inspeccione los finales de carrera superior/inferior; cambie si están defectuosos.<br/>

Si el motor Z vibra pero el láser no se mueve, cambie el motor.<br/>

Si solo se mueve en una dirección, revise cableado/circuito principal.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ed9ff22d-2d6f-4bc1-9cb4-d1bb8f2d3878.png?v=1764059671:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_02d107ac-b6e1-4453-b6c5-14f8fbeeabe6.png?v=1764059671:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_99b09a48-cb14-4f47-b8a9-03eddf515141.png?v=1764059671:Fig. 3]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_7deaabf0-6fb9-4989-a9b8-a0d1ac87a212.png?v=1764059671:Fig. 4]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_1b140d81-93d8-426e-9629-bbc98dd1f048.png?v=1764059671:Fig. 5]`,
          video_url: [
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/xiM_dekfmIU',
            'https://youtu.be/_KO5VjtipI0',
            'https://youtu.be/xiM_dekfmIU',
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/rSGkKO_S2A0',
          ],
        },
        {
          Q: `¿Cómo solucionar desplazamiento anómalo en los ejes X/Y?`,
          A: `Solución:<br/>

Pruebe el movimiento desde el software para identificar el eje defectuoso.<br/>

Revise y reconecte el cable del motor.<br/>

Intercambie motores con el otro eje para diagnosticar si es problema de motor o de driver.<br/>

Si fallan ambos ejes, revise cables a placa principal; reinstale firmware o reemplace placa si es necesario.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a26a8c1f-a3db-4e0c-90c8-9d94b41dd3c2.png?v=1764060965:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ef972445-958a-4518-aeaf-8d08d7913b55.png?v=1764060965:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_c45a2136-f3d3-4b74-89e8-8670a8810881.png?v=1764060965:Fig. 3]`,
          video_url: [
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/nd8iuCfyDBo',
            'https://youtu.be/R7wosm3dEdI',
            'https://youtu.be/rSGkKO_S2A0',
          ],
        },
        {
          Q: `¿Cómo solucionar fallo de conexión con el ordenador?`,
          A: `Solución:<br/>

Verifique el puerto COM y la velocidad de transmisión (115200, GRBL).<br/>

Instale los drivers USB (CH340/FTDI).<br/>

Pruebe con AtomStack Studio.<br/>

En Mac, use un dock para conectar Type-C a USB-A.<br/>

Revise cables y firmware; cambie la placa principal si se requiere.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_70dd00b1-ceb9-4272-bf3b-41c654214552.png?v=1764061563:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_29b1ba66-7c2c-43df-b061-f0ee43d1cadc.png?v=1764061563:Fig. 2]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d0015e0a-7f30-4606-bc78-71b306140584.png?v=1764061563:Fig. 3]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2c1bd2d1-f046-4bd9-ae9b-370ef7795297.png?v=1764061563:Fig. 4]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_8c8ac32a-24ed-4a05-bcca-e17b2c2eee77.png?v=1764061564:Fig. 5]`,
          video_url: ['https://youtu.be/R7wosm3dEdI '],
        },
        {
          Q: `¿Cómo solucionar patrones de grabado irregulares?`,
          A: `Solución:<br/>

Grabe cuadrados/círculos para identificar el eje fallido.<br/>

Inspeccione rieles, poleas, correas y soporte del láser.<br/>

Ajuste la estructura y vuelva a probar.<br/>

Asegúrese que el eje X y la viga inferior estén paralelos.<br/>

Revise los valores de paso ($100/$101).<br/>

Si los valores son correctos, reinstale el firmware.<br/>

Si no se soluciona, reemplace la placa principal.<br/>

`,
          video_url: [
            'https://youtu.be/bwJMCS_O-zE',
            'https://youtu.be/_z_IGAiNxzc',
            'https://youtu.be/R7wosm3dEdI',
          ],
        },
        {
          Q: `¿Cómo resolver desalineación entre el punto cruz y el punto láser?`,
          A: `Solución: Recalibre si la desalineación supera 1mm.`,
          video_url: ['https://youtu.be/IUibPdqX4Mk'],
        },
        {
          Q: `¿Cómo solucionar alarmas frecuentes de flama?`,
          A: `Solución:<br/>

Desactive la detección de llama al cortar materiales inflamables; supervise siempre el proceso.<br/>

Para patrones densos, aumente la velocidad o divida el trabajo en varias pasadas.<br/>

Si sigue con alarmas a baja potencia, la tarjeta de detección puede estar defectuosa; reemplácela.<br/>

`,
          video_url: ['https://youtu.be/kj5YqY8iAmE', 'https://youtu.be/1yhYDuFlY6E'],
        },
        {
          Q: `¿Cómo solucionar si el eje rotativo gira continuamente?`,
          A: `Solución: Desactive las funciones "Auto-Home al encender" y "Regresar al endpoint"; evite modo de coordenadas absolutas.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5bc5110b-38f1-44ef-a319-a923738a0160.png?v=1764138676:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_252aa5b2-4d21-4bbb-bda9-2382a9255fb3.png?v=1764138676:Fig. 2]`,
        },
        {
          Q: `¿Cómo solucionar colisiones durante la detección de bordes o el grabado?`,
          A: `Solución:<br/>

Verifique tamaño de archivo y coordenadas.<br/>

Revise posicionamiento auxiliar y control por software.<br/>

Actualice firmware o cambie placa principal si es necesario.<br/>

`,
          video_url: ['https://youtu.be/9GVAxLu9GFs', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar si el ventilador no gira?`,
          A: `Solución:<br/>

Retire obstrucciones, limpie polvo, revise movimiento de aspas.<br/>

Revise conexión en bornera del ventilador.<br/>

Pruebe ventilador aparte; cambie ventilador o placa driver si es necesario.<br/>

`,
          video_url: ['https://youtu.be/GxpTrYe8z00'],
        },
        {
          Q: `¿Cómo solucionar cuando no se enciende el indicador de encendido?`,
          A: `Solución:<br/>

El indicador solo se activa durante grabado o corte.<br/>

Revise funcionamiento del interruptor y conexión del cable.<br/>

Si todo parece normal, cambie la placa driver.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_665cacc8-76fd-4851-a13f-669e5684e947.png?v=1764139290:Fig. 1]`,
          video_url: ['https://youtu.be/Wb0vrRkKQr4', 'https://youtu.be/GxpTrYe8z00'],
        },
        {
          Q: `¿Cómo apretar un soporte de láser flojo?`,
          A: `Solución: Apriete los tornillos o reemplace el carro del eje X.`,
          video_url: ['https://youtu.be/_z_IGAiNxzc', 'https://youtu.be/h136ouvOzZ4'],
        },
        {
          Q: `¿Cómo solucionar dirección incorrecta de referencia por Home?`,
          A: `Solución: Ajuste el parámetro $23 o haga un reset ($RST=*); reinstale firmware si es necesario.<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d7259c29-f41e-4d09-8c45-c4503fae8f79.png?v=1764140571:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_32f0ddfb-48b3-4869-996d-ffb46ac553ce.png?v=1764140571:Fig. 2]`,
          video_url: ['https://youtu.be/9GVAxLu9GFs'],
        },
        {
          Q: `¿Cómo solucionar si la unidad USB no es reconocida?`,
          A: `Solución:<br/>

Pruebe el USB en el ordenador; cámbielo si está defectuoso.<br/>

Formatee a FAT32.<br/>

Si sigue fallando, puede requerir reemplazo el puerto USB o la placa principal.<br/>

`,
          video_url: ['https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar problemas de conexión con la app móvil?`,
          A: `Solución:<br/>

Verifique el procedimiento de conexión.<br/>

Actualice la App a la última versión.<br/>

Asegúrese que el teléfono detecte el Wi-Fi del láser (Engraver_***).<br/>

Pruebe con otros teléfonos; si sigue fallando, reemplace la placa principal.<br/>

`,
          video_url: ['https://youtu.be/2gEosgOEtZo', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar si la APP interrumpe el grabado y el USB no es detectado?`,
          A: `Solución: Reemplace la memoria USB.`,
        },
        {
          Q: `¿Cómo solucionar si la pantalla de control está en negro?`,
          A: `Solución:<br/>

Verifique el arranque de la máquina.<br/>

Revise la conexión HDMI.<br/>

Si la pantalla táctil suena pero no muestra imagen, puede ser fallo de HDMI/placa principal; si no hay sonido, revise la pantalla.<br/>

`,
          video_url: ['https://youtu.be/24KQlGrgTlE'],
        },
        {
          Q: `¿Cómo solucionar si no se puede mover el láser manualmente tras encender?`,
          A: `Solución:<br/>

Desactive la función “Power Resume”.<br/>

Revise cables a placa principal; reinstale firmware o cambie placa si es necesario.<br/>

`,
          video_url: ['https://youtu.be/kj5YqY8iAmE', 'https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar asistencia de aire débil y ruidosa?`,
          A: `Solución:<br/>

Verifique si hay mangueras dobladas u obstruidas.<br/>

Pruebe el máximo flujo de aire; limpie el polvo interno.<br/>

Si sigue débil, reemplace la bomba.<br/>

`,
          video_url: ['https://youtu.be/j-uBp4ZGrGc', 'https://youtu.be/W3jZZid4ZdM'],
        },
        {
          Q: `¿Cómo solucionar si la asistencia de aire no enciende?`,
          A: `Solución:<br/>

Asegúrese de que hay energía y que la operación está activa.<br/>

Revise bomba y fuente de alimentación.<br/>

Mida la salida de 12V; cambie el controlador de velocidad si es necesario.<br/>

`,
          video_url: [
            'https://youtu.be/W3jZZid4ZdM',
            'https://youtu.be/9ALA-U2AnoQ',
            'https://youtu.be/_hnlEV2_Ka0',
          ],
        },
        {
          Q: `¿Cómo solucionar si el láser no genera potencia de salida?`,
          A: `Solución:<br/>

Verifique que el interruptor del voltaje de entrada coincida con el voltaje local.<br/>

Mida salida DC; cambie la fuente si es anormal.<br/>

Revise fusible y cableado.<br/>

<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2002de7d-a016-45a7-aa3d-4a2cbc65711d.png?v=1764143145:Fig. 1]<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_95d65b02-ef09-48db-b5d1-5a71a2996c00.png?v=1764143145:Fig. 2]`,
        },
        {
          Q: `¿Cómo solucionar la alarma 9 del software?`,
          A: `Solución:<br/>

Verifique los finales de carrera.<br/>

Asegure que el autoenfoque de eje Z finalice; vea sección 6.<br/>

Si hay múltiples alarmas, reinstale firmware o sustituya la placa principal.<br/>

`,
          video_url: ['https://youtu.be/R7wosm3dEdI'],
        },
        {
          Q: `¿Cómo solucionar alarmas comunes de la máquina?`,
          A: `Alarma 1: Se activó el final de carrera<br/>

Alarma 2: Límite software activado ($20)<br/>

Alarma 3: Operación interrumpida<br/>

Alarma 8: Final de carrera activado continuadamente<br/>

Alarma 11: Inclinación detectada<br/>

Alarma 12: Detección de flama<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_786fba4d-593b-4096-bd8d-62c0b09f04eb.png?v=1764143875:Fig. 1]`,
        },
        {
          Q: `¿Cómo actualizar software, firmware y la app móvil?`,
          A: `AtomStack Studio: Actualización automática/manual.<br/>

Firmware: Actualice mediante la app o por solicitud de número de serie; copie a la raíz del USB.<br/>

App: Descargue la última versión desde AtomStack.com o actualice desde la aplicación.<br/>

`,
        },
      ],
    ],
  },
  Kraft: {
    nav: [`Preguntas antes de la compra`, `Inicio rápido`, `Mantenimiento y Cuidado`],
    nav_desc: [
      `Lo que necesitas saber antes de comprar`,
      `Tus primeros pasos hechos simples (para principiantes)`,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      [
        {
          Q: `¿Es seguro usar Kraft?`,
          A: `Kraft cuenta con un diseño totalmente cerrado y ha pasado la certificación IEC/EN60825-1 Clase 1, cumpliendo con los estándares de seguridad láser de Clase 1.<br/>

        Un bloqueo de seguridad detiene automáticamente el láser cuando se abre la puerta, evitando lesiones.<br/>

        La ventana de observación utiliza material filtrado, por lo que no se requieren gafas de seguridad cuando la puerta está cerrada.`,
          video_url: [],
        },
        {
          Q: `¿Kraft puede grabar metal?`,
          A: `Sí. El sistema de doble láser de Kraft (rojo + azul) funciona con la mayoría de los materiales.<br/>

        Para metales, recomendamos usar la luz roja o el modo de doble luz.<br/>

        Consulta la hoja de parámetros de grabado de Kraft para configuraciones específicas. Puedes acceder a ella mediante:<br/>

        Escaneando el código QR en la máquina.<br/>

        Visitando [link:/pages/product-support]<br/>

        Contactando nuestro servicio al cliente.`,
          video_url: [],
        },
        {
          Q: `¿Kraft incluye sistema de aire asistido?`,
          A: `No. Para utilizar aire asistido, necesitas la bomba de supresión de incendios F70.<br/>

        La F70 proporciona aire asistido estándar y supresión automática de incendios.<br/>

        Para habilitar la supresión automática de incendios, llena el depósito de agua y conecta ambas salidas de energía a los puertos de aire asistido y bomba de incendios de Kraft.<br/>

        Consulta el manual para instrucciones de instalación.`,
          video_url: [],
        },
        {
          Q: `¿Kraft puede usar un accesorio rotatorio?`,
          A: `Sí. Los accesorios rotatorios recomendados son R6, R8 y R8 Pro, todos con detección automática.<br/>

        Con AtomStack Studio: el R6 funciona automáticamente; el R8 requiere ingresar el diámetro o la circunferencia del material.<br/>

        Con LightBurn: configura según el tipo de rotatorio. Consulta la Guía de Accesorios Rotatorios de Kraft para más detalles.`,
          video_url: [],
        },
        {
          Q: `¿Cuál es el área de grabado de Kraft?`,
          A: `Estándar: 500 × 320 mm<br/>

        Con expansión transportadora R5: hasta 500 × 800 mm (requiere elevador H3)`,
          video_url: [],
        },
        {
          Q: `¿Kraft se puede ampliar para materiales más grandes?`,
          A: `Sí. Usando el transportador R5, el área de trabajo puede alcanzar los 500 × 800 mm.<br/>

        Se requiere elevador H3 para una correcta instalación.`,
          video_url: [],
        },
        {
          Q: `¿Cuál es el grosor máximo de material que puede grabar Kraft?`,
          A: `Con la base instalada: hasta 55 mm<br/>

        Sin base: espesor teóricamente ilimitado, siempre que las cuatro patas de soporte estén niveladas y estables.<br/>

        Con elevador H3: añade hasta 100 mm.`,
          video_url: [],
        },
        {
          Q: `¿Kraft puede usar láseres de otras marcas?`,
          A: `No. La instalación y el cableado del láser son específicos de Kraft. Sin embargo, el láser de 40W y el de doble láser rojo-azul de 20W+1.2W son intercambiables.`,
          video_url: [],
        },
        {
          Q: `¿Kraft puede grabar cuero? ¿Qué parámetros se recomiendan?`,
          A: `Sí. El cuero se puede grabar utilizando luz azul, infrarroja o modo de doble luz.<br/>

        Consulta la hoja de parámetros para las configuraciones (código QR, [link:/pages/product-support], o atención al cliente).`,
          video_url: [],
        },
        {
          Q: `¿Kraft incluye una base de panal?`,
          A: `Sí, se incluye una base tipo panal.`,
          video_url: [],
        },
        {
          Q: `¿Kraft puede ser controlado mediante pantalla táctil?`,
          A: `Sí, usando la pantalla táctil CR1. Nota: no conecte otras pantallas alimentadas (monitores HDMI, televisores, etc.) al puerto HDMI de Kraft.`,
          video_url: [],
        },
        {
          Q: `¿Kraft tiene Wi-Fi y aplicación móvil?`,
          A: `Sí. Puedes conectar Kraft mediante la app. Consulta el video de desempaquetado e instalación para instrucciones.`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`],
        },
        {
          Q: `¿Qué software es compatible con Kraft?`,
          A: `AtomStack Studio, LightBurn y la app AtomStack.`,
          video_url: [],
        },
        {
          Q: `¿Se puede actualizar el láser de Kraft?`,
          A: `Actualmente, Kraft es compatible con dos láseres:<br/>

        Doble láser rojo-azul de 20W + 1.2W<br/>

        Láser de potencia variable de 40W`,
          video_url: [],
        },
        {
          Q: `¿Hay purificadores de aire compatibles para Kraft?`,
          A: `Sí, recomendamos el purificador AtomStack D4.<br/>

        Diámetro de la brida del ventilador: 75 mm<br/>

        Manguera de escape incluida: diámetro de 76 mm, longitud de 2 m (se puede acortar a 160 mm)`,
          video_url: [],
        },
        {
          Q: `¿Cuál es el nivel de ruido de Kraft?`,
          A: `Ambiente: 48.3 dB<br/>

        Grabado horizontal: 72 dB<br/>

        Grabado vertical: 81.9 dB`,
          video_url: [],
        },
        {
          Q: `¿Cuáles son las ventajas de Kraft comparado con otros modelos?`,
          A: `Primer grabador sincronizado del mundo con doble láser, que combina un láser de diodo azul de 20W con un láser infrarrojo de 1.2W.<br/>

        Tres modos de láser con cambio de modo con un solo clic.<br/>

        Gran área de trabajo: 500 × 320 mm, expandible a 500 × 800 mm con transportador.<br/>

        Cámara 4K de 16MP integrada para posicionamiento preciso de 0.5 mm; compatible con AtomStack Studio y LightBurn.<br/>

        Ecosistema de accesorios completo: bomba de fuego, accesorios rotatorios, elevadores, purificadores de aire.<br/>

        Recuperación tras pérdida de energía: reanuda el grabado tras interrupciones para evitar desperdicio de material.<br/>

        Diseño completamente cerrado con seguridad láser Clase 1, bloqueo de seguridad y ventana de visualización filtrada.`,
          video_url: [],
        },
      ],

      [
        {
          Q: `1. Introducción a la interfaz de control de Kraft`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/1_d091799c-2951-4fa8-a908-6399ed53b330.png?v=1767686993:]<br/>

          (1) Botón de cambio de modo láser: Permite alternar entre Modo Láser Azul, Modo Infrarrojo y Modo Dual Azul & Infrarrojo.<br/>

          Mantenga presionado durante 5 segundos para restablecer la configuración de red.<br/>

          (2) Botón de autofoco: Inicia la función de autoenfoque.<br/>

          (3) Indicador de alarma: La luz roja indica estado de alarma; la luz verde indica funcionamiento normal.<br/>

          (4) Interruptor de encendido: Enciende o apaga el grabador.<br/>

          (5) Puerto de alimentación del sistema de aire asistido: Suministra energía al sistema de aire asistido y permite el control de su estado de encendido/apagado.<br/>

          Voltaje de salida: 24V.<br/>

          (6) Puerto de entrada de alimentación: Conecta el adaptador de corriente de 24V 9A incluido.<br/>

          (7) Puerto de la manguera de aire asistido: Se conecta a la manguera de aire asistido.<br/>

          (8) Puerto Type-C: Se conecta a una computadora mediante un cable Type-C.<br/>

          (9) Puerto para pantalla táctil: Se conecta a una pantalla táctil mediante un cable HDMI.<br/>

          Nota: No conecte cables HDMI de otros dispositivos alimentados, incluidos monitores o televisores.<br/>

          (10) Puerto para USB: Permite insertar una memoria USB. Nota: Es necesario insertar una unidad USB al usar la pantalla táctil o la aplicación móvil.<br/>

          (11) Puerto para dongle USB: La máquina de grabado no arrancará si el dongle USB no está insertado.<br/>

          (12) Puerto de accesorios: Se conecta a accesorios como rotatorios o alimentadores de transportador, con capacidad de reconocimiento automático.<br/>

          (13) Puerto de salida de alimentación para bomba de aire de extinción de incendios: Se conecta al sistema de aire asistido con capacidad de extinción automática de incendios.<br/>

          (14) Antena Wi-Fi: Fortalece la señal Wi-Fi.<br/>

          (15) Ventilador extractor de humo: La brida del ventilador tiene un diámetro de 75 mm y se conecta a la manguera de extracción incluida (diámetro 76 mm, largo comprimido 160 mm, largo extendido 2 metros).`,
          video_url: [],
        },
        {
          Q: `Desempaquetado y configuración de Kraft`,
          A: `Lea cuidadosamente las declaraciones de seguridad y advertencias al principio del manual antes de usar.<br/>

        Nota:<br/>

        (1) Al usar el software AtomStack Studio, no se requieren configuraciones adicionales para conectar y usar el dispositivo.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_0f50f6b1-5f5b-424e-97b1-8ab2a9aef518.png?v=1767687283:Figura 1]<br/>

        Al conectar con el software LightBurn, la velocidad en baudios debe cambiarse a 460800 (ver Figura 1).<br/>

        Alternativamente, puede importar el "archivo de configuración" proporcionado desde la memoria USB al software.<br/>

        Algunas versiones pueden ocultar la ventana de configuración de la velocidad en baudios; esto puede solucionarse importando nuestro archivo de configuración.<br/>

        Consulte el video tutorial de importación de archivos de configuración de LightBurn para más ayuda.<br/>

        (2) Al conectar al puerto USB de una computadora, los usuarios de macOS no deben conectar directamente el cable Type-C.<br/>

        En su lugar, se debe usar una estación de acoplamiento (ver Figura 2) para convertir la conexión a Type-A.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2.png?v=1767687284:Figura 2]`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`, `https://youtu.be/owtluqIgUGA`],
        },
        {
          Q: `Descripción del modo de capas`,
          A: `(1) AtomStack Studio, como se muestra en la figura 3:<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3.png?v=1767687991:Figura 3]<br/>

    Modo Imagen: Genera un archivo automáticamente después de importar una imagen.<br/>

    Modo Línea: Se utiliza al grabar gráficos vectoriales.<br/>

    Modo Relleno: Rellena el área entre líneas — este es el modo de grabado.<br/>

    Modo Corte: Corta a través del objeto — este es el modo de corte.<br/>

    LightBurn, como figura 4:<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4.png?v=1767687991:Figura 4]<br/>

    Modo Imagen:<br/>

    Después de importar una imagen, el sistema entra en modo imagen, utilizado para grabado.<br/>

    Modo Relleno:<br/>

    Rellena el área entre líneas y se utiliza para grabado.<br/>

    Modo Relleno + Línea:<br/>

    Rellena el área entre líneas y también corta a lo largo de las líneas. Este modo realiza grabado y corte.<br/>

    Modo Línea:<br/>

    Se usa para grabar archivos vectoriales o para operaciones de corte.`,
          video_url: [],
        },
        {
          Q: `Ajuste de enfoque de Kraft`,
          A: `Nota: Kraft admite métodos de enfoque automático y manual.<br/>

    Métodos de enfoque automático:<br/>

    Utilice el botón de autoenfoque de la máquina;<br/>

    En AtomStack Studio, haga clic en el botón de enfoque en el software (ver Figura 5);<br/>

    En LightBurn, ingrese [ESP500] en el área de comandos macro (ver Figura 6);<br/>

    Método de enfoque manual:<br/>

    Use el separador de enfoque fijo incluido y ajuste el enfoque a 40 mm girando la perilla de enfoque manual ubicada en la parte posterior del eje Z (ver Figura 7); la distancia es entre la base del cabezal láser y el material.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5.png?v=1767688463:Figura 5]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6.png?v=1767688463:Figura 6]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7.png?v=1767688463:Figura 7]`,
          video_url: [`https://youtu.be/wbhrViu3EGE`],
        },
        {
          Q: `Cambio entre láser infrarrojo y azul de Kraft & modo dual`,
          A: `Nota: Cuando se utilice el Modo Láser Dual, asegúrese de que la distancia focal esté ajustada precisamente a 40 mm. Si el enfoque es incorrecto, el láser infrarrojo puede no lograr resultados óptimos de grabado.`,
          video_url: [`https://youtu.be/FDSFReD3tO0`],
        },
        {
          Q: `Reemplazo del láser de Kraft`,
          A: ``,
          video_url: [`https://youtu.be/leUQfQl34Lw`],
        },
        {
          Q: `Cómo usar la cámara en Kraft`,
          A: `Nota: Cuando use la función de cámara, debe configurar "Comenzar desde" en "Coordenadas absolutas". En AtomStack Studio, consulte la Figura 6;<br/>

    En LightBurn, consulte la Figura 7.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8.png?v=1767688730:Figura 8]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9.png?v=1767688730:Figura 9]`,
          video_url: [`https://youtu.be/1q3v3KF3Af0`],
        },
        {
          Q: `Aplicación del transportador de Kraft`,
          A: `Nota: Cuando utilice el transportador, debe instalar el elevador H3 para elevar el chasis de la máquina Kraft.`,
          video_url: [`https://youtu.be/HCWcF6x3X7Q`],
        },
        {
          Q: `Aplicación de rotatorios de Kraft`,
          A: `Notas:<br/>

        (1) Los dispositivos rotatorios compatibles con reconocimiento automático son los modelos R6, R8 y R8 Pro.<br/>

        Para utilizarlos, necesita instalar el elevador H3 para elevar el chasis.<br/>

        (2) Inserte el cable de reconocimiento automático del dispositivo rotatorio (conector USB en ambos extremos, ver Figura 10) en el puerto de accesorios del grabador Kraft (puerto marcado como número 12 en el panel).<br/>

        El dispositivo rotatorio será reconocido automáticamente y no requiere ajuste de paso.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10.png?v=1767689118:Figura 10]<br/>

        (3) Al usar el software AtomStack Studio, el rodillo rotatorio (R6) no requiere configuración de parámetros,<br/>

        el chuck (R8) requiere establecer la circunferencia o el diámetro del material, como se muestra en la Figura 11:<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11.png?v=1767689118:Figura 11]<br/>

        (4) Al usar LightBurn, configure el rotatorio de la siguiente manera:<br/>

        Tipo de rotación: Seleccione "Rodillo" para R6, "Chuck" para R8<br/>

        Eje de rotación: Elija el eje Y<br/>

        Configuración de parámetros:<br/>

        Para R8:<br/>

        Fije mm por rotación en 160 (valor fijo)<br/>

        Ingrese el diámetro o la circunferencia del material<br/>

        Para R6:<br/>

        Fije mm por rotación en 50 (valor fijo)<br/>

        Fije el diámetro del rodillo en 16 mm (valor fijo)<br/>

        Ingrese el diámetro o la circunferencia del material<br/>

        Consulte la Figura 12 para detalles.<br/>

        [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12.png?v=1767689118:Figura 12]`,
          video_url: [`https://youtu.be/kKcwHmaSVI8`],
        },
        {
          Q: `Aplicación de aire asistido de Kraft (con función de supresión de incendios)`,
          A: `Nota: Cuando utilice el sistema de aire asistido incluido, asegúrese de conectar a los puertos correctos — distinga entre el puerto de energía de la bomba de aire y el puerto de energía de extinción de incendios (consulte la sección \`Introducción a las funciones del panel\`).<br/>

    Antes de usar la función de supresión de incendios, asegúrese de que el depósito de agua del sistema de aire asistido esté lleno.`,
          video_url: [`https://youtu.be/LXLHSATvD0w`],
        },
        {
          Q: `Introducción al sistema de coordenadas del software`,
          A: `Posición actual:<br/>

      Usa la ubicación actual del cabezal láser como punto de partida para el grabado.<br/>

      Puede mover manualmente el cabezal láser a cualquier posición deseada antes de comenzar.<br/>

      Origen de usuario:<br/>

      El punto de inicio se establece manualmente por el usuario como el origen de trabajo del láser.<br/>

      Consulte el video sobre configuración del origen para las instrucciones.<br/>

      Coordenadas absolutas:<br/>

      Utiliza la coordenada (0, 0) de la máquina como punto fijo de inicio.`,
          video_url: [],
        },
        {
          Q: `Tutorial: Prueba de parámetros de grabado en el software`,
          A: `Nota: Esta función solo está disponible con la versión con licencia de LightBurn (versión 1.3.01 o superior) o AtomStack Studio.`,
          video_url: [`https://youtu.be/sUPmUo3cLwE`],
        },
      ],
      [
        {
          Q: `Limpieza y mantenimiento del chasis de la máquina Kraft`,
          A: `Método de limpieza:<br/>

    Utilice etanol anhidro puro al 99% como agente de limpieza y limpie suavemente con un paño sin pelusa.<br/>

    Evite frotar hacia adelante y hacia atrás para evitar rayaduras.<br/>

    Al limpiar el ventilador de extracción, debe desmontarlo con cuidado; no use fuerza.<br/>

    Consulte el video de Limpieza y Mantenimiento de la caja de la máquina Kraft para el procedimiento de extracción de tornillos.<br/>

    Método de mantenimiento:<br/>

    Después de limpiar los ejes lineales de los ejes X e Y, aplique grasa uniformemente sobre ellos.<br/>

    (Con respecto a la selección de la grasa, se recomienda usar aceite blanco grado 2/3. Para ambientes debajo de 15°C, use grasa grado 2; para ambientes superiores a 15°C, use grasa grado 3.)<br/>

    Frecuencia de limpieza:<br/>

    Para usuarios con uso frecuente, se recomienda limpiar una vez por semana.<br/>

    Para usuarios con menos uso, se recomienda limpiar una vez al mes.`,
          video_url: [`https://youtu.be/qOaaI53eYK4`],
        },
        {
          Q: `Limpieza del láser Kraft`,
          A: `Notas:<br/>

    (1)Método de limpieza de la campana guía de aire:<br/>

    Antes de limpiar el vidrio protector, primero retire los pequeños tornillos en la campana guía de aire usando un destornillador hexagonal L1.5 (ver Figura 13), luego retire la campana.<br/>

    Use etanol anhidro puro al 99% y un paño sin pelusa o algodón óptico sin pelusa para limpiarlo.<br/>

    Herramientas recomendadas:<br/>

    Paño sin pelusa o algodón óptico sin pelusa.<br/>

    Revisión después de la limpieza:<br/>

    Asegúrese de que los orificios de la campana guía de aire no estén obstruidos ni tengan manchas.<br/>

    Frecuencia de limpieza:<br/>

    Para usuarios de alta frecuencia, limpiar diariamente. Para usuarios de baja frecuencia, limpiar una vez por semana.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_13.png?v=1767691220:Figura 13]<br/>

    (2)Vidrio protector<br/>

    Método de limpieza:<br/>

    Use etanol anhidro puro al 99% o un limpiador profesional de lentes ópticas (evite solventes que contengan amoníaco o acetona).<br/>

    Al limpiar, use un paño sin pelusa y limpie suavemente en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) para evitar rayaduras por frotamiento hacia adelante y atrás.<br/>

    Herramientas recomendadas:<br/>

    Use paño sin pelusa o hisopos de algodón óptico sin pelusa (evite los hisopos de algodón normales que sueltan fibras).<br/>

    Revisión después de la limpieza:<br/>

    Inspeccione la superficie del vidrio con una luz intensa desde un lado para asegurarse de que no queden marcas de agua ni fibras.<br/>

    Frecuencia de limpieza:<br/>

    Se recomienda para usuarios de alta frecuencia limpiar diariamente y para usuarios de baja frecuencia semanalmente.<br/>

    Precauciones:<br/>

    La lente no debe ser desmontada. No intente abrirla ni desmontarla usted mismo, ya que esto dañará la estructura sellada del láser.<br/>

    Un vidrio protector sucio puede causar daños en el enfoque láser sobre la superficie de la lente, lo que también puede llevar a daños en la propia lente.<br/>

    (3)Ventilador del módulo láser<br/>

    Método de limpieza:<br/>

    Antes de limpiar, abra la tapa del ventilador láser y retire el ventilador.<br/>

    Use etanol anhidro puro al 99% y un paño sin pelusa para limpiar suavemente la suciedad o los residuos sobre el ventilador.<br/>

    Herramientas recomendadas:<br/>

    Use paño sin pelusa o hisopos de algodón óptico sin pelusa (evite los hisopos de algodón normales que sueltan fibras).<br/>

    Frecuencia de limpieza:<br/>

    Para usuarios de alta frecuencia: limpiar una vez a la semana.<br/>

    Para usuarios de baja frecuencia: limpiar una vez al mes.<br/>

    Precauciones:<br/>

    No desmonte la placa controladora.<br/>

    No use líquidos corrosivos para la limpieza.`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `Limpieza del sistema de aire asistido Kraft`,
          A: `Notas:<br/>

    Motivo de la limpieza:<br/>

    El aire asistido es un accesorio esencial para el corte. Si el polvo obstruye la entrada de aire de la bomba, puede causar sobrecalentamiento anormal, lo que puede dañar la bomba.<br/>

    Método de limpieza:<br/>

    Use etanol anhidro puro al 99% como agente de limpieza. Limpie suavemente los orificios de ventilación de la bomba de aire con un paño sin pelusa.<br/>

    Frecuencia de limpieza:<br/>

    Para usuarios de alta frecuencia: limpiar una vez a la semana.<br/>

    Para usuarios de baja frecuencia: limpiar una vez al mes.<br/>

    Precauciones:<br/>

    Como el sistema de aire asistido Kraft también incluye una función automática de supresión de incendios, asegúrese de limpiar el tanque de agua durante el mantenimiento.`,
          video_url: [`https://youtu.be/UuUYoA9wr7M`],
        },
        {
          Q: `¿Cuál es la temperatura de funcionamiento recomendada para Kraft?`,
          A: `La temperatura de funcionamiento recomendada es de 0°C a 35°C.`,
          video_url: [],
        },
   
        {
          Q: `¿Qué debo tener en cuenta si la máquina Kraft no se va a utilizar durante un período prolongado?`,
          A: `Guarde la máquina en un ambiente seco y evite exponerla a la humedad durante largos períodos. También se recomienda encender la máquina periódicamente.`,
          video_url: [],
        },
        {
          Q: `El vidrio protector o la lente de enfoque del láser Kraft está sucia o dañada.`,
          A: `Solución:<br/>

    (1) Limpiar el vidrio protector:<br/>

    Método de limpieza: Use etanol anhidro puro al 99% para limpiar. Utilice un paño sin pelusa para limpiar suavemente y evitar rayones por fricción.<br/>

    Al limpiar el ventilador de extracción, es necesario desmontarlo. No lo desmonte de manera violenta.<br/>

    Para operaciones de extracción de tornillos, consulte el video de limpieza y mantenimiento de la carcasa Kraft.<br/>

    Frecuencia de limpieza: Se recomienda a los usuarios de alta frecuencia de uso limpiar una vez por semana, y a los de baja frecuencia una vez al mes.<br/>

    Video de referencia: Video de limpieza del láser Kraft.<br/>

    Nota: Si las manchas del vidrio protector no se pueden quitar o está dañado, debe reemplazarse a tiempo.<br/>

    (2) La lente de enfoque no se puede desmontar. Si la lente está sucia, límpiela siguiendo el método de limpieza del vidrio protector.<br/>

    Si está dañada, solo se puede reemplazar el láser.<br/>

    Está estrictamente prohibido intentar palanquear o desmontar la lente por su cuenta, de lo contrario se dañará la estructura de sellado del láser.<br/>

    Si está dañada y es necesario reemplazar el láser, proporcione al personal de atención al cliente una imagen clara del vidrio protector o lente de enfoque roto (dañado), el número de serie de la máquina (como se muestra en la Figura 14) y el código de grabado láser (como se muestra en la Figura 15) para que el personal pueda gestionarlo.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure14.png?v=1767691220:Figura 14]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_15.png?v=1767691219:Figura 15]`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `El rendimiento de corte del láser Kraft ha disminuido significativamente y la calidad del grabado es deficiente.`,
          A: `Solución:<br/>

    (1) Verifique la distancia focal: Si no ha reenfocado después de cambiar a materiales de diferente grosor, presione el botón de autoenfoque para enfocar automáticamente;<br/>

    o utilice la pieza de enfoque fijo incluida y ajuste el botón detrás del eje Z (ver figura) para establecer la distancia focal en 40 mm.<br/>

    (2) Confirme la duración de uso: Los módulos láser se degradan de forma natural con el uso prolongado.<br/>

    Intente aumentar la potencia o reducir la velocidad para compensar la pérdida.<br/>

    (3) Verifique los parámetros del software: Asegúrese de que los parámetros de grabado configurados en el software coincidan o estén cerca de los valores recomendados para el material según la tabla de parámetros.<br/>

    Cómo ver la tabla de parámetros de Kraft:<br/>

    ①Escanéela en la máquina de grabado.<br/>

    ②Consulte la web oficial [link:/pages/product-support].<br/>

    ③Solicítela al personal de atención al cliente.<br/>

    (4) Verifique el modo de láser seleccionado en Kraft: El láser infrarrojo de 1.2W no tiene capacidad de corte y no debe seleccionarse para tareas de corte.<br/>

    (5) Revise el valor máximo de S: Si utiliza el software LightBurn, tenga en cuenta que el valor máximo de S está fijo en 1000 y no puede modificarse (ver Figura 16).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16.png?v=1767691219:Figura 16]<br/>

    Compruebe el adaptador de corriente: Si el voltaje es anormal, utilice un multímetro en modo voltaje DC para medir que la salida esté entre 20V y 24V (ver Figura 17).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17.png?v=1767691220:Figura 17]<br/>

    (7) Verifique el voltaje en el conector del módulo láser:<br/>

    Desconecte el conector láser, luego ejecute un programa de corte a 100 % de potencia y 1 mm/min de velocidad.<br/>

    Use un multímetro (rango DC) para medir:<br/>

    Entre el Pin 2 (24V) y el Pin 3 (GND), el voltaje debe estar entre 20V y 25V.<br/>

    Entre el Pin 4 (GND) y el Pin 5 (PWM de luz azul), el voltaje debe estar entre 1V y 6V.<br/>

    Consulte el video de prueba de voltaje del conector láser Kraft.<br/>

    (8) Si todas las comprobaciones anteriores son normales, es probable que el módulo láser tenga un fallo de potencia y deba ser reemplazado.<br/>

    Por favor, proporcione al servicio técnico todo el proceso de diagnóstico, el número de serie de la máquina (ver Figura 18) y el código de grabado láser del módulo (ver Figura 19) para su asistencia.<br/>

    Si el voltaje medido es menor de 20V, el problema está en la placa base o el cable de conexión.<br/>

    En ese caso, envíe un video del diagnóstico y el número de serie de la máquina al servicio técnico.<br/>

    Consulte los videos de reemplazo del láser Kraft, tarjeta madre y cables kraft.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure18.png?v=1767691219:Figura 18]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19.png?v=1767691219:Figura 19]`,
          video_url: [
            `https://youtu.be/t5eae1vGkjE`,
            `https://youtu.be/leUQfQl34Lw`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/pzhm-CW99CQ`,
          ],
        },
        {
          Q: `El láser azul del módulo Kraft funciona normalmente, pero el láser infrarrojo no emite haz.`,
          A: `Solución:<br/>

    (1) Compruebe si el láser solo deja de emitir durante los primeros segundos:<br/>

    El láser infrarrojo requiere un tiempo de pre-calentamiento de 2 a 20 segundos.<br/>

    Asegúrese de haber cambiado al modo Infrarrojo o Doble láser y espere el calentamiento.<br/>

    (2) Verifique el material de grabado:<br/>

    El láser infrarrojo se usa principalmente para grabar metales y cuero.<br/>

    No funciona sobre madera ni materiales similares.<br/>

    (3) Revise la distancia focal:<br/>

    El enfoque del láser infrarrojo es muy sensible. Si no ha reenfocado tras cambiar de material, hágalo ahora.<br/>

    Utilice el autoenfoque y confirme que la distancia sea 40 mm.<br/>

    (4) Verificación de la distancia focal:<br/>

    Si la distancia focal es 40 mm pero sigue sin verse láser, pruebe lo siguiente:<br/>

    Coloque la potencia al 20 %, pulse “Fire” y ajuste lentamente la perilla del eje Z o suba/baje el material hasta ver si la superficie quema o hace chispa.<br/>

    Si ve chispas o quemaduras en una altura determinada, esa es su distancia focal efectiva.<br/>

    Siga usando el láser en esa altura y comunique el problema al servicio técnico junto con:<br/>

    Sus resultados de diagnóstico, la nueva distancia focal y el número de serie de su máquina (ver Figura 18).<br/>

    Consulte el video de verificación de enfoque del láser infrarrojo Kraft.<br/>

    (5) Si todos los pasos anteriores son normales, el módulo láser puede estar defectuoso.<br/>

    Proporcione al servicio técnico:<br/>

    Un video del diagnóstico, el número de serie de la máquina (ver Figura 20), el código grabado en el módulo láser (ver Figura 21).<br/>

    Ellos le ayudarán con los siguientes pasos.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20.png?v=1767691220:Figura 20]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21.png?v=1767691219:Figura 21]`,
          video_url: [`https://youtu.be/6GDNnk7yFV8`],
        },
        {
          Q: `Durante el autoenfoque, el cabezal láser Kraft toca directamente la superficie del material y no puede completar el proceso de enfoque.`,
          A: `Solución:<br/>

    Compruebe si la placa madre funciona correctamente:<br/>

    En el software, haga clic en los botones de control del eje Z (ver AtomStack Studio en la Figura 22 o LightBurn en la Figura 23) y observe si el eje Z sube y baja según lo ordenado.<br/>

    Si el eje Z se mueve normalmente en ambas direcciones, el control de la placa base funciona correctamente.<br/>

    Si solo se mueve en una dirección, verifique la conexión del cable del eje Z:<br/>

    Asegúrese de que el cable esté correctamente insertado.<br/>

    Inspeccione el conector para daños, pines doblados o rotos.<br/>

    Si el cable y el conector no presentan problemas, probablemente la placa base o el cable de conexión estén defectuosos.<br/>

    En ese caso, será necesario reemplazar la placa madre o el cable.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22.png?v=1767691218:Figura 22]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23.png?v=1767691219:Figura 23]<br/>

    (2) Verifique problemas con el interruptor de límite inferior:<br/>

    Mientras el láser esté en modo de espera, presione manualmente el bloque disparador y observe si el software muestra una advertencia de \`interruptor de límite activado\`:<br/>

    ● Si aparece la advertencia, el problema puede estar en el firmware de la placa base. Intente volver a instalar el firmware.<br/>

    Si esto no resuelve el problema, puede requerir reemplazo de placa madre.<br/>

    Consulte el video de prueba manual del interruptor de límite Kraft y el video de reinstalación de firmware de la placa Kraft.<br/>

    ● Si el bloque disparador no se puede presionar (atascado), puede estar atascado o desalineado.<br/>

    Ajústelo según el video de ajuste del bloque disparador del límite inferior Kraft.<br/>

    ● Si no aparece ninguna advertencia tras presionar el bloque, revise el interruptor de límite inferior en la placa:<br/>

    Apague la máquina y desconecte el cable del láser. Retire el módulo láser desatornillando los dos tornillos del bloque disparador.<br/>

    Revise si el pin del interruptor inferior en la placa está dañado.<br/>

    Si está dañado, hay que reemplazar el módulo láser.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26.png?v=1767691220:Figura 26]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27.png?v=1767691219:Figura 27]<br/>

    (3) Compruebe el estado de funcionamiento del motor:<br/>

    Si el motor funciona de manera anómala durante el autoenfoque—movimiento errático, ruidos inusuales o vibraciones sin desplazamiento—esto sugiere que el controlador del motor en la placa base o el cable de conexión están defectuosos.<br/>

    En este caso, será necesario reemplazar la placa madre y el cable.<br/>

    Consulte los siguientes videos: Reemplazo de placa base Kraft y reemplazo de cables Kraft.`,
          video_url: [
            `https://youtu.be/9pjnFzSlFsA`,
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/CCYbB1pKtY0`,
          ],
        },
   
        {
          Q: `Fallo del autoenfoque Kraft`,
          A: `Solución:<br/>

    (1) Verifique si el botón de autoenfoque está defectuoso:<br/>

    Si al presionar el botón de autoenfoque en el cuerpo de la máquina de grabado no hay respuesta y el software no muestra mensajes de error, intente activar el autoenfoque desde el software:<br/>

    En AtomStack Studio, haga clic en el botón de autoenfoque (ver Figura 24). O en la consola de LightBurn, ingrese el comando [ESP500] para ver si la máquina ejecuta el autoenfoque (ver Figura 25).<br/>

    Si la máquina puede realizar el autoenfoque por software pero no con el botón físico, el botón de autoenfoque está defectuoso y debe ser reemplazado.<br/>

    Consulte el video de reemplazo del botón de autoenfoque Kraft.<br/>

    Si tampoco se puede realizar el autoenfoque desde el software y el eje Z no se mueve en absoluto:<br/>

    Revise la conexión del cable del motor del eje Z para comprobar que esté correctamente insertado y sin pines doblados o rotos.<br/>

    Gire manualmente la perilla de ajuste detrás del eje Z para confirmar si puede moverse hacia arriba y hacia abajo de manera suave.<br/>

    Si no se detectan problemas en el cable o el movimiento, el problema puede estar en la placa base o su cable de conexión.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24.png?v=1767691219:Figura 24]<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25.png?v=1767691219:Figura 25]<br/>

    (2) Verifique si los interruptores de límite superior e inferior están defectuosos:<br/>

    Si la máquina ejecuta el comando de autoenfoque pero solo se mueve hacia arriba o hacia abajo hasta llegar a un tope mecánico y no puede retroceder, puede deberse a una falla de un interruptor de límite.<br/>

    Para probar esto:<br/>

    Retire el módulo láser y luego gire la perilla de ajuste manual hacia abajo para exponer el interruptor de límite superior (ver Figura 26).<br/>

    Presione manualmente los interruptores de límite superior e inferior (ver Figura 27) para ver si ambos pueden ser activados.<br/>

    Si el interruptor de límite superior no puede ser activado:<br/>

    Consulte el video de reemplazo del interruptor de límite Kraft y revise si el cable de conexión está correctamente insertado.<br/>

    Desconecte y vuelva a conectar el cable. Si aun así no se activa, el interruptor probablemente está defectuoso y debe ser reemplazado.<br/>

    Si el interruptor de límite inferior no se puede activar:<br/>

    Consulte la solución titulada \`Durante el autoenfoque, el cabezal láser Kraft toca el material y no puede completar el autoenfoque\`.<br/>

    Para más orientación sobre la comprobación de los interruptores, vea el video de reinstalación de firmware de la placa Kraft y el video de prueba manual del interruptor de límite Kraft.`,
          video_url: [
            `https://youtu.be/NN0raPITQss`,
            `https://youtu.be/CCYbB1pKtY0`,
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
          ],
        },
        {
          Q: `Kraft se detiene repentinamente en medio del grabado`,
          A: `Solución:<br/>

    (1) Cuando el software muestra un aviso:<br/>

    Aviso: Desconectado<br/>

    ◆ Si el software muestra un mensaje de “desconectado”:<br/>

    Verifique si el cable TYPE-C fue tocado accidentalmente o está flojo.<br/>

    Mida la salida del adaptador de corriente para asegurar que esté entre 23V y 24V.<br/>

    Pruebe usando otro puerto USB en la computadora.<br/>

    Intente cambiar al software AtomStack Studio.<br/>

    ◆ Aviso: Alarma 1<br/>

    “Alarma 1” significa que se activó un interruptor de límite.<br/>

    Verifique si el tamaño del archivo excede el área de trabajo de la máquina.<br/>

    Use la función de enmarcar para ver si el movimiento es normal.<br/>

    Si el enmarcado es correcto pero el grabado activa la alarma, mueva el archivo al centro o reduzca su tamaño.<br/>

    Nota: El centro de la cruz es el punto de disparo del láser, puede que no llegue al límite al enmarcar, pero durante el grabado el borde del módulo láser podría acercarse demasiado y activar el interruptor.<br/>

    Si el archivo es pequeño, está centrado y se inicia desde coordenadas absolutas, pero aún así se activa la alarma, es probable que haya una falla en el interruptor de límite.<br/>

    Consulte el video de prueba manual de los interruptores de límite Kraft.<br/>

    (2) Cuando el software no muestra ningún aviso:<br/>

    Desconecte y vuelva a conectar el cable TYPE-C, o pruebe con otro cable TYPE-C.<br/>

    Cambie entre AtomStack Studio y LightBurn.<br/>

    Pruebe con otro puerto USB de la computadora.<br/>

    Si el problema persiste, reinstale el firmware. (Nota: no se puede reinstalar la misma versión del firmware—use una versión diferente. Comuníquese con el soporte si es necesario.)<br/>

    Si el problema continúa aun después de reinstalar el firmware, es probable que la placa base esté defectuosa y deba ser reemplazada.<br/>

    Consulte el video de reinstalación de firmware de la placa Kraft y el video de reemplazo de la placa Kraft para referencia.`,
          video_url: [
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/CCYbB1pKtY0`,
          ],
        },
        {
          Q: `Kraft no puede conectarse al software`,
          A: `Solución:<br/>

    (1) Verifique que el puerto serie no esté ocupado:<br/>

    Asegúrese de que ningún otro software de grabado esté conectado actualmente al equipo Kraft.<br/>

    (2) Confirme que la velocidad de transmisión esté configurada en 460800:<br/>

    Se recomienda usar AtomStack Studio o LightBurn.<br/>

    Con AtomStack Studio, no se necesita configuración adicional: la conexión debería ser automática.<br/>

    Con LightBurn, puede importar el archivo de configuración incluido en la memoria USB (ver Figura 28).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28.png?v=1767691218:Figura 28]<br/>

    (3) Confirme que el puerto COM seleccionado sea el correcto:<br/>

    Abra el Administrador de Dispositivos y verifique qué puerto COM corresponde a CH340 (ver Figura 29).<br/>

    Si CH340 no aparece o no es reconocido, instale el controlador USB a serie (CH340).<br/>

    Pruebe otro cable TYPE-C, cambie de puerto USB o utilice otra computadora.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29.png?v=1767691220:Figura 29]<br/>

    (4) Confirme si está utilizando una computadora macOS:<br/>

    Si usa un sistema operativo Mac, tenga en cuenta que no puede conectar directamente el extremo C del cable TYPE-C al Mac.<br/>

    Debe utilizar un hub USB o estación de acoplamiento para convertir la conexión a un puerto USB-A (ver Figura 30).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30.png?v=1767691220:Figura 30]<br/>

    (5) Si los pasos anteriores no resuelven el problema, intente reinstalar el firmware.<br/>

    Nota: No se puede reinstalar la misma versión del firmware, debe usar una versión diferente.<br/>

    Puede solicitar el firmware adecuado al soporte.<br/>

    Si el problema persiste después de reinstalar, probablemente se deba a una placa base defectuosa, la cual deberá ser reemplazada.<br/>

    Consulte el video de reinstalación de firmware de la placa Kraft y el video de reemplazo de placa para referencia.`,
          video_url: [`https://youtu.be/757s6JzbKsY`, `https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `No hay respuesta después de encender Kraft.`,
          A: `Solución：<br/>

    (1) Verifique que la salida del adaptador sea normal: use un multímetro en modo DC para medir la salida del adaptador.<br/>

    Debe haber un voltaje de 20V a 24V, como se muestra en la Figura 31.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31.png?v=1767691220:Figura 31]<br/>

    (2) Compruebe si el interruptor de encendido está defectuoso:<br/>

    Primero, observe visualmente si la luz indicadora del interruptor de encendido está encendida.<br/>

    Si está encendida, el dispositivo está recibiendo corriente normalmente.<br/>

    Si la luz está apagada, verifique los puertos de conexión de accesorios en la placa base para ver si hay indicadores encendidos.<br/>

    Si los indicadores de la placa base están encendidos, el interruptor de encendido funciona normalmente.<br/>

    Si no hay luces encendidas, el problema podría estar en el interruptor de encendido o la placa base.<br/>

    Consulte las posiciones 4 y 12 en la visión general de funciones del panel Kraft para más detalles.<br/>

    (3) Si tras realizar los pasos anteriores no se detectan problemas, probablemente la placa base esté defectuosa y deba ser reemplazada.<br/>

    Consulte el video de reemplazo de la placa Kraft para referencia.`,
          video_url: [`https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `Kraft presenta fallas y persiste el error de interruptor de límite activado`,
          A: `Solución：<br/>

  Confirme el tamaño del archivo: el rango de trabajo de Kraft es 500mm*320mm. Si el tamaño del archivo excede este rango, aparecerá el mensaje de que se ha superado el recorrido.<br/>

  Confirme las coordenadas usadas: si utiliza la posición actual, puede que el rango restante no sea suficiente para grabar.<br/>

  Se recomienda patrullar el borde primero, confirmar el rango y luego grabar o configurar en \`Absolute Coords\`.<br/>

  Confirme el interruptor de límite: ◆ Verifique que ningún interruptor de límite esté siendo activado por otros objetos.<br/>

  Si es así, mueva el objeto que lo activa. ◆ Use los avisos de software para localizar y resolver el problema.<br/>

  El software AtomStack Studio lo avisará directamente. Si utiliza LightBurn, puede introducir \`?\` después del mensaje de alarma en la consola para obtener un aviso (ver Figura 32).<br/>

  Luego siga los consejos para resolver el problema. Si puede ser activado manualmente, puede desconectar el interruptor de límite para comprobar si el mensaje sigue apareciendo.<br/>

  Confirme la falla y reemplácelo. Consulte el video de reemplazo del interruptor de límite Kraft.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32.png?v=1767691219:Figura 32]<br/>

  Si se indica un error en el interruptor de límite del eje Z:<br/>

  Empiece por revisar el interruptor de límite superior. Intente desconectar el conector del interruptor de límite superior para descartar fallas.<br/>

  Si el problema está en el interruptor de límite inferior del módulo láser, presione suavemente el bloque disparador con la mano para comprobar que se mueva libremente.<br/>

  Si el bloque disparador está atascado, consulte el video de ajuste del bloque disparador de límite inferior del módulo láser Kraft.<br/>

  Si el bloque se mueve normalmente, probablemente deba reemplazar el módulo láser.<br/>

  Proporcione lo siguiente al soporte técnico para asistencia:<br/>

  Un video claro de la prueba de falla, el número de serie de la máquina (ver Figura 33) y el código grabado del módulo láser (ver Figura 34)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33.png?v=1767691220:Figura 33]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34.png?v=1767691219:Figura 34]`,
          video_url: [`https://youtu.be/9DMaOiOa2zU`, `https://youtu.be/9pjnFzSlFsA`],
        },
   
        {
          Q: `Kraft produce resultados de grabado distorsionados.`,
          A: `Solución:<br/>

  (1) Verifique si la configuración de velocidad es demasiado alta:<br/>

  Establezca parámetros apropiados según la tabla de parámetros de referencia. Cómo ver la tabla de parámetros de Kraft: ① Ingrese para verla escaneando el código QR en la máquina de grabado.<br/>

  ② Ingrese al sitio web oficial para verla [link:/pages/product-support].<br/>

  ③ Solicítela al personal de atención al cliente.<br/>

  (2) Inspeccione los ejes dobles X y Y para verificar suciedad o daños:<br/>

  Examine cuidadosamente los rieles de guía y los ejes dobles para asegurarse de que no haya suciedad, daño u otras anomalías.<br/>

  (3) Identifique cuál eje está fallando:<br/>

  En el software, cree un archivo de prueba con un círculo y un cuadrado en el contorno.<br/>

  Por ejemplo, use un modo de corte con una velocidad de 10,000 mm/min y 30% de potencia para trazar las líneas sobre madera contrachapada.<br/>

  Observe si el problema es causado por un movimiento anómalo en un eje o en ambos.<br/>

  Consulte el Video de Ajuste Mecánico de Kraft para centrarse en ajustar las partes relevantes.<br/>

  Importante: Después de cada ajuste, realice una prueba para determinar si el problema mejora. Si mejora, continúe ajustando finamente.<br/>

  Si no, siga ajustando otras posiciones.<br/>

  (4) Verifique si el eje X está paralelo a la viga transversal inferior:<br/>

  Si las líneas grabadas están inclinadas pero no son onduladas o curvas, probablemente el eje X no esté paralelo a la viga inferior.<br/>

  Ajuste el eje X para asegurarse de que esté paralelo. Consulte el video de ajuste mecánico de Kraft para recibir orientación.<br/>

  (5) Verifique si la configuración de los pasos ha sido alterada:<br/>

  En LightBurn o LaserGRBL, abra la configuración de la máquina y revise si los valores de $100 y $101 están en 100 (ver Figura 35).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35.png?v=1767694662:Figura 35]<br/>

  (6) Confirme que no hay anormalidades en el firmware: intente volver a grabar el firmware (Nota: no es posible volver a grabar la misma versión de firmware. Por favor, proporcione la versión actual de su firmware al soporte para solicitar la versión adecuada). Consulte el video de grabación de firmware de la placa Kraft.<br/>

  (7) Si después de todos estos pasos el problema persiste y los ajustes estructurales no surten efecto, probablemente la placa base esté defectuosa y deba ser reemplazada.<br/>

  Consulte el video de reemplazo de la placa base de Kraft para instrucciones detalladas.`,
          video_url: [
            `https://youtu.be/KY3dAcAqYVU`,
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
          ],
        },
        {
          Q: `Kraft no reconoce la cámara.`,
          A: `Solución:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36.png?v=1767694662:Figura 36]<br/>

  (1) Verifique si la cámara está deshabilitada:<br/>

  Abra el Administrador de dispositivos para ver si la cámara está restringida o deshabilitada.<br/>

  Si es así, elimine la restricción y otorgue los permisos necesarios.<br/>

  (2) Verifique si el puerto USB de su computadora está dañado:<br/>

  Pruebe con otro puerto USB en la computadora y use la cámara o aplicación de video integrada para verificar si se muestra la imagen.<br/>

  (3) Verifique si el cable de la cámara en la placa principal está suelto:<br/>

  Si la cámara no captura imagen, inspeccione el cable de conexión de la cámara (ver Figura 37).<br/>

  Use pinzas u otra herramienta para desconectar y volver a conectar cuidadosamente el cable, luego pruebe la cámara nuevamente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37.png?v=1767694663:Figura 37]<br/>

  (4) Si ninguno de los pasos anteriores soluciona el problema, probablemente la cámara esté defectuosa y deba ser reemplazada.<br/>

  Consulte el video de reemplazo de la cámara Kraft para recibir instrucciones.`,
          video_url: [`https://youtu.be/5UgyzdwLDXI`],
        },
        {
          Q: `La posición de la cámara en Kraft es inexacta, con una desviación significativa.`,
          A: `Solución:<br/>

  (1) Verifique si la configuración de coordenadas es la correcta:<br/>

  Para que el posicionamiento con cámara funcione adecuadamente, "Start From" debe estar en Coordenadas Absolutas, no en Posición Actual ni en Usuario Origen.<br/>

  (2) Asegúrese de que la cámara esté calibrada:<br/>

  Después de cambiar a materiales de diferente grosor, se requiere recalibración.<br/>

  Si hay demasiado error durante la calibración, vuelva a realizar la calibración del modelo de la máquina.<br/>

  (3) Verifique si la iluminación interna es suficiente:<br/>

  La iluminación insuficiente dentro del gabinete de Kraft puede causar errores considerables en el algoritmo de la cámara. Mejore la luminosidad interna y pruebe nuevamente.<br/>

  (4) Evite usar los bordes de la vista de la cámara:<br/>

  Se recomienda hacer el grabado cerca del centro del área de trabajo.<br/>

  Cuanto más cerca de los bordes, mayor será el posible error en la posición.`,
          video_url: [],
        },
        {
          Q: `La cámara de Kraft funciona normalmente en AtomStack Studio, pero no puede calibrarse al usar LightBurn.`,
          A: `Solución:<br/>

  (1) Verifique las condiciones de luz del entorno de trabajo:<br/>

  AtomStack Studio requiere condiciones de iluminación relativamente bajas al usar la cámara.<br/>

  Sin embargo, LightBurn requiere condiciones de iluminación significativamente mejores para lograr una calibración exitosa.<br/>

  Si la calibración falla, intente usar luz externa como apoyo.<br/>

  (2) Asegúrese de que el software tenga los permisos necesarios:<br/>

  Si la calibración sigue fallando, incluso con iluminación adicional, puede deberse a permisos del sistema insuficientes otorgados a LightBurn o a un problema con el software LightBurn en sí.<br/>

  En tales casos, se recomienda usar AtomStack Studio para operaciones con la cámara.`,
          video_url: [],
        },
        {
          Q: `El movimiento de Kraft es anormal.`,
          A: `Solución:<br/>

  Confirme que se hayan retirado los bloqueos de fábrica: Para proteger la estructura del eje X durante el transporte, se instala un módulo de fijación cuando sale de fábrica.<br/>

  Tras recibir el producto, desenrosque los tornillos del módulo de fijación y retire los módulos de ambos extremos del eje X, como se muestra en la Figura 38.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38.png?v=1767694663:Figura 38]<br/>

  (2) Verifique si el movimiento inverso está activado:<br/>

  Si el movimiento anormal es consistente o sigue un patrón—como el desplazamiento invertido—puede indicar que se modificaron los parámetros de la placa Kraft. Puede comprobarlo yendo a la configuración de la máquina en LightBurn o LaserGRBL (ver Figura 39), o restaurar los valores de fábrica en el software, o volver a grabar el firmware.<br/>

  Tenga en cuenta que no se puede volver a grabar el mismo firmware. Puede contactar al servicio de atención para solicitar el video de grabación de firmware de la placa Kraft.<br/>

  El método para restaurar los valores de fábrica es el siguiente:<br/>

  ◆ Restaurar la configuración de fábrica en AtomStack Studio: Para la versión 2.20 o posterior, toque el número de versión (por ejemplo, V.2.20) siete veces consecutivas para ingresar a Modo Desarrollador (ver Figura 40). En el menú, abra Registro del Puerto Serie, luego haga clic en Reset para restaurar los valores (ver Figura 41).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39.png?v=1767694662:Figura 39]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40.png?v=1767694661:Figura 40]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41.png?v=1767694661:Figura 41]<br/>

  ◆ En LightBurn: introduzca el comando $RST=* en la caja de comando para restablecer los valores de fábrica (ver Figura 42).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42.png?v=1767694661:Figura 42]<br/>

  (2) Verifique si hay componentes dañados o deformados:<br/>

  Inspeccione las correas de distribución, los rieles guía de doble eje y los acoplamientos para detectar aflojamiento, rotura, daño o deformación.<br/>

  También verifique que los cables del motor estén conectados firmemente y que no haya pines doblados o rotos.<br/>

  (3) Si ninguna de las soluciones anteriores resuelve el problema, intente reemplazar la placa base, los cables de conexión y los motores.<br/>

  Consulte los siguientes videos para orientación:<br/>

  Reemplazo de la placa base Kraft<br/>

  Reemplazo del motor Kraft<br/>

  Reemplazo de los cables de la placa base Kraft`,
          video_url: [
            `https://youtu.be/757s6JzbKsY`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/eR-zxrJz7Kk`,
          ],
        },
   
        {
          Q: `La máquina no responde al realizar tareas de grabado en Kraft.`,
          A: `Solución：<br/>

  (1) Confirme que todas las operaciones sean normales:<br/>
  Primero, verifique que la fuente de alimentación y todos los cables de conexión estén correctamente conectados, que la puerta de la carcasa esté cerrada y que no se hayan activado los interruptores de límite.<br/>

  (2) Revise si hay mensajes en el software:<br/>
  Observe si el software muestra algún mensaje de error. Si es así, siga las indicaciones para solucionar el problema.<br/>
  Si no aparece ningún mensaje, reinicie la fuente de alimentación de Kraft y el software, luego intente reconectar el dispositivo.<br/>

  (3) Verifique si otros softwares funcionan correctamente:<br/>
  Intente cambiar a AtomStack Studio o LightBurn para hacer pruebas.<br/>
  Si ninguno de los dos softwares funciona, intente cambiar el cable Type-C, usar otro puerto USB o actualizar el controlador USB.<br/>

  (4) Si el problema persiste después de todos los pasos anteriores, intente volver a grabar el firmware.<br/>
  (Nota: no se puede grabar el mismo firmware de manera repetida. Consulte el video de grabación de firmware de la placa madre Kraft. Por favor, proporcione la versión actual de su firmware al soporte técnico para obtener una versión compatible.)<br/>
  Si volver a grabar el firmware no soluciona el problema, es probable que la placa base esté defectuosa y deba ser reemplazada.<br/>

  Proporcione el número de serie de la máquina (ver Figura 43) al servicio de atención al cliente para obtener más ayuda.<br/>
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43.png?v=1767694662:Figura 43]`,
          video_url: [`https://youtu.be/757s6JzbKsY`],
        },
        {
          Q: `El módulo láser en Kraft se mueve correctamente, pero no emite rayo láser al grabar.`,
          A: `Solución：<br/>

  (1) Verifique si el cable láser está correctamente conectado:<br/>
  Asegúrese de que el cable del módulo láser esté bien conectado. Desenchúfelo y vuelva a conectarlo para confirmar una conexión estable.<br/>

  (2) Revise los parámetros de software:<br/>
  Verifique que los parámetros coincidan con la tabla recomendada para el material. Si usa LightBurn, confirme que el valor máximo S (S-value Max) no haya sido modificado. Asegúrese de que el valor S máximo esté en 1000 (ver Figura 44). Cómo consultar la tabla de parámetros de Kraft:<br/>
  ① Acceda escaneando el código QR de la máquina de grabado.<br/>
  ② Consulte en el sitio web oficial [link:/pages/product-support].<br/>
  ③ Solicítelo al personal de atención al cliente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44.png?v=1767694662:Figura 44]<br/>

  (3) Verifique si la distancia focal está ajustada a 40 mm.<br/>

  (4) Pruebe otro modo de láser para verificar su funcionamiento:<br/>
  Si actualmente está usando el modo infrarrojo, pruebe cambiando al láser azul o al modo dual para ver si el láser azul funciona correctamente.<br/>
  Si el láser azul funciona y el infrarrojo no, consulte la guía de solución de problemas para:<br/>
  “El láser azul funciona normalmente, el infrarrojo no emite luz.”<br/>
  Si ningún modo funciona, proceda a medir la salida de voltaje del cable láser:<br/>
  Desenchufe el cable láser.<br/>
  Ejecute una tarea de corte al 100% de potencia y a 10mm/min de velocidad.<br/>
  Utilice un multímetro (modo DC) para medir el voltaje:<br/>
  Entre el Pin 2 y el Pin 3, el valor normal debe ser de 20V a 24V.<br/>
  Entre el Pin 4 y el Pin 5, el valor normal debe ser de 1V a 6V. (Ver Figura 45.)<br/>
  Si los valores de voltaje son normales, el módulo láser está defectuoso y se debe reemplazar.<br/>
  Si el voltaje es 0V o inferior al rango normal, el problema está en la placa base o sus cables de conexión.<br/>

  Consulte los siguientes videos para instrucciones detalladas:<br/>
  Video de comprobación del voltaje del cable láser Kraft<br/>
  Video de reemplazo de placa base Kraft<br/>
  Video de reemplazo de cables de la placa base Kraft<br/>
  Video de reemplazo del módulo láser Kraft<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45.png?v=1767694663:Figura 45]`,
          video_url: [
            `https://youtu.be/t5eae1vGkjE`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/1Gd5fKsAlLA`,
            `https://youtu.be/leUQfQl34Lw`,
          ],
        },
        {
          Q: `Kraft produce líneas incompletas o rotas.`,
          A: `Solución：Verifique el enfoque del láser:<br/>

  Después de cambiar a materiales con diferente grosor, es necesario reenfocar el láser.<br/>
  Simplemente presione el botón de autoenfoque para completar el proceso.<br/>
  También puede medir manualmente la distancia desde el borde inferior del módulo láser (no la campana de asistencia de aire) hasta la superficie del material.<br/>
  Debe ser de 40 mm.<br/>

  Revise la configuración de potencia en el software:<br/>
  Si la potencia es demasiado baja, aumente la potencia o reduzca la velocidad.<br/>

  Asegúrese de que “Modo de Potencia Constante” esté activado:<br/>
  En AtomStack Studio (ver Figura 46) o LightBurn (ver Figura 47), asegúrese de que el modo de potencia constante esté activado.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46.png?v=1767694661:Figura 46]<br/>
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47.png?v=1767694662:Figura 47]<br/>

  Ajuste el valor mínimo de potencia ($31):<br/>
  Si activar el modo de potencia constante no resuelve el problema, vaya a la configuración de la máquina en LightBurn o LaserGRBL y aumente el valor $31 hasta que las líneas aparezcan completas (ver Figura 48).<br/>
  Nota: Si el modo de potencia constante resuelve el problema, no es necesario modificar $31.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48.png?v=1767694662:Figura 48]`,
          video_url: [],
        },
        {
          Q: `Las líneas grabadas por Kraft son demasiado anchas.`,
          A: `Solución：<br/>

  Verifique el enfoque del láser:<br/>
  Si el láser no se ha reenfocado después de cambiar a materiales de diferente grosor, el haz puede desenfocarse y causar líneas más anchas.<br/>
  Presione el botón de autoenfoque para reenfocar el láser.<br/>

  Revise el vidrio protector y la campana de asistencia de aire:<br/>
  Asegúrese de que el vidrio protector y la campana de asistencia de aire estén limpios y sin daño.<br/>
  Consulte el video de limpieza del láser Kraft para instrucciones de inspección y limpieza.<br/>

  Revise los parámetros de configuración:<br/>
  Si la potencia es demasiado alta, puede hacer que el haz del láser se ensanche.<br/>
  Compruebe que la configuración coincida con la tabla de parámetros del material recomendada. Cómo ver la tabla de parámetros de Kraft: ①Revísela escaneando el código QR en la máquina de grabado.<br/>
  ②Consulte el sitio web oficial [link:/pages/product-support].<br/>
  ③Solicítela al personal de atención al cliente.`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
   
        {
          Q: `Los bordes de corte producidos por Kraft aparecen amarillos y no logran cortar el material.`,
          A: `Solución：<br/>

  (1) Revise las condiciones de corte:<br/>

  Asegúrese de que la asistencia de aire esté habilitada durante el corte.<br/>

  Verifique que el voltaje de salida del adaptador de corriente esté dentro del rango normal (23V–24V).<br/>

  Asegúrese de que el grosor del material no exceda la capacidad de corte de la máquina.<br/>

  (2) Revise el enfoque del láser:<br/>

  Después de cambiar a un material de diferente grosor, reemplace el enfoque del láser presionando el botón de autoenfoque.<br/>

  Inspeccione el vidrio protector y la campana de asistencia de aire:<br/>

  Asegúrese de que el vidrio y la campana estén limpios y sin daños.<br/>

  Consulte el video de limpieza del láser Kraft para obtener instrucciones de inspección y limpieza.<br/>

  (3) Verifique los parámetros del software:<br/>

  Si la potencia es demasiado baja o la velocidad demasiado alta, el láser puede que no logre cortar el material.<br/>

  Intente aumentar la potencia o reducir la velocidad.<br/>

  Si usa LightBurn, asegúrese de que el valor máximo de S esté fijado en 1000 y que no se haya cambiado (ver Figura 49).<br/>

  Cómo ver la tabla de parámetros de Kraft:<br/>

  ① Ingrese a la tabla escaneando el código QR en la máquina de grabado.<br/>

  ② Ingrese al sitio web oficial para ver [link:/pages/product-support].<br/>

  ③ Solicítela al personal de servicio al cliente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49.png?v=1767694662:Figura 49]<br/>

  (4) Si no hay anomalías en lo anterior, se determina que el láser está defectuoso y debe ser reemplazado.<br/>

  Proporcione al personal de servicio al cliente el número de serie (como se muestra en la Figura 50), el video de la falla (incluyendo la configuración de parámetros) y el código de grabado láser (como se muestra en la Figura 51).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50.png?v=1767694662:Figura 50]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51.png?v=1767694661:Figura 51]`,
          video_url: [`https://youtu.be/H8cfU-eOHr8`],
        },
        {
          Q: `El láser no se detiene incluso cuando la puerta del gabinete Kraft está abierta.`,
          A: `Solución:<br/>

  (1) Verifique si la función de detección de apertura de la puerta está activada:<br/>

  Confirme en AtomStack Studio o en la aplicación AtomStack si esta función está deshabilitada. Si es así, actívela.<br/>

  Vea la Figura 52.<br/>

  (2) Verifique si el interruptor de límite de la puerta del gabinete está defectuoso:<br/>

  Presione y suelte manualmente el interruptor de límite de la puerta del gabinete para ver si el software muestra una advertencia de puerta abierta.<br/>

  Si no aparece ninguna advertencia, el interruptor de límite puede estar defectuoso y debe ser reemplazado.<br/>

  Consulte el video de reemplazo del interruptor de límite de Kraft.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52.png?v=1767694662:Figura 52]`,
          video_url: [`https://youtu.be/9DMaOiOa2zU`],
        },
        {
          Q: `La tira de luz LED del gabinete Kraft no enciende.`,
          A: `Solución：<br/>

  Mida el voltaje en el conector de la tira LED:<br/>

  Cuando la máquina está encendida normalmente, la tira de luz LED debería iluminarse.<br/>

  Si no lo hace, utilice un multímetro en modo DC para medir el voltaje en el conector de la tira LED.<br/>

  El rango normal de voltaje debe estar entre 20V y 24V. Vea la Figura 53.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53.png?v=1767694663:Figura 53]<br/>

  ① Si el voltaje está dentro del rango normal, la tira de LED está defectuosa y debe ser reemplazada.<br/>

  Consulte el video de reemplazo de la tira de LED Kraft.<br/>

  ② Si el voltaje medido es 0V, el cable de conexión de la tira LED está defectuoso.<br/>

  Consulte el video de reemplazo del cable de conexión LED.<br/>

  ③ Si el voltaje medido es inferior a 20V, el adaptador de corriente puede estar defectuoso.`,
          video_url: [`https://youtu.be/6rI-PbQVlLI`, `https://youtu.be/1Gd5fKsAlLA`],
        },
        {
          Q: `Kraft no pudo reiniciar.`,
          A: `Solución:<br/>

  Confirme que se han retirado los refuerzos de fábrica: Para proteger la estructura del eje X durante el transporte, se instala un módulo de fijación en la fábrica.<br/>

  Después de recibir el producto, desenrosque los tornillos del módulo de fijación y retire los módulos de fijación en ambos extremos del eje X, como se muestra en la Figura 54.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54.png?v=1767694663:Figura 54]<br/>

  Confirme que la longitud de paso es correcta: Use LightBurn o LaserGRBL para entrar a la configuración de la máquina y verificar si los valores de $100 y $101 son 100, como se muestra en la Figura 55:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_55.png?v=1767694662:Figura 55]<br/>

  (3) Confirme que el láser esté instalado correctamente: Si el interruptor de límite del eje Y se activa normalmente pero el láser golpea el marco, reinstale el láser.<br/>

  Consulte el video de reemplazo del láser Kraft.<br/>

  (4) Confirme que el eje X esté a nivel: Use una regla para medir la distancia desde ambos extremos del eje X (el eje donde se instala el láser) hasta el marco para ver si son consistentes, como se muestra en la Figura **.<br/>

  Si no es así, consulte el video de ajuste horizontal del eje X de Kraft.<br/>

  (5) Confirme la información indicada por el software: Si aparece un mensaje de que se ha alcanzado el recorrido máximo, se trata de un fallo en el interruptor de límite del eje X o Y.<br/>

  Presione manualmente el interruptor de límite (como se muestra en la Figura 56) para ver si se emite un sonido de \`beep\` y el software indica el mensaje.<br/>

  Si no aparece el mensaje, hay un fallo en el interruptor de límite; si aparece, es normal.<br/>

  Para el reemplazo, consulte el video de reemplazo del interruptor de límite Kraft.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_56.png?v=1767694663:Figura 56]<br/>

  (6) Confirme si los movimientos de los ejes X e Y son normales: Si solo un eje puede moverse normalmente durante el reinicio, puede conectar el cable del motor del eje Y al motor del eje X para ver si el eje operativo y el defectuoso se intercambian.<br/>

  Si sigue igual, se determina que es un fallo de motor.<br/>

  Si el problema se traslada, se determina que es un fallo del driver de la placa madre o del cable de conexión del motor.<br/>

  Consulte los videos de intercambio de cable del motor Kraft, reemplazo de motor, reemplazo de placa madre y reemplazo de cable de motor.<br/>

  (7) Confirme si hay un problema de firmware: Si lo anterior no resuelve el problema del cliente, intente actualizar el firmware.<br/>

  Puede actualizarlo a través de AtomStack Studio, AtomStack APP o una memoria USB.<br/>

  ◆Conéctese al cliente AtomStack Studio o a la aplicación móvil y haga clic directamente en Actualizar Firmware, como se muestra en la Figura 57. Note que necesitará insertar una memoria USB como almacenamiento para la actualización.<br/>

  ◆Copie el archivo al directorio raíz de una memoria USB e insértela en el puerto USB de la máquina para actualizar.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_57.png?v=1767694662:Figura 57]`,
          video_url: [
            `https://youtu.be/leUQfQl34Lw`,
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/KPIi_Vv9VNI`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/eR-zxrJz7Kk`,
            `https://youtu.be/xuaepbjWv5I`,
            `https://youtu.be/gGMmN-PHTk8`,
          ],
        },
        {
          Q: `Kraft no puede activar el interruptor de límite.`,
          A: `Solución:<br/>

  El interruptor de límite del eje X no puede ser activado: En modo de espera, presione manualmente los dos interruptores de límite en el eje X (ver Figura 58).<br/>

  ◆ Si se escucha un sonido de \`beep\` después de presionar y el software muestra una alarma de activación, entonces el interruptor está normal.<br/>

  Revise cuidadosamente si hay obstáculos bloqueando los extremos o si la varilla de activación está torcida, como se muestra en la Figura 59.<br/>

  ◆ Si después de presionar no hay sonido ni mensaje, puede tratarse de una falla en el interruptor de límite.<br/>

  Proporcione una foto del número de serie de la máquina (ver Figura 60) y un video del fallo al personal de servicio al cliente para su gestión.<br/>

  Para el reemplazo, consulte el video de reemplazo de interruptor de límite Kraft.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_58.png?v=1767694663:Figura 58]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_59.png?v=1767694663:Figura 59]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_60.png?v=1767694662:Figura 60]<br/>

  El interruptor de límite del eje Y no puede ser activado: En modo de espera, presione manualmente los dos interruptores de límite en la parte delantera y trasera del eje Y izquierdo (ver Figura 58).<br/>

  ◆ Si se escucha un sonido \`beep\` después de presionar y el software muestra una alarma, entonces el interruptor está normal.<br/>

  Revise cuidadosamente los siguientes puntos.<br/>

  ① El láser no está instalado correctamente: retire el láser y reinstálelo, asegurándose de que las dos ranuras en la parte inferior del láser estén alineadas con los dos postes de límite en el deslizador, como se muestra en la Figura 61.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_61.png?v=1767694663:Figura 61]<br/>

  ② El eje X no está nivelado: mida las distancias desde ambos extremos del eje X hasta el marco frontal para ver si son consistentes.<br/>

  Si no es así, consulte el video de ajuste horizontal del eje X de Kraft.<br/>

  ◆ Si al presionar no aparece mensaje ni suena, puede tratarse de un fallo en el interruptor de límite.<br/>

  Proporcione una foto del número de serie de la máquina y un video del fallo de activación al personal de servicio al cliente para su gestión.<br/>

  (3) El interruptor de límite del eje Z no puede ser activado: En modo de espera, presione manualmente el interruptor de límite superior del eje Z (como se muestra en la Figura **) y la palanca de activación debajo del láser (como se muestra en la Figura **).<br/>

  ◆ Si no aparece sonido de \`beep\` al presionar el interruptor superior y no hay alarma en el software, puede ser una falla en el interruptor de límite.<br/>

  Verifique cuidadosamente si el conector del interruptor está bien conectado.<br/>

  Si se confirma que no hay anormalidad en el cable, puede ser una falla del interruptor.<br/>

  Proporcione una foto del número de serie de la máquina y un video del fallo al personal de servicio al cliente para su gestión.<br/>

  ◆ Si no hay sonido de \`beep\` al presionar el interruptor inferior y no hay alarma en el software, desatornille la placa de detección de flama y verifique si el pin de activación del interruptor inferior en la tarjeta de control está roto.<br/>

  Si está roto, proporcione una foto clara y la foto del número de serie al servicio al cliente.<br/>

  Si no está roto, proporcione un video de la falla y la foto del número de serie al servicio al cliente.<br/>

  ◆ Si la palanca del interruptor de límite inferior no se mueve al presionarla, puede que la varilla activadora esté atascada.<br/>

  Consulte el video de ajuste de la varilla activadora del límite inferior del láser Kraft.<br/>

  (4) Si todos los interruptores de límite pueden ser activados manualmente y emiten mensaje, pero no controlan el movimiento del láser: esto puede estar causado por una anomalía de firmware en la placa madre.<br/>

  Proporcione un video del fallo y una foto del número de serie al personal de servicio al cliente para su gestión.`,
          video_url: [
            `https://youtu.be/9DMaOiOa2zU`,
            `https://youtu.be/9pjnFzSlFsA`,
            `https://youtu.be/gGMmN-PHTk8`,
          ],
        },
        {
          Q: `El sistema Kraft dispara repetidamente la alarma de detección de llama.`,
          A: `Solución:<br/>

  (1) Confirme si el material a grabar es inflamable:<br/>

  Compruebe si el material es inflamable, como MDF. Si es así, es más probable que haya falsas alarmas del sensor de flama.<br/>

  (2) Confirme si el archivo de grabado tiene líneas muy densas:<br/>

  Si los patrones de línea son muy densos, el detector de llama se activa más fácilmente.<br/>

  Se recomienda aumentar la velocidad de grabado y el número de pasadas.<br/>

  (3) Verifique si al grabar en otros materiales se activa la alarma:<br/>

  ① Si al cortar el mismo archivo en madera contrachapada no se dispara la alarma, puede deshabilitar la función de detección de llama en AtomStack Studio o en la App de AtomStack mientras graba este material, como se muestra en la Figura 62.<br/>

  (Nota: Cuando esta función está deshabilitada, la máquina debe ser supervisada en todo momento para evitar accidentes. Por favor, reactive esta función después de grabar.)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_62.png?v=1767694662:Figura 62]<br/>

  ② Si la alarma sigue activándose al trabajar madera contrachapada, ajuste la sensibilidad de detección de llama en LightBurn o LaserGRBL:<br/>

  El comando $fire_alarm/overflow_value=15 ajusta el número de activaciones para superar el umbral.<br/>

  El comando $fire_alarm/threshold_value=74 ajusta el valor umbral de detección de llama, como se muestra en la Figura 63; un valor más alto lo hace más difícil de disparar.<br/>

  Nota: Aunque estos consejos pueden reducir eficazmente las falsas alarmas, no reemplazan una operación cuidadosa.<br/>

  Siempre supervise de cerca la máquina durante su funcionamiento, ya que la seguridad debe ser su máxima prioridad.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_63.png?v=1767694662:Figura 63]`,
          video_url: [],
        },
        {
          Q: `La asistencia de aire de Kraft no funciona.`,
          A: `Solución:<br/>

  (1) Confirme que la asistencia de aire está encendida correctamente:<br/>

  Verifique si la perilla de control está activada; gírela en sentido horario para encenderla.<br/>

  (2) Verifique si la bomba de aire vibra:<br/>

  ① Si la bomba de aire no vibra, mida el voltaje en el puerto de salida de energía de la asistencia de aire Kraft (puerto 05 como se describe en la sección de funciones del panel).<br/>

  El voltaje debe estar entre 20V y 24V.<br/>

  Si la fuente de alimentación es normal, la placa del interruptor rotatorio está defectuosa y debe ser reemplazada.<br/>

  Consulte el video de reemplazo del interruptor rotatorio de la asistencia de aire Kraft.<br/>

  Si no hay voltaje, la placa madre está defectuosa. Consulte el video de reemplazo de la placa madre Kraft.<br/>

  ② Si la bomba de aire vibra pero no hay flujo de aire, la bomba de aire está defectuosa y debe ser reemplazada.<br/>

  Consulte el video de reemplazo de la bomba de aire y de agua Kraft.`,
          video_url: [
            `https://youtu.be/r6yvxL3uXfs`,
            `https://youtu.be/pzhm-CW99CQ`,
            `https://youtu.be/ugqh5NtUNyY`,
          ],
        },
        {
          Q: `El dispositivo activo de extinción de incendios del sistema Kraft no responde después de activar la alarma de llama.`,
          A: `Solución:<br/>

  (1) Verifique si el tanque de agua de extinción está lleno:<br/>

  Inspeccione el nivel de agua a través de la ventanilla del depósito de la bomba.<br/>

  (2) Confirme que la función de supresión activa de incendios esté habilitada:<br/>

  Verifique esto en el software AtomStack Studio o en la App AtomStack, como se muestra en la Figura 64.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_64.png?v=1767694662:Figura 64]<br/>

  (3) Confirme que el dispositivo de extinción esté recibiendo energía:<br/>

  Si la función es activada pero la bomba de agua no vibra ni hace ruido, mida el voltaje en el puerto de salida de la bomba de agua en el chasis de Kraft.<br/>

  El voltaje debe estar entre 20V y 24V.<br/>

  Si hay voltaje, la bomba de agua está defectuosa y debe ser reemplazada, como se muestra en la Figura 65.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_65.png?v=1767694662:Figura 65]`,
          video_url: [],
        },
   
        {
          Q: `Hay humo excesivo dentro de la carcasa Kraft y la capacidad de extracción es muy pobre.`,
          A: `Solución:<br/>

  (1) Confirme si se está utilizando un purificador de aire:<br/>

  Si la capacidad de filtrado del purificador es baja, la extracción de aire se verá afectada.<br/>

  Intente quitar la manguera de extracción y ventilar el humo directamente al exterior para comprobar si la ventilación de la carcasa funciona correctamente.<br/>

  Si la ventilación directa funciona, significa que la capacidad de filtrado del purificador es débil o el filtro necesita ser reemplazado.<br/>

  (2) Revise si el ventilador de la carcasa está obstruido por polvo:<br/>

  La acumulación excesiva de polvo reduce la eficiencia de extracción. Consulte el Video de Limpieza de la Carcasa Kraft para limpiar la carcasa y el ventilador.<br/>

  (3) Si la ventilación directa y la limpieza no resuelven el problema, el ventilador puede estar defectuoso:<br/>

  Intente reemplazar el ventilador. Consulte el Video de Reemplazo del Ventilador de la Carcasa Kraft.`,
          video_url: [`https://youtu.be/ayJjKddG4kk`, `https://youtu.be/qOaaI53eYK4`],
        },
        {
          Q: `Al usar el dispositivo rotatorio en la Kraft, la salida está invertida.`,
          A: `Solución:<br/>

  (1) Confirme si el patrón de salida está en espejo:<br/>

  Si es así, revise si la función de espejo está habilitada en la configuración del software. Si está habilitada, desactívela;<br/>

  si está deshabilitada, actívela.<br/>

  Consulte AtomStack Studio (ver Figura 66) y LightBurn (ver Figura 67).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_66.png?v=1767694661:Figura 66]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_67.png?v=1767694662:Figura 67]<br/>

  (2) Confirme si el patrón de grabado está invertido:<br/>

  Si es así, intente invertir la dirección del motor para solucionar el problema. Ver Figura 68.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_68.png?v=1767694662:Figura 68]<br/>

  (3) Si los pasos anteriores no resuelven el problema: Restaure los valores de fábrica en AtomStack Studio: para la versión 2.20 o superior, toque el número de versión (por ejemplo, V.2.20) siete veces consecutivas para entrar en el Modo Desarrollador (ver Figura 69). En el menú, abra el Registro del Puerto Serie y luego haga clic en Restablecer para restaurar la configuración de fábrica (ver Figura 70). Alternativamente, en el software LightBurn, introduzca el comando $RST=* en el cuadro de comandos para restablecer a los valores predeterminados de fábrica (ver Figura 71).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_69.png?v=1767694662:Figura 69]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_70.png?v=1767694661:Figura 70]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_71.png?v=1767694661:Figura 71]`,
          video_url: [],
        },
        {
          Q: `Kraft no puede conectarse a la aplicación móvil.`,
          A: `Solución:<br/>

  Confirme que el método de conexión sea correcto: consulte el video de desempaquetado y uso en línea de Kraft.<br/>

  Confirme que la contraseña es correcta: la contraseña predeterminada de Kraft es 12345678.<br/>

  Asegúrese de que el teléfono esté lo suficientemente cerca de la máquina: cuando se conecte a través de la aplicación, mantenga el teléfono cerca de la máquina.<br/>

  Compruebe si el Wi-Fi de la máquina está ocupado: si el Wi-Fi de la máquina ya está conectado a otro dispositivo, no puede conectarse a uno nuevo.<br/>

  Desconecte otros dispositivos antes de intentar la conexión.<br/>

  Apague los datos móviles del teléfono y vuelva a conectar el Wi-Fi, o pruebe con otro teléfono.<br/>

  Confirme la intensidad de la señal Wi-Fi de la máquina:<br/>

  Al conectarse, verifique la intensidad de la señal Wi-Fi en el teléfono.<br/>

  Si la señal es muy débil, es posible que la antena Wi-Fi esté suelta.<br/>

  Abra la placa base, compruebe si el conector de la antena Wi-Fi está desconectado y vuelva a conectarlo antes de intentarlo de nuevo.`,
          video_url: [`https://youtu.be/p_WDoDDHwYA`],
        },
        {
          Q: `El dispositivo Kraft no inicia el grabado después de conectarse a la APP.`,
          A: `Solución:<br/>

  (1) Confirme las condiciones de uso:<br/>

  Al usar la APP, se debe conectar una USB KEY y una unidad USB. La unidad USB debe tener suficiente espacio de almacenamiento.<br/>

  (2) Confirme que la puerta de la carcasa esté cerrada:<br/>

  La puerta debe estar completamente cerrada para iniciar el grabado. El láser no emitirá luz si la puerta está abierta.<br/>

  (3) Verifique mensajes de error en la APP:<br/>

  Preste atención a cualquier aviso anormal en la APP. Si no hay mensajes, intente reiniciar tanto la máquina de grabado como la APP.<br/>

  También elimine la máquina conectada de la APP y vuelva a conectarla.`,
          video_url: [],
        },
        {
          Q: `El sistema Kraft no detecta la unidad USB.`,
          A: `Solución:<br/>

  (1) Compruebe si la unidad USB está dañada:<br/>

  Inserte la unidad USB en una computadora para ver si se puede leer normalmente.<br/>

  Si se puede acceder a los archivos, la unidad USB se considera funcional.<br/>

  (2) Confirme que la unidad USB está conectada al puerto correcto:<br/>

  Asegúrese de que la unidad USB esté insertada en el puerto USB DRIVE de la máquina de grabado.<br/>

  No la inserte en el puerto USB KEY.<br/>

  (3) Verifique si el puerto USB DRIVE funciona correctamente:<br/>

  Inspeccione el puerto USB DRIVE para ver si está dañado o defectuoso.<br/>

  (4) Si todas las comprobaciones anteriores son normales pero el problema persiste, puede ser necesario reemplazar la placa base.<br/>

  Consulte el video de reemplazo de la placa base de Kraft.`,
          video_url: [`https://youtu.be/pzhm-CW99CQ`],
        },
        {
          Q: `Actualizaciones para el software de control, firmware y APP de Kraft.`,
          A: `(1) Actualización de AtomStack Studio:<br/>

  Al abrir el software, si hay una nueva versión disponible, aparecerá automáticamente un aviso de actualización.<br/>

  Si no hay un aviso, vaya a Configuración y seleccione Buscar actualizaciones.<br/>

  También puede descargar la última versión desde AtomStack.com.<br/>

  Actualización de firmware:<br/>

  Puede actualizar mediante AtomStack Studio, la APP de AtomStack o una unidad flash USB.<br/>

  ◆ Después de conectar al cliente AtomStack Studio o la aplicación móvil, haga clic directamente en Actualizar Firmware, como se muestra en la Figura 72. Tenga en cuenta que necesita insertar una unidad flash USB como almacenamiento para actualizar.<br/>

  ◆ Copie el archivo en el directorio raíz de la unidad flash USB e insértela en el puerto USB de la máquina para actualizar.<br/>

  (3) Actualización de la APP:<br/>

  Descargue la última versión de la APP desde AtomStack.com, o abra la APP y vaya a Perfil > Configuración > Acerca de ATOMSTACK para comprobar la versión del software.<br/>

  Si hay una actualización disponible, puede actualizarla directamente desde allí.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_71.png?v=1767694661:Figura 72]`,
          video_url: [],
        },
        {
          Q: `Avisos de alarma de Kraft y solución de problemas.`,
          A: `Alarma1: Interruptor de límite activado - Verifique si el interruptor de límite se ha activado y compruebe el tamaño del archivo de grabado. Si se activa una alarma incluso cuando la posición de grabado está en el centro del área de trabajo, es posible que el interruptor de límite esté defectuoso. Consulte el video de comprobación manual de activación del interruptor de límite de Kraft para la solución de problemas.<br/>

  Alarma9: Fallo en el proceso de origen (homing) - Solucione siguiendo la solución de fallo de homing de Kraft.<br/>

  Alarma12: Detección de llama activada - Observe cuidadosamente si el material que se está grabando o cortando se ha incendiado. Si es una falsa alarma, siga la solución para “Kraft activa la alarma de llama con frecuencia”.<br/>

  Alarma13: Puerta abierta detectada - La puerta de la carcasa puede estar abierta o el interruptor de límite puede estar defectuoso. Consulte la solución para “Kraft continúa grabando incluso con la puerta abierta”.`,
          video_url: [`https://youtu.be/CCYbB1pKtY0`],
        },
   
      ],
    ],
  },
  P1: {
    nav: [`Preguntas antes de la compra`, `Inicio rápido`, `Mantenimiento y Cuidado`],
    nav_desc: [
      `Lo que necesitas saber antes de comprar`,
      `Tus primeros pasos de forma sencilla (Para principiantes)`,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      [
        {
          Q: `¿Puede la P1 funcionar con módulos o accesorios de terceros (que no sean AtomStack)?`,
          A: `Debido al diseño especial de la P1, no es compatible con módulos/accesorios de otras marcas. El módulo utiliza un conector de 8 pines y un montaje específico (ver Figura 1). [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1.png?v=1758787320:Figura 1]`,
        },
        {
          Q: `¿Es la P1 compatible con módulos de otras máquinas AtomStack?`,
          A: `La P1 no es compatible con módulos de otros modelos. Soporta [link:/products/atomstack-p1-1w-1064nm-laser-module:el módulo infrarrojo de 1.2W de la P1] y los giratorios AtomStack [link:/products/r6:R6] /[link:/products/r8:R8] /[link:/products/r8-pro:R8 Pro] con auto-reconocimiento.`,
        },
        {
          Q: `¿Cuál es el área de trabajo?`,
          A: `Láser de diodo: 110 × 110 mm. Láser infrarrojo: 105 × 100 mm. La P1 prioriza la portabilidad.`,
        },
        {
          Q: `¿Puede grabar o cortar metal?`,
          A: `Puede grabar algunos metales pero no puede cortarlos. La P1 admite un láser de diodo (azul) y un [link:/products/atomstack-p1-1w-1064nm-laser-module:lásser infrarrojo de 1.2W]. Consulta la hoja de parámetros de la P1 para los ajustes.<br/>

  Notas para metal:<br/>

  • Con el láser de diodo: marcado limitado de metales (por ejemplo, acero inoxidable con el proceso adecuado), no apto para corte.<br/>

  • Con el láser infrarrojo de 1.2W: adecuado para grabado en metal; tampoco para corte.<br/>

  ¿Dónde encontrar la hoja de parámetros?<br/>

  Escanea el código QR en la máquina; visita [link:/pages/product-support:soporte de producto]; o solicita ayuda al soporte.`,
        },
        {
          Q: `¿Puede la P1 conectarse a un router Wi-Fi?`,
          A: `Sí. Durante la configuración con la APP por Bluetooth, el flujo de provisión de AtomStack incluye pasos para la conexión al router. Consulta el tutorial de la APP.`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `¿Puede grabar termos, tazas y otros objetos curvos?`,
          A: `Sí, con AtomStack [link:/products/r6:R6] /[link:/products/r8:R8] /[link:/products/r8-pro:R8 Pro] (auto-reconocimiento) y pies elevadores instalados. Consulta el tutorial de giratorio.`,
          video_url: [`https://www.youtube.com/embed/aT0n1hF0wgI`],
        },
        {
          Q: `¿Puede grabar o cortar cuero? ¿Qué parámetros debo usar?`,
          A: `Sí. Como punto de partida: Graba a 6000 mm/min, 80% de potencia. Corta cuero de 1 mm a 500 mm/min, 80% de potencia en una sola pasada. Para otros materiales, consulta la hoja de parámetros de la P1.`,
        },
        {
          Q: `¿La P1 admite giratorio?`,
          A: `Sí. Consulta el tutorial de giratorio.`,
          video_url: [`https://www.youtube.com/embed/0dIsqOSiCnk`],
        },
        {
          Q: `¿Qué ventajas tiene la P1 frente a otros modelos?`,
          A: `
• Económica y fácil: asequible, lista para usar; biblioteca de recursos gratuita; interfaz simple con indicadores claros de estado.<br/>

• Reconocimiento dual de módulos: el software detecta qué módulo está instalado y cambia de modo automáticamente. Soporta módulos de diodo de 5W y láser infrarrojo de 1.2W para una amplia variedad de materiales (madera, bambú, papel, cuero, cartulina, corcho, piedra, fieltro, metales, plásticos, acrílico, etc.).<br/>

• Software AtomStack: AtomStack Studio (PC) y AtomStack APP (móvil) incluyen preajustes de materiales, biblioteca de recursos, y reconocimiento automático de accesorios—ideal para principiantes y profesionales.<br/>

• Mini y portátil: compacto (265 × 303 × 185 mm), ~3 kg. Ideal para casa, estudio, ferias y tiendas.<br/>

• Grabado rápido: hasta 10.000 mm/min.<br/>

• Alta precisión: CoreXY con doble motor; precisión de posicionamiento hasta 0,1 mm.<br/>

• Seguridad clase 1: diseño completamente cerrado con ventana de visualización, detección de inclinación, detección de puerta y llave USB.<br/>

• Enfoque rápido: palanca de enfoque fijo incorporada.<br/>

• Accesorios versátiles: admite accesorios giratorios (mandril/rodillo/correa, se venden por separado) para trabajar con termos, anillos, pulseras y áreas de trabajo expandidas.<br/>

• Certificaciones: IEC 60825‑1 Clase 1, CE, RoHS, FCC, FDA.<br/>

• Compatibilidad: Funciona con software AtomStack en Android/iOS/Windows/macOS; compatible también con LightBurn (de pago).`,
        },
        {
          Q: `¿Hay un purificador dedicado?`,
          A: `Utiliza el AtomStack [link:/products/atomstack-d3-air-purifier:purificador D3]. El puerto de salida de la P1 es de 49 mm de diámetro externo; utiliza el adaptador incluido. Consulta el tutorial de conexión del D3.`,
          video_url: [`https://www.youtube.com/embed/o3Ij-po3u_c`],
        },
        {
          Q: `¿Puedo usar un panel de panal?`,
          A: `No es necesario. La placa base metálica incluida está diseñada para corte. Utiliza los imanes incluidos para elevar ligeramente la pieza y obtener cortes más limpios.`,
        },
        {
          Q: `¿Puedo usar aire asistido?`,
          A: `No. El módulo no tiene puerto de aire. La carcasa utiliza un ventilador de escape de alta velocidad para eliminar el humo y lograr mejores resultados.`,
        },
        {
          Q: `¿Qué medidas de seguridad incluye? ¿Necesito gafas de seguridad?`,
          A: `• Seguridad: diseño totalmente cerrado con ventana de observación; detección de inclinación; detección de puerta; llave de seguridad USB.<br/>

• Gafas: No se requieren cuando se usa dentro de la carcasa. Si instalas elevadores para usar giratorio (carcasa abierta), usa gafas de seguridad láser.`,
        },
        {
          Q: `¿Qué hago si el material es demasiado grande para el cerramiento?`,
          A: `La placa inferior es desmontable. Retírala para grabar objetos de gran tamaño.`,
        },
        {
          Q: `¿Qué software puedo usar?`,
          A: `Recomendado: AtomStack Studio (PC) y AtomStack APP (móvil). LightBurn también es compatible. Para LightBurn, configura la velocidad de transmisión a 460800 o importa la configuración de la P1 desde la unidad USB.`,
        },
        {
          Q: `¿Cuál es la temperatura de funcionamiento?`,
          A: `Ambiente recomendado: 0–35°C.`,
        },
        {
          Q: `¿Puede grabar materiales reflectantes?`,
          A: `No. Materiales reflectantes o altamente refractantes no están soportados y podrían dañar el láser.`,
        },
      ],
      [
        {
          Q: `¿Panel de control y funciones?`,
          A: `
          1. Llave USB — Insértala para desbloquear la máquina.<br/>

          2. Puerto de accesorios — Conecta rodillos giratorios/mandriles y otros complementos.<br/>

          3. Ranura USB — Requerida para el uso de la APP móvil; de lo contrario, la APP no funcionará.<br/>

          4. Puerto Type-C — Conecta al PC con un cable Type-C.<br/>

          5. Entrada de corriente — 24V 3A.<br/>

          6. Interruptor de encendido — Enciende o apaga el grabador.<br/>

          7. Botón APP Frame / Repetición (solo modo APP): presiona una vez para encuadrar; mantén pulsado (3s) para repetir el último trabajo.<br/>

          8. Botón de inicio / pausa: pulsa una vez para pausar/reanudar; doble clic para eliminar errores; mantén pulsado (3s) para alternar el modo Bluetooth/ Wi-Fi. El anillo indicador se ilumina cuando hay un accesorio conectado (por ejemplo, giratorio).<br/>

          9. Indicador de estado: verde fijo = normal; verde parpadeando = en pausa; rojo fijo = error; azul fijo = láser en funcionamiento.<br/>

          10. Indicador Wi-Fi: apagado = no conectado; parpadeando = conectando; verde fijo = conectado.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_ae3571a6-73c7-4cf4-b2c4-e994974c8aa8.png?v=1758866558:Fig. 1]`,
        },
        {
          Q: `¿Qué pasa con la conexión por PC?`,
          A: `• Con AtomStack Studio: no requiere configuración de baudios.<br/>

              • Con LightBurn: fija la velocidad de baudios en 460800 o importa el archivo de configuración de la P1 (incluido en la memoria USB). Ver Fig. 1.<br/>

              • El láser dispone de una palanca de enfoque fijo: bájala hasta que toque la superficie del material (Fig. 2).<br/>

              • El módulo se sujeta con un tornillo en L para un enfoque rápido. Si el mango del tornillo está bloqueado por la guía, tira del mango hacia afuera para reposicionarlo (Fig. 3).<br/>

              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1.png?v=1758866781:Fig. 1]
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2.png?v=1758867024:Fig. 2]
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3.png?v=1758866954:Fig. 3]`,
          video_url: [`https://www.youtube.com/embed/ZV_OsUjkZ4k`],
        },
        {
          Q: `¿Qué pasa con la conexión de la APP?`,
          A: `• Consulta el tutorial de la APP / manual de usuario.<br/>

              • Inserta una memoria USB antes de usar la APP.<br/>

• Durante la configuración por Bluetooth en la APP, sigue el flujo de provisión para conectar la P1 al router (Wi‑Fi).<br/>

• La APP incluye una biblioteca de materiales y recursos de muestra. Si los resultados son demasiado profundos/superficiales, baja/sube la potencia o incrementa/disminuye la velocidad según corresponda.`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `¿Cómo cambio el módulo láser?`,
          A: `• El módulo incluye una palanca de enfoque fijo; no se requiere tarjeta de enfoque.
              • Cambio rápido mediante tornillos de mano en L. Si el mango está bloqueado por la guía, tira hacia afuera para girarlo libremente (Fig. 1).
              • Con el [link:/products/atomstack-p1-1w-1064nm-laser-module:módulo infrarrojo de 1.2W], la máquina puede pre-calentar automáticamente durante ~2–10 s a bajas temperaturas ambientales antes de grabar.
              [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a3d30f12-dcfe-4279-ba67-86bdd70d4601.png?v=1758867988:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/eVCdVBK4DDA`],
        },
        {
          Q: `¿Cómo conecto los dispositivos giratorios (R6 / R8 / R8 Pro)?`,
          A: `• Solo compatibles los AtomStack R6, R8, R8 Pro (auto-reconocimiento). Utiliza el cable dual USB auto-ID al puerto de accesorios (Fig. 1).<br/>

• Si tu kit giratorio no incluye pies elevadores, adquiere el kit elevador H5.<br/>

• AtomStack Studio: R6 no requiere parámetros; R8 requiere ingresar diámetro o circunferencia de la pieza (Fig. 2).<br/>

• LightBurn: configura el tipo de giro (R6 = Rodillo, R8 = Mandril), eje = Y. Parámetros: R8 = 160 mm/vuelta (fijo), R6 = 50 mm/vuelta (fijo) con diámetro de 16 mm (fijo). Ingresa diámetro o circunferencia (Fig. 3).<br/>

• Extrae la placa inferior (gira los seguros en sentido horario) e instala pies elevadores al usar el giratorio (Fig. 4).<br/>

• Si el resultado aparece en espejo, activa/desactiva Mirror en AtomStack Studio (Fig. 5) o LightBurn (Fig. 6).<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_503d242a-2e43-4397-bafb-0bded3e54a25.png?v=1758869138:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f3a93e58-4651-4de3-aad6-a3edb646f87c.png?v=1758869182:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2acad521-fa1e-4c33-ae9f-838b89d89ab5.png?v=1758869183:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4.png?v=1758869184:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5.png?v=1758869182:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dc8da09-daa0-476b-b19d-9af59fec2224.png?v=1758875525:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_7f51015e-a34f-4251-ae09-e9e6ff3094c7.png?v=1758875525:Fig. 2]`,
          video_url: [
            `https://www.youtube.com/embed/aT0n1hF0wgI`,
            'https://youtu.be/0dIsqOSiCnk',
            'https://youtu.be/rCjEHuaNifs',
          ],
        },
        {
          Q: `¿Cómo enfoco el láser?`,
          A: `Afloja el tornillo de mano en L, baja la palanca de enfoque fijo hasta que toque la superficie del material, aprieta el tornillo y luego retrae la palanca. Si el mango está bloqueado por la guía, tira hacia afuera para reposicionarlo (Fig. 1).
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8b836157-dd15-4a21-994f-9bd4dead2e69.png?v=1758870212:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/BQ-HoWZhJ1A`],
        },
        {
          Q: `¿Cómo usar los modos de coordenadas (software)?`,
          A: `• Posición Actual — El láser comienza donde lo coloques manualmente.<br/>

• Origen de Usuario — Tú eliges y defines el punto de inicio.<br/>

• Coordenadas Absolutas — Usa el origen de la máquina (0,0) después de hacer homing; la posición absoluta del diseño determina el inicio (LightBurn: Fig. 1; AtomStack Studio: Fig. 2).<br/>

[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1cbb6018-412a-4950-88c1-df4dca21d4be.png?v=1758870332:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_35b234c1-5a8e-496c-bba9-1136654792e2.png?v=1758870384:Fig. 2]`,
        },
        {
          Q: `¿Qué es la prueba de parámetros (software)?`,
          A: `Disponible en LightBurn con licencia v1.3.01+ o AtomStack Studio. Usa las pruebas de parámetros para encontrar rápidamente los ajustes óptimos para diferentes materiales.`,
        },
      ],
 
      [
        {
          Q: `¿Cómo limpio la ventana del láser y el ventilador?`,
          A: `La ventana del láser (vidrio protector) no es desmontable. Usa etanol anhidro al 99% o limpiador óptico de lentes (evita amoníaco/acetona). Limpia suavemente con un paño sin pelusa en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) para evitar rayones. Ilumina lateralmente con una fuente de luz brillante para confirmar que no quedan residuos/fibras. Limpia a diario si hay uso intensivo; semanalmente si el uso es ligero. Si la ventana está dañada, contacta a [link:/pages/contact:soporte].<br/>
• La acumulación de polvo en el ventilador del módulo afecta la refrigeración. Limpia semanalmente (uso intensivo) o cada 1–2 meses (uso ligero). Usa paños sin pelusa o hisopos ópticos (evita hisopos de algodón con pelusa).`,
        },
        {
          Q: `¿Cómo limpio el interior de la carcasa?`,
          A: `Utiliza etanol anhidro al 99% y un paño sin pelusa. Evita líquidos corrosivos y evita frotar de un lado a otro, ya que podría rayar las superficies. Limpia semanalmente (uso intensivo) o mensualmente (uso ligero). Después de limpiar los ejes lineales, aplica grasa uniformemente (recomendado NLGI grado 2 por debajo de 15°C; grado 3 por encima de 15°C). Al limpiar el ventilador de extracción, desármalo con cuidado; no fuerces. Consulta la Fig. 1 para ver la ubicación de los tornillos.
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_93fe5274-a555-40d2-9d30-247235d830e9.png?v=1758871190:Fig. 1]`,
          video_url: [`https://www.youtube.com/embed/wH6GIgNEeTg`],
        },
        {
          Q: `¿Qué debo tener en cuenta para el almacenamiento a largo plazo?`,
          A: `• Guarda la máquina en un lugar seco; evita la humedad prolongada.<br/>
• Enciende la máquina periódicamente para mantener la electrónica en buen estado.`,
        },
        {
          Q: `¿Qué hago si la conexión con el PC falla y el software no puede conectarse?`,
          A: `• Verifica los indicadores del panel: verde fijo = normal; rojo fijo = alarma. Si está en rojo, asegúrate de que la puerta esté cerrada, que el cabezal no presione los finales de carrera, que la llave USB esté insertada y que el interruptor de la puerta funcione. Si el interruptor de la puerta está defectuoso, puedes desactivar temporalmente la Detección de Puerta en la APP o AtomStack Studio (ver Fig. 1), pero opera con precaución.<br/>
• LightBurn: velocidad en baudios 460800 (Fig. 2) o importa el archivo de configuración P1.<br/>
• Puerto serie/COM: revisa en el Administrador de Dispositivos (conecta/desconecta el Type‑C para ver los cambios). Si no es reconocido o muestra advertencias, instala el controlador USB serial. Ejemplo de puerto COM en la Fig. 3.<br/>
• Prueba con otro cable/puerto Type‑C; prueba AtomStack Studio.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_66a922ca-e2e4-4b62-b39a-f8269c2acd78.png?v=1758872181:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_d725f250-7ca2-4666-b982-246986198f8b.png?v=1758872181:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d59aa01a-81d3-4f7f-bc93-c3595758fb58.png?v=1758872181:Fig. 3]`,
          video_url: [`https://www.youtube.com/embed/ihZ-cWw5rw8`],
        },
        {
          Q: `¿Qué hago si la APP móvil no puede conectarse?`,
          A: `• Comprueba la potencia de la señal Wi‑Fi en tu teléfono, cerca de la máquina. Si es débil, consulta “La señal Wi‑Fi es muy débil”.<br/>
• Asegúrate de que ningún otro dispositivo esté usando la conexión Wi‑Fi del P1.<br/>
• Prueba modos alternativos: Wi‑Fi, Bluetooth o Zona Wi‑Fi según corresponda. Consulta el tutorial de conexión de la APP.<br/>`,
          video_url: [`https://www.youtube.com/embed/fS4eDWv50Hs`],
        },
        {
          Q: `¿Qué hago si la ventana del láser está sucia o dañada?`,
          A: `• Si está sucia: límpiala con etanol anhidro al 99% o limpiador óptico de calidad (evita amoníaco/acetona). Limpia suavemente con un paño sin pelusa en una dirección. Ilumina lateralmente para confirmar la limpieza. Limpia a diario (uso intensivo) o semanalmente (uso ligero). Consulta el video de limpieza de ventana/ventilador.<br/>
• Si está dañada: la ventana no es reemplazable; reemplaza todo el módulo. Proporciona fotos claras del daño, el número de serie de la máquina (Fig. 1) y el código del módulo láser (Fig. 2) al soporte.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dc8da09-daa0-476b-b19d-9af59fec2224.png?v=1758875525:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_7f51015e-a34f-4251-ae09-e9e6ff3094c7.png?v=1758875525:Fig. 2]`,
          video_url: [`https://www.youtube.com/embed/OE0dVz_c5_w`],
        },
        {
          Q: `¿Qué hago si la P1 no enciende o no inicia correctamente?`,
          A: `Indicador en ROJO:<br/>
• ¿La puerta está cerrada? Ábrela y ciérrala nuevamente. Revisa el cableado del interruptor Hall en la puerta (Fig. 1). Usa un imán pequeño cerca del sensor Hall—si cambia a verde (Fig. 2), el imán de la puerta puede estar débil o el cableado suelto. Consulta “La detección de puerta no funciona”.<br/>
• ¿El cabezal está en el borde? Muévelo manualmente al centro para evitar que presione un final de carrera.<br/>
• Finales de carrera: pulsa cada final interno para confirmar que activa (Fig. 3).<br/>
• Llave USB: muévela con suavidad para detectar contacto intermitente. Reconéctala. Si es necesario, presiona suavemente la carcasa del puerto USB hacia adentro para mejorar el contacto (Fig. 4). Proporciona un video del fallo y el número de serie (Fig. 5) al soporte.<br/>
• Firmware: copia el firmware más reciente (o anterior) en la raíz de la unidad USB; insértala y espera que finalicen los pitidos. Consulta el tutorial de firmware.<br/>
• Si no se resuelve: reemplazo de la tarjeta principal.<br/><br/>
Indicador alternando ROJO/VERDE con pitidos:<br/>
• Generalmente por mal contacto de la llave USB. Reconéctala o presiona suavemente el puerto USB (Fig. 6).<br/><br/>
Sin luz de indicador:<br/>
• Adaptador de corriente: revisa el LED del adaptador. Mide que la salida esté entre 20–25V DC (Fig. 7). Si es <20V, el adaptador está defectuoso.<br/>
• Interruptor de corriente: desconecta el adaptador, abre la tapa superior, haz un puente entre los dos cables del interruptor, reconecta y prueba. Si inicia, reemplaza el interruptor (ver tutorial de puente).<br/>
• Si sigue sin encender: fallo de tarjeta principal; reemplázala.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9dcb2e48-1b1b-43f0-b08b-3145b73b8019.png?v=1758876240:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_db7131db-d00e-43ca-96fb-1fb037bac0f9.png?v=1758876242:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_dc3a7d68-d145-4b79-b2b2-400dc04ba248.png?v=1758876242:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_f24a252f-83a6-4ffa-b4ac-310c9c0c5c1b.png?v=1758876238:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_ce9b5d8b-f3c4-4db4-a89e-79abb87ef94a.png?v=1758876242:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6.png?v=1758876238:Fig. 6]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._7.png?v=1758876243:Fig. 7]`,
          video_url: [
            'https://youtu.be/AR1UlNIDheI',
            'https://youtu.be/5k5FWyUSaL8',
            'https://youtu.be/tmiQr5I2_a0',
          ],
        },
        {
          Q: `¿Qué hago si la detección de puerta (verificación de puerta abierta) no funciona?`,
          A: `• Revisa el cableado: reconecta el conector del interruptor Hall en la puerta (Fig. 1).<br/>
• Confirma que la puerta esté completamente cerrada.<br/>
• Asegúrate de que la Detección de Puerta está habilitada en AtomStack Studio o en la APP (Fig. 2).<br/>
• Prueba el interruptor Hall con un imán—si cambia a verde, el imán de la puerta está débil; reemplázalo. Si no responde a ningún imán, reemplaza la placa del interruptor Hall (Fig. 3). Hasta que la reemplaces, puedes desactivar la Detección de Puerta por software para continuar (con precaución).
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d513bebf-8667-4f2f-b0aa-7335de140edf.png?v=1758876997:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_b8e17245-7492-46e4-a751-78a56a1ff66d.png?v=1758876995:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_ce1c5e1b-be3a-46a3-9f54-6ceb625d5ee7.png?v=1758876996:Fig. 3]`,
          video_url: ['https://youtu.be/FxNPiXiqvlM', 'https://youtu.be/KI-CWcxoMhc'],
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar el problema de grabado muy superficial?`,
          A: `• Enfoque: vuelve a enfocar después de colocar el material (consulta el tutorial de enfoque).<br/>
• Planitud: asegúrate de que la superficie y el material estén planos; cualquier curvatura da lugar a profundidad desigual.<br/>
• Idoneidad del material: solo los materiales no transparentes graban correctamente. Verifica compatibilidad en la hoja de parámetros P1.<br/>
• Parámetros de software: comienza con los valores recomendados; si faltan preajustes, prueba para encontrar los parámetros óptimos según materiales similares.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5a7391e8-1936-46c7-811a-7edf71fc0b19.png?v=1758878187:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ecc27018-bb82-4995-bf4b-5b222fc77176.png?v=1758878187:Fig. 2]`,
          video_url: ['https://youtu.be/jheG1aVGWzc', 'https://youtu.be/OE0dVz_c5_w'],
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar la caída significativa en el rendimiento de corte?`,
          A: `• Tiempo de uso: la potencia del diodo decae naturalmente con el tiempo—compensa con mayor potencia o menor velocidad.<br/>
• Vuelve a enfocar para diferentes grosores de material.<br/>
• Salida del adaptador: verifica que esté en 20–25V DC (Fig. 1).<br/>
• Software: confirma que S‑Max en LightBurn sigue en 1000 (Fig. 2). Consulta la hoja de parámetros.<br/>
• Estado de la ventana: limpia o reemplaza el módulo si la ventana está dañada. Si todo está correcto pero el corte sigue débil, el módulo puede haber fallado. Proporciona videos, número de serie (Fig. 3) y código de módulo (Fig. 4) a soporte.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9ef33927-e637-472d-9f35-5c69c9f4ecd1.png?v=1758879259:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9f4b2911-7f56-4872-a8eb-5318166f6ea5.png?v=1758879253:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_4979a38b-f5a1-4655-bdc7-49b771418f7f.png?v=1758879256:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_e4080901-5eea-4916-97c6-1a92dfdabb2d.png?v=1758879256:Fig. 4]`,
          video_url: ['https://youtu.be/OE0dVz_c5_w', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar cuando el cabezal se mueve pero no hay salida de láser?`,
          A: `• No grabes materiales reflectantes sin preparación—cubre la superficie (por ejemplo, pintura negra) o evítalos para prevenir daños.<br/>
• Adaptador de corriente: verifica salida de 20–25V DC (Fig. 1).<br/>
• Cable del láser: reconecta el conector.<br/>
• Reconocimiento: AtomStack Studio detecta módulos automáticamente. Si enmarcando/grabando indica “sin láser instalado”, el módulo o cable pueden estar defectuosos. Usa un multímetro para probar continuidad del cable.<br/>
• Voltajes de cable: a 100% de potencia y 1 mm/min, mide en el conector del módulo (Fig. 2): pines 1–2 = 20–25V; pines 2–3 = >1–6V. Si los voltajes son normales, el módulo está averiado—reemplázalo. Proporciona número de serie (Fig. 3) y código de módulo (Fig. 4).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_a0b3913e-8eb1-483d-86a2-a44ad163514b.png?v=1758879965:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_92ae4bd7-e6ac-4df8-ac8f-cb9467ba1532.png?v=1758879963:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_67edfcda-a2c5-4a07-bc94-fce4e4dcb348.png?v=1758879966:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_cb09bafa-0516-4b19-9aa6-bb93c4ac1987.png?v=1758879965:Fig. 4]`,
          video_url: ['https://youtu.be/r-iuQcnabiQ', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `¿Qué pasos debo seguir si la máquina se detiene inesperadamente durante un trabajo?`,
          A: `• Adaptador de corriente: ¿El LED está encendido y la salida DC tiene 20–25V? Si la energía de la red es inestable localmente, intenta de nuevo o usa otro adaptador de 24V 3A.<br/>
• Reinicios durante trabajos pueden indicar falla de placa principal o adaptador.<br/>
• “Alarm 1” u “out-of-bounds” sin golpear el marco: probablemente fallo en un final de carrera; si sí chocó, reduce el tamaño del trabajo.<br/>
• “Desconectado”: puede ser fallo de cable Type‑C/puerto COM/placa principal. Prueba otro cable/puerto e instala drivers. Si las desconexiones persisten, reemplaza la placa principal.<br/>
• Sin mensaje de alarma: vuelve a grabar el firmware. Si sigue mal, falla de la placa principal.`,
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar resultados inconsistentes usando el mismo material y parámetros?`,
          A: `• Consistencia de enfoque: vuelve a enfocar tras cambiar el material.<br/>
• Planitud: asegúrate de que la placa base y el material estén planos.<br/>
• Vetado de la madera: la veta natural causa variabilidad—prueba MDF.<br/>
• Ventana: limpia la ventana del láser.<br/>
• Mecánicos: revisa los tornillos de las poleas del motor (Fig. 1) y confirma que las correas estén bien ubicadas en las poleas locas (Fig. 2).<br/>
• Si no se resuelve, envía un video mostrando ajustes, superficie del material, resultados y número de serie (Fig. 3) al soporte.
[img::https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bb68daf6-95ca-42d9-b57b-ace150c4fc17.png?v=1758881305Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_34693420-d2cc-4823-8e05-f9643944688c.png?v=1758881305:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2bd88497-7331-4f5b-b5c9-2f4d37ee8815.png?v=1758881303:Fig. 3]`,
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar y corregir mala calidad de grabado?`,
          A: `• Parámetros: verifica en la hoja de parámetros P1.<br/>
• S‑Max de LightBurn: confirma 1000 (Fig. 1).<br/>
• Ventana: limpia o reemplaza el módulo si la ventana está dañada.<br/>
• Voltaje del adaptador: confirma 20–25V (Fig. 2).<br/>
• Artefactos de relleno: si aparecen bandas horizontales, reduce el intervalo de línea a ~0,08 mm y usa escaneado vertical (AtomStack Studio: Fig. 3; LightBurn: Fig. 4).<br/>
• Comprobación de decaimiento de potencia: a 100% de potencia y 200 mm/min cortando contrachapado de 3 mm en una pasada—si falla, el módulo puede estar al final de su vida útil.<br/>
• Si los patrones son irregulares, consulta “Patrones irregulares”.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_80b834f6-b089-4b7c-8c66-3954e163ca78.png?v=1758881678:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_af386a49-fb78-42a5-806d-7a0e444f7098.png?v=1758881679:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_106746fb-788d-4296-8157-d771814d2778.png?v=1758881678:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_7a55f36f-cebc-46f3-ba00-c084db4d47fc.png?v=1758881678:Fig. 4]`,
          video_url: ['https://youtu.be/OE0dVz_c5_w', 'https://youtu.be/eVCdVBK4DDA'],
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar patrones irregulares o formas distorsionadas?`,
          A: `• Prueba de desplazamiento: usa las flechas para mover los ejes; si el movimiento es en diagonal (45°) o incorrecto, puede haber fallo en motor o driver. Cambia los conectores de motor para ver si el problema se mueve—si cambia, el fallo es del driver; si no, del motor.<br/>
• Prueba de círculo y cuadrado: dibuja un círculo vectorial y un cuadrado.<br/>
– Si los lados son desiguales pero las líneas rectas están bien: los pasos/mm pueden haber cambiado. Revisa en LightBurn: $100 y $101 deberían ser 100.270 (Fig. 1).<br/>
– Si hay líneas onduladas/curvas: ajusta la mecánica — tensa correas, revisa que la correa esté bien en las poleas locas (Fig. 51), paralelismo eje X, tornillos de polea del motor (Fig. 2). Si sigue mal, vuelve a grabar el firmware. Proporciona video, capturas de parámetros y número de serie (Fig. 3).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5740fce0-dc1d-4b9b-be58-e5922485e13a.png?v=1759996632:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c24d885c-61e7-42df-bfe0-e0bfc4388146.png?v=1759996632:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_25095fe6-6893-4207-840c-4c403285fbc3.png?v=1759996632:Fig. 3]`,
          video_url: [
            'https://youtu.be/y14XNf4T6KU',
            'https://youtu.be/z6b6Gc5Ingk',
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/mqn7Ee4Draw',
          ],
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar el mensaje repetido de error "¡Advertencia! Golpeó el límite."?`,
          A: `• Tipo de módulo: ten en cuenta que el volumen útil del módulo infrarrojo es 105 × 100 × 50 mm.<br/>
• Tamaño de archivo: asegúrate de que el diseño cabe dentro del área de trabajo del P1.<br/>
• Coordenadas: elimina coordenadas negativas; reinicia el software e importa de nuevo el archivo.<br/>
• Prueba de movimiento: graba un cuadrado de 20 × 20 mm. Si el tamaño es incorrecto, los pasos/mm cambiaron o el controlador es anormal. En LightBurn, pon $100 y $101 en 100.270 (Fig. 1). Si es necesario, vuelve a grabar el firmware; si no, fallo de placa principal.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5de6e241-c890-4653-a0c9-0db92a3a5351.png?v=1759997525:Fig. 1]`,
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar el problema de que la visualización de marco es normal pero el grabado choca con el límite?`,
          A: `• Calibra primero el cursor de cruz roja (solo para módulo IR). Consulta tutorial.<br/>
• Si persiste, en la Consola de LightBurn escribe: $rst=* (Fig. 1), luego recalibra el cursor.<br/>
• Si sigue igual, restablece desplazamientos con:<br/>
$aux_red_light/offset_y_mm=0<br/>
$aux_red_light/offset_x_mm=0<br/>
o [ESP312]/X0/Y0<br/>
Luego recalibra el cursor.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_27e93623-d1c9-4577-bda3-5b2c9e29e95e.png?v=1759997748:Fig. 1]`,
          video_url: ['https://youtu.be/agxm6chTlZs'],
        },
        {
          Q: `¿Cómo puedo corregir el problema de que el grabado IR esté desalineado con el marco y cause un choque?`,
          A: `Calibra el cursor de cruz roja IR (solo en el módulo IR). Si sigue desalineado, sigue los pasos del tema 14.`,
          video_url: ['https://youtu.be/agxm6chTlZs'],
        },
        {
          Q: `¿Qué hago si la máquina choca con el marco durante el grabado?`,
          A: `• Tamaño del diseño: asegúrate que encaje (diodo: 110 × 110 mm; IR: 105 × 100 mm).<br/>
• Siempre enmarca antes de grabar. Si el marco excede los límites, el trabajo chocará.<br/>
• Modo de coordenadas: en Posición Actual siempre enmarca primero; en Coordenadas Absolutas y con archivos más pequeños que el área útil, no deberían ocurrir choques.<br/>
• Diferencia por tipo de módulo: diodo usa el punto láser como (0,0) tras homing; IR usa la cruz roja como (0,0).<br/>
• Movimientos de ejes: usa flechas para verificar correcta movilidad; si solo ocurre movimiento diagonal o alarmas, reconecta motores (Fig. 1).<br/>
• Firmware: actualiza a la versión más reciente por AtomStack Studio/APP. Si ya tienes la última, prueba una versión anterior. Si no se resuelve, considera cambiar tarjeta principal y motores. Proporciona número de serie y video del fallo. Consulta los tutoriales de cambio de firmware, placa principal y motores.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_39de5251-6494-4f1b-8345-18219bffddb0.png?v=1759998153:Fig. 1]`,
          video_url: [
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
            'https://youtu.be/y14XNf4T6KU',
          ],
        },
        {
          Q: `¿Qué hago para evitar que materiales delgados/ligeros se desplacen o salten líneas al grabar?`,
          A: `El ventilador de la carcasa puede levantar o mover materiales ligeros. Usa los imanes o pesos incluidos para sujetar las esquinas o bordes.`,
        },
        {
          Q: `¿Qué pasos debo seguir para solucionar la señal Wi‑Fi muy débil?`,
          A: `• Antena Wi‑Fi: abre la tapa superior y reconecta la antena en la placa principal (Fig. 1).<br/>
• Si sigue débil, la antena puede estar defectuosa—reemplázala (ver tutorial de sustitución de antena).<br/>
• Sin señal Wi‑Fi puede deberse a falla de firmware o tarjeta principal. Vuelve a grabar el firmware; si no sale, reemplaza la tarjeta principal.
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_78893b86-2c08-491a-91df-ea5da24fa683.png?v=1759998527:Fig. 1]`,
          video_url: [
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
            'https://youtu.be/AYHzv-ErtUs',
          ],
        },
        {
          Q: `¿Qué hago si la máquina hace un clic al moverse en ángulo de 45° o no se mueve?`,
          A: `• Conectores de motor: reconectar.<br/>
• Identifica el motor defectuoso desconectando uno por vez. Cambia los conectores para ver si el problema migra (falla del driver) o queda igual (fallo del motor). Reemplaza la pieza defectuosa según corresponda.`,
          video_url: ['https://youtu.be/y14XNf4T6KU', 'https://youtu.be/ihZ-cWw5rw8'],
        },
        {
          Q: `¿Cómo soluciono que la máquina no pueda hacer homing o reiniciarse?`,
          A: `
• Finales de carrera: pulsa manualmente los finales X e Y (Fig. 58). Si no activan, reconecta cables; si sigue sin funcionar, cambia el interruptor (ver tutorial de sustitución).<br/>
• Movimiento de ejes: verifica que los ejes se mueven normalmente con las flechas. Si hay clics o no se mueve, revisa el tema 19.<br/>
• Firmware: revisa y actualiza con AtomStack Studio/APP (Fig. 1). Inserta USB para actualizar.<br/>
• Poleas de motor: aprieta los tornillos de la polea con llave Allen de 1,5 mm (Fig. 2).<br/>
• Restablecimiento de fábrica: Con AtomStack Studio v2.20+, toca 7 veces el número de versión para entrar en modo desarrollador (Fig. 3). Abre “Registro del Puerto Serie” y pulsa “Restablecer” (Fig. 4). O en consola LightBurn escribe $RST=* (Fig. 5).
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9b739df6-bfd3-41c4-bf64-92a51a2c602e.png?v=1759999747:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_95681a47-b4b5-4d0e-9019-d3b59aa68587.png?v=1759999746:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bab624de-2daa-4f60-96b0-5aa3abf4c5e5.png?v=1759999746:Fig. 3]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_1f878555-3088-4fea-b461-21b2f072d9b6.png?v=1759999746:Fig. 4]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_45315ee9-0193-4ccc-9465-b5919f5c8277.png?v=1759999746:Fig. 5]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_488008b7-7ded-48ea-8fff-3b3a319d4175.png?v=1759999746:Fig. 6]`,
          video_url: ['https://youtu.be/dYEL2UDOIXo'],
        },
        {
          Q: `¿Qué hago si las líneas vectoriales no cierran y quedan espacios al final?`,
          A: `• Enfoque: vuelve a enfocar correctamente con la palanca de enfoque fijo.<br/>
• Energía: aumenta la potencia o disminuye la velocidad.<br/>
• Potencia constante: activa el modo de Potencia Constante (LightBurn: Fig. 1; AtomStack Studio: Fig. 2).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2f3b82ab-765a-4f42-8f96-0c829ffc087f.png?v=1760000549:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_96c72ac8-20cc-4586-b176-0c7588d30919.png?v=1760000547:Fig. 2]`,
        },
        {
          Q: `¿Qué hago si el extractor tiene un mal rendimiento?`,
          A: `• Limpia los ventiladores de acuerdo al tutorial de mantenimiento de la carcasa.<br/>
• Si usas un purificador: revisa que la manguera no tenga dobleces/curvas; prueba la extracción directa. Si la extracción directa es buena, el filtro del purificador puede estar saturado—reemplaza los filtros.<br/>
• Cambia el ventilador si las RPM son bajas tras la limpieza.`,
          video_url: ['https://youtu.be/wH6GIgNEeTg', 'https://youtu.be/kXQU8bgUv2M'],
        },
        {
          Q: `¿Qué hago si se oye un ruido de fricción durante la operación?`,
          A: `• Ejes lineales: si están secos, aplica lubricante.<br/>
• Correas: verifica que las correas estén bien en las poleas locas (Fig. 1); un desalineamiento puede rozar con los soportes. Consulta tutorial de cambio de correas y ajuste de poleas locas.<br/>
• Pasos/mm: verifica en LightBurn que $100 y $101 sean 100.270.<br/>
• Tornillos de polea de motor: ajusta con llave Allen de 1,5 mm (Fig. 2).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_eda7e05d-eb59-4c93-8174-45912360aeb5.png?v=1760001151:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_e26e09ea-f5da-40ef-ad30-71b1f33bf4af.png?v=1760001153:Fig. 2]`,
          video_url: [
            'https://youtu.be/_YZ0CbywgMU',
            'https://youtu.be/wH6GIgNEeTg',
            'https://youtu.be/rEzOaAmhYj0',
          ],
        },
        {
          Q: `¿Cómo corrijo el grabado invertido (efecto espejo) al usar el rotatorio?`,
          A: `• Dirección de movimiento: si los ejes se mueven opuesto a las flechas en pantalla, invierte el eje ($3) en LightBurn (Fig. 1).<br/>
• Firmware: vuelve a grabar si los cambios de parámetros no resuelven.<br/>
• Software: configura parámetros del rotatorio y activa/desactiva el modo Espejo según se requiera (AtomStack Studio: Fig. 2; LightBurn: Fig. 3). Si no se resuelve, considera reemplazo de placa principal y motores X/Y.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2fbacaf0-45d7-479c-bf6e-586e8dd2b091.png?v=1760002275:Fig. 1]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_6e21786f-2174-41c4-b8ac-bff3f5406ecd.png?v=1760002278:Fig. 2]
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_1ba08653-9581-4a4f-9599-5d5c9062786a.png?v=1760002279:Fig. 3]`,
          video_url: ['https://youtu.be/ihZ-cWw5rw8', 'https://youtu.be/y14XNf4T6KU'],
        },
        {
          Q: `¿Cómo soluciono que la unidad USB no sea reconocida?`,
          A: `• Prueba la unidad USB en una PC. Si no la reconoce, reemplázala y pide los archivos necesarios al soporte.<br/>
• Si solicita formateo, elige FAT32.<br/>
• Si la PC la reconoce pero el P1 no tras formatear, el puerto USB de la placa principal puede estar fallando—reemplaza la placa principal.`,
          video_url: ['https://youtu.be/ihZ-cWw5rw8'],
        },
        {
          Q: `¿Qué hago si el trabajo de la APP se detiene y muestra "Unidad USB no insertada"?`,
          A: `• Apaga la P1; vuelve a insertar la unidad USB e inténtalo de nuevo.<br/>
• Si te pide formatear en la PC, selecciona FAT32.<br/>
• Si el almacenamiento es anormal, cambia la unidad USB.`,
        },
        {
          Q: `¿Cómo soluciono que el cabezal láser está bloqueado y no puede moverse manualmente al encender la máquina?`,
          A: `• Reanudación tras corte de energía: si está habilitado, el cabezal queda bloqueado. Conéctate con la APP o AtomStack Studio y desactiva "Resumir tras apagado" (Fig. 1).<br/>
• Si sigue bloqueado tras desactivar, vuelve a grabar el firmware P1 (no puedes grabar la misma versión de nuevo; pide otra versión si es necesario). Si solo se puede mover manualmente estando apagada, puede ser falla de placa principal—reemplázala.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_dee49839-3b61-4bc4-92ff-38515ad91ded.png?v=1760002969:Fig. 1]`,
          video_url: [
            'https://youtu.be/Ah0wyk9I5sg',
            'https://youtu.be/ihZ-cWw5rw8',
            'https://youtu.be/tmiQr5I2_a0',
          ],
        },
        {
          Q: `¿Qué hago si falla la actualización de firmware?`,
          A: `Actualiza directamente desde AtomStack Studio o la APP (requiere memoria USB como almacenamiento; ver Fig. 1). Si sigue fallando, primero asegúrate de que la USB funciona en el P1.
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6dc212d-6975-47e4-b475-a32d7c7a14a3.png?v=1760003252:Fig. 1]`,
        },
        {
          Q: `¿Cómo actualizar el software, firmware o la APP?`,
          A: `• AtomStack Studio: si hay nueva versión, la app te pedirá actualizar. O ve a Configuración → Buscar actualizaciones. También puedes descargar desde atomstack.com.<br/>
• Firmware: actualiza por AtomStack Studio/APP (requiere USB; Fig. 1) o copia el archivo de firmware en la raíz del USB e insértalo en el P1.<br/>
• APP: descarga desde atomstack.com o en la APP ve a Perfil → Configuración → Acerca de ATOMSTACK para ver actualizaciones.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d0382cb6-e9ea-4c02-a1c2-73773dabf351.png?v=1760004748:Fig. 1]`,
        },
        {
          Q: `¿Qué hago para solucionar mensajes de alarma en LightBurn o Grbl?`,
          A: `• Alarma 1 — Se activó un final de carrera. Si ocurrió sin contacto físico, comprueba manualmente cada final y reconecta para encontrar el defectuoso.<br/>
• Alarma 2 — Límites suaves. Revisa $20 (límites blandos) en configuración de la máquina; desactívalos si es necesario (Editar → Configuración de máquina; ver Fig. 1).<br/>
• Alarma 3 — Desconectado durante la operación. Revisa el código/salida de consola para diagnosticar.<br/>
• Alarma 8 — Un final de carrera quedó siempre activado. Desconecta/reconecta cada final para localizar el fallo.<br/>
• Alarma 11 — Alarma de inclinación. Si la máquina no se inclinó ni se movió la caja de control, puede ser falsa alarma. Reinicia o desactiva la alarma de inclinación desde la APP/pantalla/control/AtomStack Studio.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bdf89232-328a-49af-ab00-4f445f235f2d.png?v=1760004880:Fig. 1]`,
        },
      ],
    ],
  },
  Swift: {
    nav: [`Preguntas antes de comprar`, `Guía rápida`, `Mantenimiento y cuidado`],
    nav_desc: [
      `Lo que necesitas saber antes de comprar`,
      `Tus primeros pasos, fácil (para principiantes)`,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      // Categoría 1: Preguntas antes de comprar
      [
        {
          Q: `¿Cuál es el área de grabado de la Swift?`,
          A: `El área de grabado es de 300mm × 300mm.`,
        },
        {
          Q: `¿Qué grosor de madera puede cortar la Swift?`,
          A: `Con el láser de 7W, a 100% de potencia y 120mm/min de velocidad, puede cortar contrachapado de 4mm en una sola pasada.<br/>

  Con el láser de 12W, a 100% de potencia y 110mm/min de velocidad, puede cortar contrachapado de 7mm en una sola pasada.`,
        },
        {
          Q: `¿La Swift puede usar módulos láser de otras máquinas AtomStack?`,
          A: `AtomStack ofrece un módulo láser infrarrojo de 1.8W compatible con la Swift.`,
        },
        {
          Q: `¿La Swift puede grabar o cortar metal?`,
          A: `Puede grabar pequeñas zonas de metal como aluminio anodizado negro, acero inoxidable, hierro galvanizado, etc.<br/>

  Con un módulo láser infrarrojo puede grabar la mayoría de los metales.<br/>

  No se recomienda cortar metal debido a la baja potencia.`,
        },
        {
          Q: `¿La Swift se puede conectar a un ordenador por WiFi?`,
          A: `Sí. Necesitas descargar la versión Beta de AtomStack Studio para usar WiFi. En circunstancias normales, se recomienda la conexión por cable.`,
        },
        {
          Q: `¿La Swift puede grabar objetos como tazas o termos?`,
          A: `Sí. Necesitarás el accesorio rotatorio R6 o R8. Consulta la sección “Conexión de accesorio rotatorio Swift”.`,
        },
        {
          Q: `¿La Swift graba cuero? ¿Qué ajustes se recomiendan?`,
          A: `Sí.<br/>

  Láser de 7W:<br/>

  Grabado de mapa de bits: 10.000mm/min, 30% de potencia<br/>

  Corte de 1mm de cuero: 500mm/min, 100% de potencia<br/>

  Láser de 12W:<br/>

  Grabado de mapa de bits: 10.000mm/min, 20% de potencia<br/>

  Corte de 1mm de cuero: 700mm/min, 100% de potencia`,
        },
        {
          Q: `¿La Swift es compatible con dispositivos rotatorios?`,
          A: `Sí. Por favor consulta la sección “Conexión de accesorio rotatorio Swift”.`,
        },
        {
          Q: `¿Qué cubierta de protección se recomienda para la Swift?`,
          A: `Recomendamos la cubierta protectora FB2.`,
        },
        {
          Q: `¿Qué purificador de aire se recomienda?`,
          A: `Se recomienda el purificador D3. Nota: se debe utilizar junto con una cubierta, como la FB2.`,
        },
        {
          Q: `¿La Swift puede usar aire asistido?`,
          A: `Sí. La Swift cuenta con un sistema de aire asistido dedicado con una boquilla especial. Consulta la sección “Conexión de aire asistido Swift” para más detalles.`,
        },
        {
          Q: `¿Hay panel tipo panal para la Swift?`,
          A: `Sí. El panel panal F2N está disponible, tamaño 350mm × 350mm.`,
        },
        {
          Q: `¿La Swift tiene funciones de seguridad?`,
          A: `Sí. El botón de encendido puede cortar la corriente rápidamente.`,
        },
        {
          Q: `¿Se puede ampliar la Swift?`,
          A: `Sí. Puedes instalar un kit de extensión para ampliar el área de trabajo a 300mm × 600mm.`,
        },
        {
          Q: `¿Qué software de control es compatible con la Swift?`,
          A: `Compatible con:<br/>

  AtomStack Studio<br/>

  AtomStack APP<br/>

  LightBurn<br/>

  No recomendado: LaserGRBL, porque no soporta de forma estable la velocidad 460800 baud, lo que puede causar bloqueos o errores de datos.`,
        },
        {
          Q: `¿Cuál es la temperatura de funcionamiento de la Swift?`,
          A: `Láser de luz azul: 0°C – 35°C<br/>

  Láser infrarrojo: 10°C – 30°C`,
        },
      ],
      // Categoría 2: Guía rápida
      [
        {
          Q: `¿Qué puertos y luces indicadoras hay en el panel de la Swift?`,
          A: `El panel de la Swift incluye:<br/>

  1. Puerto de alimentación: Entrada 24V 1.5A (7W) o 24V 2A (12W)<br/>

  2. Puerto Type-C: Conexión con ordenador<br/>

  3. Puerto de accesorios: Conexión a dispositivos rotatorios (requiere cable adaptador USB)<br/>

  4. Botón de encendido: Mantener pulsado 5 segundos para ingresar al modo de configuración WiFi<br/>

  5. Indicadores luminosos:<br/>

  Blanco: Fijo = Espera; Parpadeando = Configuración WiFi<br/>

  Verde: Fijo = Conectado a WiFi; Parpadeando = Pausa<br/>

  Azul: Fijo = Funcionando<br/>

  Rojo: Fijo = Alarma<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_14a0a109-c645-494f-90d8-2c35069f81dd.png?v=1764732359:Fig. 1]`,
          video_url: ['https://youtu.be/ZoAOg78NhxQ'],
        },
        {
          Q: `¿Cómo instalar la Swift?`,
          A: `Consulta el video de instalación o el manual de usuario.<br/>

  Notas:<br/>

  No aprietes demasiado los tornillos.<br/>

  Al instalar el eje óptico de unión, asegúrate de que el eje X esté paralelo a los marcos superior e inferior antes de apretar los tornillos de acoplamiento.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_7c92a86b-2dca-403e-b871-4e27e18db4f6.png?v=1764732829:Fig. 1]`,
          video_url: ['https://youtu.be/sguqSunzygM'],
        },
        {
          Q: `¿Cómo conectar la Swift y elegir software?`,
          A: `(1) Opciones de software:<br/>

  Recomendado: AtomStack Studio, LightBurn<br/>

  Móvil: Descarga AtomStack APP<br/>

  Descarga de AtomStack Studio: /pages/atomstack-studio-software<br/>

  Descarga de LightBurn: https://lightburnsoftware.com/pages/download-trial<br/>

  (2) Configuración del área de grabado:<br/>

  En AtomStack Studio, selecciona el modelo correcto y el área de grabado se configura automáticamente.<br/>

  En LightBurn, configura manualmente el área de grabado a 300mm × 300mm, o importa el archivo de configuración desde la tarjeta TF.<br/>

  (Consulta el video “Importación de archivo de configuración Swift”.)<br/>

  (3) Notas del sistema (usuarios Mac):<br/>

  Los usuarios de Mac no deben conectarse directamente mediante el puerto Type-C.<br/>

  Utiliza un hub adaptador y conecta a través del puerto USB-A.<br/>

  (4) Elección del cable Type-C:<br/>

  Cables no originales o solo de carga pueden causar fallos de conexión.<br/>

  Asegúrate de que el cable soporte transferencia de datos.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1d2fc041-4779-4fe4-9067-c40fe2186f17.png?v=1764733068:Fig. 1]`,
          video_url: ['https://youtu.be/WSn0kQ7caKo'],
        },
        {
          Q: `¿Cómo reemplazar el módulo láser de la Swift?`,
          A: `El láser utiliza un módulo de enfoque fijo situado en la parte inferior lateral del láser.<br/>

  El láser se fija mediante un tornillo manual en "L", haciendo que el ajuste de enfoque sea más rápido y fácil.<br/>

  Si el tornillo está bloqueado por el eje óptico, tira del mango hacia afuera para poder girarlo libremente.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1bac7557-7bb3-47e0-adfa-74b32b9f6e61.png?v=1764733364:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9bc4b47e-4b87-4826-aa73-82887bb30cd2.png?v=1764733364:Fig. 2]`,
          video_url: ['https://youtu.be/n3y-cGH_6-I', 'https://youtu.be/vaRW93SHC54'],
        },
        {
          Q: `¿Puede la Swift conectarse a aire asistido?`,
          A: `El láser de la Swift no incluye una boquilla de aire, por lo que solo es compatible el F40 Air Assist.<br/>

  El F40 incluye boquillas dedicadas tanto para los láseres de 7W como de 12W, y debe instalarse manualmente.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_57e72572-9b69-4039-8147-4ead6315188c.png?v=1764740746:Fig. 1]`,
          video_url: ['https://youtu.be/jB3rUCI9Ruo'],
        },
        {
          Q: `¿Puede la Swift conectarse a un dispositivo rotatorio?`,
          A: `Selección de rotatorio:<br/>

  La Swift utiliza elevadores roscados, por lo que se recomiendan los dispositivos rotatorios R6, R8 y R8 PRO.<br/>

  Conecta el cable USB incluido al puerto de accesorios para reconocimiento automático.<br/>

  Si utilizas R1, R1 Pro, R2, R3 Pro, R1-B o R2-B:<br/>

  Debes apagar la máquina, desconectar el cable del motor del eje Y y seguir el procedimiento de conexión en secuencia.<br/>

  Advertencia: asegúrate de que el equipo esté completamente apagado antes de desconectar cables para evitar cortocircuitos.<br/>

  Los pies elevadores por defecto pueden no funcionar en rotatorios de primera generación. Usa cuatro objetos de igual altura para elevar la Swift.<br/>

  Configuración en AtomStack Studio:<br/>

  Selecciona el dispositivo rotatorio detectado.<br/>

  R6 (rodillo): no requiere cambios de parámetros.<br/>

  R8 (mandril): requiere definir la circunferencia o el diámetro del material.<br/>

  Configuración en LightBurn:<br/>

  Establece los parámetros de rotatorio manualmente:<br/>

  Tipo de rotatorio: Rodillo para R6, Mandril para R8<br/>

  Eje rotatorio: Eje Y<br/>

  R8 (mandril):<br/>

  Pasos por vuelta: fijo en 160mm/vuelta<br/>

  Ingresa diámetro o circunferencia<br/>

  R6 (rodillo):<br/>

  Pasos por vuelta: 50mm/vuelta<br/>

  Diámetro de rodillo: 16mm (fijo)<br/>

  Ingresa diámetro o circunferencia<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_139d4840-fa5c-4f78-9742-df6c91daf409.png?v=1764741423:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ac9301ac-a493-4fe3-9188-5fe1fc043746.png?v=1764741422:Fig. 2]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_e7d99974-9864-475f-8932-8a0518a5d68e.png?v=1764741423:Fig. 3]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2452233f-cfc6-4850-9205-e8656d8c4f4b.png?v=1764741423:Fig. 4]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_18647c18-87fa-4d03-ae71-4d1a1594cbc2.png?v=1764741423:Fig. 5]`,
          video_url: ['https://youtu.be/MjLYdcqnZFo'],
        },
        {
          Q: `¿Cómo ajustar el enfoque de la Swift?`,
          A: `Cada láser tiene una perilla de enfoque fijo.<br/>

  Gira la perilla completamente en la dirección de la flecha.<br/>

  Cuando el punto más alto de la perilla toque la superficie del material, ajusta la altura del láser y luego afloja levemente la perilla para terminar el enfoque.<br/>

  La distancia final de enfoque es 4mm.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6714535-7c50-41a3-8067-99bd188f703e.png?v=1764742569:Fig. 1]`,
          video_url: ['https://youtu.be/lBVm3z1xILQ'],
        },
        {
          Q: `¿Qué hacer si el tornillo láser en "L" está bloqueado?`,
          A: `Si el tornillo en "L" está bloqueado, tira del mango hacia afuera y gíralo a otra posición.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_257203a7-be5f-410b-aa7f-6d99c6e642c7.png?v=1764744372:Fig. 1]`,
          video_url: ['https://youtu.be/lBVm3z1xILQ'],
        },
        {
          Q: `Resumen del sistema de coordenadas del software`,
          A: `Posición actual:<br/>

  Usa la posición actual del láser como el punto de inicio. Puedes mover el láser manualmente a cualquier posición deseada.<br/>

  Origen del usuario:<br/>

  Un punto de inicio personalizado establecido por el usuario.<br/>

  Coordenadas absolutas:<br/>

  Usa el punto "home" (0,0) como el origen.<br/>

  La posición del material en el área de trabajo determina la ubicación de inicio.<br/>

  <br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_3ea0b963-8bdb-41ed-b2dd-8fc5e74bef47.png?v=1764744974:Fig. 1]<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_98a553e6-71b5-4a2f-9942-c74e63a99e9d.png?v=1764744974:Fig. 2]`,
          video_url: ['https://youtu.be/ojRNaf4txn8'],
        },
        {
          Q: `Parámetros de grabado en software`,
          A: `La prueba de parámetros de grabado requiere: LightBurn versión 1.3.01 o superior, o AtomStack Studio.`,
        },
      ],
      [
        {
          Q: `¿Cómo limpiar la lente de ventana y la lente de enfoque del módulo láser Swift?`,
          A: `Accesorios de limpieza:<br/>

  Módulo láser de 7W: No tiene lente de enfoque ni lente de ventana desmontable, por lo que solo es necesario limpiar la superficie de la lente interna del tubo láser.<br/>

  Módulo láser de 12W: Tiene tanto una lente de enfoque como una lente de ventana. Puedes quitar la lente de ventana para limpiarla y también revisar si ambas lentes están dañadas.<br/>

  Método de limpieza:<br/>

  Usa etanol anhidro al 99% o un limpiador de lentes ópticas profesional (evita productos que contengan amoníaco o acetona).<br/>

  Limpia suavemente con un paño sin pelusa en una sola dirección (por ejemplo, del centro hacia fuera en espiral). Evita movimientos de vaivén que puedan rayar.<br/>

  Tras limpiar, inspecciona la superficie de la lente bajo luz lateral fuerte para asegurarte de que no hay residuos ni fibras.<br/>

  Frecuencia de limpieza:<br/>

  Usuarios de uso frecuente: limpiar una vez al día.<br/>

  Usuarios de uso poco frecuente: limpiar una vez a la semana.`,
          video_url: ['https://youtu.be/rCgK4zlsgIU'],
        },
        {
          Q: `¿Cómo limpiar el polvo dentro del módulo láser Swift?`,
          A: `Componentes a limpiar: Ventilador del módulo láser, placa controladora y disipador térmico del tubo.<br/>

  Método de limpieza: Primero cepilla el polvo superficial. Luego limpia con etanol anhidro al 99% y un paño sin pelusa.<br/>

  Frecuencia de limpieza: Limpiar cuando las aspas del ventilador estén visiblemente cubiertas de polvo.`,
          video_url: ['https://youtu.be/rCgK4zlsgIU'],
        },
        {
          Q: `¿Cómo limpiar el bastidor de la Swift?`,
          A: `Componentes a limpiar: Polvo en los rieles guía de los ejes X e Y.<br/>

  Método de limpieza: Usa un cepillo suave para eliminar polvo y residuos de los rieles para evitar obstrucciones durante el funcionamiento.<br/>

  Frecuencia de limpieza:<br/>

  Ambientes polvorientos: limpiar una vez por semana.<br/>

  Ambientes limpios: limpiar una vez al mes.`,
          video_url: ['https://youtu.be/1CL4vSDQWDU'],
        },
        {
          Q: `¿Cómo limpiar el Air Assist de la Swift?`,
          A: `Razón para limpiar: Evitar que el polvo bloquee la entrada de aire de la bomba, lo que podría causar sobrecalentamiento y daño.<br/>

  Método de limpieza: Retira la tapa exterior, luego limpia el polvo interno usando un cepillo, paño sin pelusa y alcohol siguiendo el video tutorial.<br/>

  Frecuencia de limpieza:<br/>

  Ambientes polvorientos: una vez al mes.<br/>

  Ambientes poco polvorientos o de uso poco frecuente: una vez cada tres meses.`,
          video_url: ['https://youtu.be/vgIegZDZ8wQ'],
        },
        {
          Q: `¿Cómo almacenar la Swift cuando no se usa durante mucho tiempo?`,
          A: `Si la máquina no se va a utilizar durante un periodo prolongado, guárdala en un ambiente seco.<br/>

  Se recomienda encender la máquina y hacerla funcionar durante 5 minutos una vez al mes para prolongar la vida útil de los componentes electrónicos.`,
        },
        {
          Q: `¿Cómo resolver un rendimiento de corte severamente reducido del módulo láser Swift?`,
          A: `(!) Atenuación de potencia normal:<br/>

  Los módulos láser pierden potencia con el tiempo. Esto puede compensarse aumentando la potencia o disminuyendo la velocidad de corte.<br/>

  (2) Verifica el enfoque del láser:<br/>

  Reenfoca usando la perilla de enfoque fijo en la parte inferior del módulo láser.<br/>

  La altura correcta de enfoque es 4 mm (distancia desde el marco inferior del módulo láser hasta el material).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1bac7557-7bb3-47e0-adfa-74b32b9f6e61.png?v=1764733364:Fig. 1]
  (3) Verifica los parámetros de configuración:<br/>

  Asegúrate de que tus ajustes coinciden con la tabla de parámetros recomendada.<br/>

  Asegúrate de que la unidad de velocidad sea mm/min.<br/>

  Para ver la tabla de parámetros de la Swift:<br/>

  ① Escanea el código QR en la máquina.<br/>

  ② Visita la página oficial de soporte: [link:/pages/product-support:atomstack.com/pages/product-support]<br/>

  ③ Contacta al servicio de atención al cliente.<br/>

  (4) Verifica el valor S máximo en el software:<br/>

  Si usas LightBurn, asegúrate de que el valor S máximo sea 1000 y que no se haya modificado.<br/>

  No cambies el valor 1000.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/2_169dd1ff-59b5-49e5-8cd5-eb6189fea669.jpg?v=1764817965:Fig. 2]
  (5) Verifica si hay obstrucción en la boquilla de aire:<br/>

  Si usas el air assist F40 con la guía de aire, asegúrate de que esté instalada correctamente y no bloquee la salida del láser.<br/>

  (6) Verifica si las lentes de ventana y de enfoque están sucias o dañadas:<br/>

  Desconecta la energía, retira el módulo láser e inspecciona las lentes.<br/>

  Si están sucias, consulta la sección “Limpieza de lente de ventana y de enfoque”.<br/>

  (7) Verifica la salida del adaptador:<br/>

  Usa un multímetro (modo DC) para medir si el adaptador da 24V 1.5A (7W) o 24V 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:Fig. 3]
  (8) Verifica voltaje en el conector del módulo láser:<br/>

  Desconecta el cable láser.<br/>

  Ejecuta una tarea de corte a 100% potencia y 1 mm/min.<br/>

  Mide el voltaje en los pines:<br/>

  Pines 1–2: deben marcar 24V<br/>

  Pines 2–3: deben ser ≥1V (ver Fig. 18)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/4_4df4fe2e-1f31-476a-992e-2e1ef753bd7e.jpg?v=1764818349:Fig. 18]
  Si:<br/>

  1–2 < 20V o 0V,<br/>

  2–3 < 1V o 0V,<br/>

  entonces indica fallo en la placa madre o en el cable.<br/>

  Envía al servicio técnico:<br/>

  Un video de fallo<br/>

  Video de medición de voltaje<br/>

  Foto del número de serie de la máquina (ver Fig. 19)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:Fig. 19]
  Consulta el video de prueba de cable láser y de reemplazo de placa madre.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:Fig]

  (9) Si todo es normal:<br/>

  Si el pin 1–2 ≥ 20V y el pin 2–3 ≥ 1V, entonces el módulo láser sufre una degradación anormal de potencia.<br/>

  Por favor, facilita al servicio técnico un video de corte que muestre:<br/>

  Los parámetros usados<br/>

  El proceso de corte<br/>

  Resultados de corte<br/>

  El código de grabado del módulo láser (ver Fig. 20)<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:Fig. 20]
  Consulta el video de reemplazo del módulo láser Swift.`,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
            'https://youtu.be/yebgo1L04E4',
          ],
        },
        {
          Q: `¿Cómo solucionar el problema si el láser Swift se mueve pero no emite luz?`,
          A: `Soluciones:<br/>

  (1) Verifica el conector del láser:<br/>

  Apaga la máquina, desconecta el conector del láser, vuelve a conectarlo y verifica si el problema se resolvió.<br/>

  (2) Verifica los parámetros del software:<br/>

  Ajusta los parámetros de acuerdo con la tabla de parámetros.<br/>

  Asegúrate de que la opción "Output" (Salida) de la capa esté activada.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/8_75159a23-511c-4e5f-be06-160b4c51b4f8.jpg?v=1764818775:]
  (3) Verifica la salida del adaptador:<br/>

  Mide la salida del adaptador con un multímetro en modo DC.<br/>

  Debe ser 24V, 1.5A (7W) o 24V, 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  (4) Verifica el voltaje del conector del láser:<br/>

  Desconecta el cable del láser, realiza un trabajo de corte al 100% de potencia y 1 mm/min.<br/>

  Mide el voltaje:<br/>

  Pines 1–2: 24V<br/>

  Pines 2–3: ≥1V<br/>

  Si los pines 1–2 < 20V o 0V, o los pines 2–3 < 1V o 0V, puede que exista un fallo de placa madre o cable.<br/>

  Consulta los videos de prueba del conector láser Swift y reemplazo de placa madre.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:]
  (5) Si el problema continúa y el voltaje del conector es normal:<br/>

  El módulo láser podría estar defectuoso.<br/>

  Proporciona al servicio técnico un video de error donde se vean los parámetros configurados, el proceso de corte/grabado y el código de serie del láser.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
          ],
        },
        {
          Q: `¿Cómo solucionar si el láser emite luz pero el ventilador no gira?`,
          A: `Solución:<br/>

  Retira los 4 tornillos en la parte trasera del láser, abre la carcasa, extrae el ventilador y conéctalo al adaptador usando dos cables para probar si gira.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/9_1754199f-d6de-426b-84d9-2154136e1489.jpg?v=1764819423:]
  1. Si el ventilador no gira:<br/>

  El ventilador está defectuoso.<br/>

  Envía el código de serie del láser y un video de prueba al servicio técnico.<br/>

  Consulta el video de reemplazo del ventilador de láser Swift.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  2. Si el ventilador gira normalmente:<br/>

  La placa controladora del láser está defectuosa.<br/>

  Envía el código de serie del láser y el video al servicio técnico.`,
          video_url: ['https://youtu.be/vaRW93SHC54'],
        },
        {
          Q: `¿Cómo solucionar sobrecalentamiento durante el grabado?`,
          A: `Soluciones:<br/>

  1. Comprueba si el ventilador gira durante el grabado:<br/>

  Durante el grabado, observa si el ventilador está girando.<br/>

  Si el ventilador no gira, retira los 4 tornillos, extrae el ventilador y conéctalo directo al adaptador para probar.<br/>

  Si gira con el adaptador, la placa controladora está defectuosa.<br/>

  Si no gira, el ventilador está defectuoso.<br/>

  Envía el código de serie y el video de error al servicio técnico.<br/>

  Consulta los videos sobre reemplazo de plato y ventilador del láser Swift.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/9_1754199f-d6de-426b-84d9-2154136e1489.jpg?v=1764819423:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  2. Comprueba si el ventilador está bien instalado:<br/>

  Observa la etiqueta del centro del ventilador.<br/>

  Si la etiqueta está hacia arriba, el ventilador está mal instalado. Instálalo con la etiqueta hacia abajo, orientada al núcleo del tubo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/10_876bb2bb-d392-4d7d-98d4-12f626a761dc.jpg?v=1764819581:]
  3. Comprueba si las lentes de ventana y enfoque están sucias o dañadas:<br/>

  Lentes sucias o dañadas pueden bloquear la energía del láser y causar sobrecalentamiento.<br/>

  Límpialas o reemplázalas según la sección de limpieza.<br/>

  4. Verifica la limpieza interna:<br/>

  El polvo dentro del láser impide la disipación del calor.<br/>

  Consulta el video de limpieza interna del módulo láser Swift.<br/>

  5. Comprueba la instalación de la guía de aire:<br/>

  Retira la guía de aire y prueba.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/11_70e63b66-e844-430d-9b78-fdc7837e8c2a.jpg?v=1764819626:]
  Si el sobrecalentamiento desaparece, reinstala correctamente la guía de aire.<br/>

  6. Si el problema continúa:<br/>

  Envía video de error y el código de serie al servicio técnico.`,
          video_url: [
            'https://youtu.be/vaRW93SHC54',
            'https://youtu.be/QDbtpBBO75o',
            'https://youtu.be/vaRW93SHC54',
            'https://youtu.be/rCgK4zlsgIU',
          ],
        },
        {
          Q: `¿Qué hacer si la Swift se detiene repentinamente durante el grabado?`,
          A: `Soluciones:<br/>

  Asegúrate de que la alimentación principal sea estable y sin fluctuaciones de voltaje.<br/>

  Verifica que el adaptador y el cable Type-C no se estén moviendo durante el grabado.<br/>

  Prueba otro software: AtomStack Studio, APP o LightBurn.<br/>

  Si el problema no ocurre en la APP pero sí en la computadora, prueba con otro puerto USB o cable Type-C.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/12_b466c8e4-757f-4599-a7b5-ef09596c468d.jpg?v=1764819952:]
  Revisa y actualiza el firmware a través de AtomStack Studio o la APP.<br/>

  Si el problema continúa, facilita al servicio técnico:<br/>

  Pasos verificados<br/>

  Foto del número de serie
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: [
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/5AZ8ojx6KKo',
            'https://youtu.be/yebgo1L04E4',
          ],
        },
        {
          Q: `¿Cómo solucionar grabados claros o débiles?`,
          A: `Soluciones:<br/>

  1. Comprueba la atenuación normal de potencia:<br/>

  Es normal que el láser pierda potencia con el tiempo. Compénsalo aumentando la potencia o reduciendo la velocidad.<br/>

  2. Revisa el enfoque del láser:<br/>

  Reenfoca usando la perilla inferior; altura de enfoque = 4 mm entre el marco inferior del láser y el material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_d6714535-7c50-41a3-8067-99bd188f703e.png?v=1764742569:]
  3. Verifica parámetros y material:<br/>

  Asegúrate de que la configuración coincide con los parámetros recomendados para el material.<br/>

  La unidad de velocidad debe ser mm/min.<br/>

  Consulta la tabla de parámetros: código QR de la máquina, [link:/pages/product-support:atomstack.com/pages/product-support], o servicio técnico.<br/>

  4. Comprueba el valor S máximo en software:<br/>

  En LightBurn, asegúrate de que el valor S máximo sea 1000 y no esté modificado.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/2_169dd1ff-59b5-49e5-8cd5-eb6189fea669.jpg?v=1764817965:]
  5. Revisa lentes sucias o dañadas:<br/>

  Desconecta la energía y revisa las lentes de ventana y enfoque, límpialas si es necesario.<br/>

  6. Verifica la instalación de la guía de aire:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/11_70e63b66-e844-430d-9b78-fdc7837e8c2a.jpg?v=1764819626:]
  Asegúrate de que la guía no bloquee la salida del láser.<br/>

  7. Verifica la salida del adaptador:<br/>

  DC 24V, 1.5A (7W) o 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  8. Revisa el voltaje del conector láser:<br/>

  Pines 1–2 ≥ 20V, pines 2–3 ≥ 1V.<br/>

  Un voltaje bajo indica fallo en la placa madre; facilita video de pruebas, medición y foto de número de serie al soporte.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/5_586c136d-4de3-4335-a38b-f0428eeee9e3.jpg?v=1764818348:]
  9. Si todo es normal pero la salida sigue siendo débil:<br/>

  Poder láser anormalmente bajo.<br/>

  Envía video de corte, parámetros, proceso y código del láser.<br/>

  Consulta el video de reemplazo del láser Swift.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
        },
        {
          Q: `¿Cómo solucionar vibración (temblores) en líneas vectoriales durante el grabado?`,
          A: `Soluciones:<br/>

  Verifica que todos los tornillos de los marcos X y Y estén apretados.<br/>

  Asegúrate de que la velocidad vectorial ≤ 1000 mm/min.<br/>

  Inspecciona las ruedas de POM de los ejes X e Y para daño.<br/>

  Revisa las tuercas excéntricas para correcta tensión; ajusta según el video de ajustes estructurales de la Swift.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Verifica la tensión de la correa dentada; ajusta según el video de reemplazo de correa Swift.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Asegura que los tornillos de la polea del motor estén ajustados; revisa que las distancias del eje X sean uniformes.<br/>

  Revisa nivelación del eje X; ajusta si es necesario.<br/>

  Si el problema continúa, envía video de prueba y foto de número de serie al soporte técnico.`,
          video_url: [
            'https://youtu.be/aTHsp6CX8Us',
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/InPaynvy9rI',
            'https://youtu.be/wIFTLnh8Es8',
          ],
        },
        {
          Q: `¿Cómo solucionar deformación de patrones o líneas abiertas?`,
          A: `Soluciones:<br/>

  Verifica que los tornillos de los marcos X/Y estén apretados.<br/>

  Inspecciona ruedas de POM por daño; envía fotos y número de serie si están defectuosas.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Revisa tuercas excéntricas; ajusta según se describió arriba.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Verifica pasos en LightBurn ($100 y $101 = 100.15).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Activa “Overscan” en el software (LightBurn, AtomStack Studio).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/18_5a6e8be4-38f7-414c-aedc-33da471257b6.jpg?v=1764830160:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/19_60251e84-cb4d-434f-a328-95dc1f075807.jpg?v=1764830160:]
  Verifica que los tornillos de la polea del motor estén apretados.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Asegúrate que los travesaños horizontales y el eje X estén nivelados.<br/>

  Ajusta la tensión de la correa si es necesario.<br/>

  Prueba el movimiento del motor en el software; si la dirección es anormal, actualiza el firmware o intercambia conectores para diagnosticar si es fallo de placa o motor.<br/>

  Si el problema persiste, envía un video de pruebas, parámetros, resultados y número de serie al soporte técnico.

  `,
          video_url: [
            'https://youtu.be/aTHsp6CX8Us',
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/wIFTLnh8Es8',
            'https://youtu.be/InPaynvy9rI',
            'https://youtu.be/IbMC0If7qvM',
            '',
          ],
        },
        {
          Q: `¿Cómo solucionar error al reiniciar la Swift?`,
          A: `Soluciones:<br/>

  1. Verifica que los cables de la placa madre no obstruyan el movimiento:<br/>

  Asegúrate de que todos los cables estén pasados por los sujetacables y no se tiren durante el movimiento.<br/>

  2. El reinicio causa colisión con el marco:<br/>

  Normalmente se debe a fallo en el interruptor de límite. Pulsa manualmente los interruptores X y Y: debes escuchar un "clic" y el software debe mostrar una alarma.<br/>

  Si no hay clic/alarma: revisa el conector del interruptor, desconéctalo y vuelve a conectarlo. Si sigue sin funcionar, graba un video y envía el número de serie al soporte técnico.<br/>

  Si hay clic/alarma pero aún hay colisión: puede deberse a firmware defectuoso. Actualiza el firmware desde AtomStack Studio o la APP, o solicita por el número de serie el firmware correcto para cargar con tarjeta TF.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/23.jpg?v=1764831404:]
  3. Alarma sin movimiento:<br/>

  Usa el software (AtomStack Studio, LightBurn) para mover desde las flechas.<br/>

  Si se mueve normalmente: puede ser un problema de firmware; actualiza desde la APP o solicita el firmware correcto.<br/>

  Si un eje no se mueve o vibra: revisa los conectores del motor, desconéctalos y vuelve a conectarlos. Si sigue sin funcionar, intercambia conectores entre ejes para identificar si el fallo es de cable/placa o motor. Graba un video y envía el número de serie.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  4. Ambos ejes no se mueven:<br/>

  Actualiza el firmware o solicita el correcto.<br/>

  Si sigue sin solución, puede tratarse de fallo de placa o cable. Envía video de pruebas y número de serie. Consulta los videos de reemplazo de placa madre y cables.<br/>

  5. Prueba reinicio de fábrica:<br/>

  En AtomStack Studio versión ≥ 2.20: pulsa 7 veces el número de versión para entrar en Modo Desarrollador, abre "Serial Port Log" y pulsa "Reset".<br/>

  En LightBurn: introduce $RST=* en la consola.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/26.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  `,
          video_url: [
            'https://youtu.be/vr0-nYwbimE',
            'https://youtu.be/IbMC0If7qvM',
            'https://youtu.be/IbMC0If7qvM',
            '',
          ],
        },
        {
          Q: `¿Cómo solucionar si la Swift no enciende?`,
          A: `Soluciones:<br/>

  1. Verifica la salida del adaptador:<br/>

  Debe ser DC 24V, 1.5A (7W) o 24V, 2A (12W).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/3_60c10599-fae4-4627-af94-2b465a802165.jpg?v=1764818203:]
  2. Verifica si hay cortocircuitos:<br/>

  Desconecta todos los cables de la placa madre (limitadores, motores, láser), luego intenta encender.<br/>

  Si enciende: un componente tiene cortocircuito; conecta uno por uno para identificar el fallo.<br/>

  Si sigue sin encender: fallo en placa madre; envía video de pruebas y número de serie a soporte.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `¿Cómo solucionar si la Swift enciende con alarma de luz roja?`,
          A: `Soluciones:<br/>

  Verifica la conectividad: usando AtomStack Studio o LightBurn.<br/>

  Si no conecta: posible fallo de placa madre; envía video y número de serie.<br/>

  Si conecta pero no responde: puede estar en estado de alarma por los interruptores de límite; desconéctalos para probar.<br/>

  Si no es fallo de límite: usa el comando $i en consola para ver los errores, captura pantalla y envíala a soporte.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `¿Cómo solucionar si la Swift no puede conectarse a la computadora?`,
          A: `Soluciones:<br/>

  Asegúrate de que la máquina encienda y la luz blanca esté encendida.<br/>

  Verifica la conexión Type-C según la “Introducción al Panel de Swift”.<br/>

  Reinicia el software e intenta conectar de nuevo.<br/>

  Verifica si la computadora reconoce el puerto COM; instala driver si es necesario:<br/>

  - Enlace driver Windows: https://asa.atomstack.com/downloadWindowsDrivers.do3<br/>

  - Enlace driver Mac: https://asa.atomstack.com/downloadMacDrivers.do3<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/29.jpg?v=1764832282:]
  Asegúrate de que ningún otro software use el puerto.<br/>

  Windows: Type-C directo. Mac: usa hub a puerto Type-C A.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/30.jpg?v=1764832374:]
  Prueba con otro software: AtomStack Studio o LightBurn.<br/>

  Cambia el cable Type-C; si funciona, el original está defectuoso.<br/>

  Prueba con otra computadora.<br/>

  Si el problema continúa, puede ser fallo de placa; facilita video de pruebas y número de serie.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/Ge9sIxBEasA', 'https://youtu.be/08OgANnvVWw'],
        },
        {
          Q: `¿Cómo solucionar si la Swift no puede conectarse a la APP?`,
          A: `Soluciones:<br/>

  Sigue los pasos del video de conexión de la Swift APP.<br/>

  Asegúrate de tener la última versión de la APP: [link:/pages/software-guide:atomstack.com/pages/software-guide] o App Store.<br/>

  Mantente cerca de la placa principal al conectar.<br/>

  Verifica que la WIFI no esté siendo usada por otro dispositivo.<br/>

  Contraseña por defecto: 12345678.<br/>

  Revisa intensidad de la señal WIFI; si es débil cerca de la máquina, el módulo WIFI podría estar dañado; envía video y número de serie.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Prueba con otro móvil; si sigue fallando, envía video y número de serie.`,
          video_url: ['https://youtu.be/WSn0kQ7caKo'],
        },
        {
          Q: `APP de Swift conectada pero no graba`,
          A: `Soluciones:<br/>

  Asegúrate de que la tarjeta TF esté insertada.<br/>

  Verifica los controles del software (movimiento direccional). Reconecta la máquina si es necesario.<br/>

  Verifica que el archivo G-code no supere 100MB.<br/>

  Revisa la tarjeta TF en la computadora; formatea a FAT32 si es necesario.<br/>

  Prueba con otro teléfono; si sigue fallando, envía video y número de serie.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `¿Cómo solucionar saltos o tartamudeo durante el grabado en la Swift?`,
          A: `Soluciones:<br/>

  Retira la tarjeta TF y prueba.<br/>

  Prueba con otro software (AtomStack Studio o LightBurn).<br/>

  Prueba el movimiento de los motores desde las flechas del software:<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  Si se mueven bien, sigue con el siguiente paso.<br/>

  Si un eje falla/vibra: revisa conectores, desconéctalos y reconéctalos; intercambia conectores si es necesario para identificar si es fallo de placa/cable o motor; envía video y número de serie.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Restablecimiento de fábrica: AtomStack Studio → Modo desarrollador → “Reset” o consola LightBurn $RST=*.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  Actualización de firmware: usa AtomStack Studio, APP o solicita el firmware correcto vía número de serie.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/23.jpg?v=1764831404:]
  Si todo está bien y el problema persiste, probablemente es fallo de placa madre; envía video, pasos y número de serie.`,
          video_url: [
            'https://youtu.be/Ge9sIxBEasA',
            'https://youtu.be/08OgANnvVWw',
            'https://youtu.be/QDbtpBBO75o',
            'https://youtu.be/Izlqpqgrh5U',
            'https://youtu.be/IbMC0If7qvM',
          ],
        },
        {
          Q: `Error de dimensiones de grabado Swift`,
          A: `Soluciones:<br/>

  Pasos a revisar: En LightBurn, accede a ajustes de máquina y verifica los pasos del motor $100 y $101—deben ser 100.15. Corrige si es necesario.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Revisa los tornillos de la polea del motor: utilizando una llave hexagonal de 1.5mm, asegúrate de que ambas poleas estén firmes. Al apretar, mantén la misma distancia entre extremos del eje X y los perfiles horizontales.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/15_656a4501-25f0-43bd-90c2-8fa6d819a0d3.jpg?v=1764829755:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/16_8442021e-fd56-42a7-a4cc-f549c1b4a2fa.jpg?v=1764829755:]
  Ajuste estructural: sigue el video de ajuste estructural Swift, enfocándote en correas y poleas.<br/>

  Restablecimiento de fábrica:<br/>

  AtomStack Studio ≥ 2.20: pulsa 7 veces en el número de versión → Modo desarrollador → "Serial Port Log" → Reset.<br/>

  Consola de LightBurn: introduce $RST=*.<br/>

  Actualización de firmware: actualiza desde Studio, APP, o solicita el firmware correcto vía tarjeta TF enviando el número de serie.<br/>

  Si el problema persiste: probablemente es fallo de placa; envía video de error y número de serie.`,
          video_url: ['https://youtu.be/opUuJ_wYR1M'],
        },
        {
          Q: `Eje X o Y de la Swift no se mueve o hace ruido`,
          A: `Soluciones:<br/>

  Prueba el movimiento desde las flechas del software (AtomStack Studio, LightBurn).<br/>

  Si un eje falla o vibra:<br/>

  Revisa conectores de motor; desconéctalos y vuelve a conectar.<br/>

  Intercambia conectores entre el eje funcional y el defectuoso para determinar si es motor o placa/cable.<br/>

  Envía video de comprobación y número de serie.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/20_e19a92de-654b-49b8-96bc-42f3a1ed40b1.jpg?v=1764831403:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/21.jpg?v=1764831404:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/24.jpg?v=1764831705:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `Los bordes de corte de la Swift se queman (negros o amarillos)`,
          A: `Soluciones:<br/>

  Usa air assist: Requerido para cortes; recomendamos el AtomStack F40.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/31.jpg?v=1764833528:]
  Verifica el enfoque del láser: ajusta la perilla; altura de enfoque = 4mm desde la superficie del material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/32.jpg?v=1764833678:]
  Utiliza base panalada: se recomienda AtomStack F2N.<br/>

  Verifica el grosor del material: sigue los parámetros recomendados.<br/>

  Revisa los parámetros de corte: potencia excesiva / velocidad muy baja puede quemar los bordes. Consulta la tabla por QR, web o servicio técnico.<br/>

  Limpia lente de ventana y enfoque: si está sucia o dañada.<br/>

  Verifica la potencia del láser: ajústala según tabla y considera desgaste. Si persiste, manda video y código del láser al soporte.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/7_c29efe61-c933-4a4a-95f9-940bd4223ace.jpg?v=1764818607:]
  `,
        },
        {
          Q: `El grabado Swift sale áspero`,
          A: `Soluciones:<br/>

  Revisa ruedas de POM: inspecciona las 9 por deformación/daño; proporciona fotos y número de serie si están defectuosas.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  Revisa tornillos de los extremos del eje X: aprieta si están flojos.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/34.jpg?v=1764833820:]
  Verifica el movimiento del soporte del eje X: ajusta alineación y tuercas excéntricas si está flojo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/14_3f8f79c2-be41-47ed-a62b-ac3df5b7f78d.jpg?v=1764829611:]
  Revisa la tensión de la correa dentada: ajusta si está floja.`,
          video_url: [
            'https://youtu.be/opUuJ_wYR1M',
            'https://youtu.be/wIFTLnh8Es8',
            'https://youtu.be/InPaynvy9rI',
          ],
        },
        {
          Q: `La detección de llamas de la Swift no funciona`,
          A: `Soluciones:<br/>

  Asegúrate de que la función de detección de llamas esté activa (AtomStack Studio o APP).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/22.jpg?v=1764831404:]
  Mantén el sensor limpio; límpialo con paño sin pelusa + etanol.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/35.jpg?v=1764833916:]
  Si persiste: el sensor puede estar dañado; facilita video, código láser y número de serie al soporte.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
        },
        {
          Q: `Alarma de llama falsa en la Swift`,
          A: `Soluciones:<br/>

  Reduce densidad de líneas o sube la velocidad / baja la potencia.<br/>

  Para MDF, desactiva la detección de llamas si hay falsas alarmas recurrentes.<br/>

  Ajusta sensibilidad en LightBurn o LaserGRBL:<br/>

  $fire_alarm/overflow_value=15 → recuento de activación<br/>

  $fire_alarm/threshold_value=74 → umbral de llama<br/>

  Siempre supervisa la máquina durante la operación.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/36.jpg?v=1764833981:]
  `,
        },
        {
          Q: `Problemas si usas el software LaserGRBL con la Swift`,
          A: `Solución:<br/>

  No se recomienda; la velocidad por defecto de 460800 causa errores y fallas de funcionamiento.`,
        },
        {
          Q: `Patrones de grabado aparecen espejados usando el rotatorio`,
          A: `Soluciones:<br/>

  Revisa la configuración de espejo en el software; actívala/desactívala según sea necesario (AtomStack Studio, LightBurn).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/37.jpg?v=1764834087:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/38.jpg?v=1764834089:]
  Si no se soluciona: reinicia a valores de fábrica $RST=* o vuelve a cargar el firmware; solicita el adecuado si es necesario.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  `,
        },
        {
          Q: `El accesorio rotatorio de la Swift no funciona`,
          A: `Soluciones:<br/>

  Confirma la conexión:<br/>

  R6/R8/R8 PRO: usa el cable USB que viene de fábrica.<br/>

  R1/R1 Pro/R2/R3 PRO/R1-B: usa el cable de conexión secuencial al motor del eje Y.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ac9301ac-a493-4fe3-9188-5fe1fc043746.png?v=1764741422:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_e7d99974-9864-475f-8932-8a0518a5d68e.png?v=1764741423:]
  Confirma parámetros:<br/>

  AtomStack Studio: R6 rollo → sin parámetros, R8 mandril → introduce diámetro/circunferencia del material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_2452233f-cfc6-4850-9205-e8656d8c4f4b.png?v=1764741423:]
  LightBurn: selecciona tipo de accesorio rotatorio (rotary), eje Y e introduce parámetros (R8: 160mm/vuelta; R6: 50mm/vuelta, diámetro 16mm).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_18647c18-87fa-4d03-ae71-4d1a1594cbc2.png?v=1764741423:]
  Comprueba movimiento: si es anómalo, conecta el motor rotatorio al conector del eje Y y prueba; envía video y foto de etiqueta del modelo rotatorio.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/39.jpg?v=1764834362:]
  `,
          video_url: ['https://youtu.be/aVtrXUHuRvI', 'https://youtu.be/MjLYdcqnZFo'],
        },
        {
          Q: `La Swift colisiona con el marco durante la detección de bordes o grabado`,
          A: `Soluciones:<br/>

  ◆ Verifica el tamaño del archivo: El área de grabado Swift es 300 mm × 300 mm. Si el archivo es mayor, podría chocar con el marco.<br/>

  ◆ Confirma el sistema de coordenadas: Si usas modo de posición actual, verifica que haya espacio para el diseño moviendo manualmente el láser o selecciona coordenadas absolutas.<br/>

  ◆ Verifica los valores de pasos del motor: En LightBurn o LaserGRBL, ve a "Editar → Configuración de Máquina", haz doble clic en "Outputs Setup" y verifica si $100 y $101 son 100 y 150. Corrige si no coincide (ver Figura 112).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/17_107fac4a-e39d-43bf-8f73-67d934c256fa.jpg?v=1764830161:]
  Restaurar valores de fábrica: AtomStack Studio o en consola de LightBurn $RST=*.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/28.jpg?v=1764831843:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/27.jpg?v=1764831774:]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/25.jpg?v=1764831774:]
  `,
        },
        {
          Q: `La Swift no reconoce tarjeta TF`,
          A: `Soluciones:<br/>

  Asegúrate de que la tarjeta TF esté insertada.<br/>

  Verifica la integridad de la tarjeta TF en un ordenador.<br/>

  Prueba con otra tarjeta TF.<br/>

  Si sigue fallando: la placa madre puede necesitar reemplazo; envía número de serie y video.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]`,
        },
        {
          Q: `¿Cómo reemplazar piezas de plástico dañadas en la Swift?`,
          A: `Soluciones:<br/>

  Facilita fotos de los daños y número de serie. El servicio técnico te guiará con el reemplazo; consulta el video de reemplazo de piezas plásticas de la Swift.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/6_44baf0cf-c076-4016-b73b-e6ad395844c0.jpg?v=1764818348:]
  `,
          video_url: ['https://youtu.be/kMPO_u0odD0'],
        },
      ],
 
    ],
  },
  Hurricane: {
    nav: [`Preguntas antes de la compra`, `Inicio Rápido`, `Mantenimiento y Cuidado`],
    nav_desc: [
      `Lo que debes saber antes de comprar`,
      `Tus primeros pasos hechos simples (para principiantes)`,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      // Categoría 1: Preguntas antes de la compra
      [
        {
          Q: `¿Puede Hurricane cortar acrílico transparente? ¿De qué grosor?`,
          A: `Sí, puede cortar acrílico transparente. A 100% de potencia y una velocidad de 50mm/min, puede cortar hasta 20mm de grosor en una sola pasada.<br/>
  
  Nota: El corte de acrílico produce vapores fuertes. Usa el purificador AtomStack D4 o ventila el escape al exterior.<br/>
`,
        },
        {
          Q: `¿Cuál es el área de grabado de Hurricane?`,
          A: `El área estándar de grabado es de 500mm × 300mm.<br/>
  
  Con el accesorio transportador R7, puede alcanzar 500mm × 800mm. (Ver sección “Accesorio Transportador Hurricane”).<br/>
`,
        },
        {
          Q: `¿Puede Hurricane cortar vidrio transparente?`,
          A: `No, cortar vidrio con láser de CO2 puede hacer que se rompa. El grabado sí es posible.`,
        },
        {
          Q: `¿Qué grosor de material puede grabar Hurricane?`,
          A: `Con la bandeja y el panel de panal en su lugar, el grosor máximo es de 25mm.<br/>
  
  Si se retiran y la máquina está elevada, el grosor es teóricamente ilimitado.<br/>
`,
        },
        {
          Q: `¿Se puede expandir Hurricane para grabar materiales más grandes?`,
          A: `Sí, el accesorio transportador R7 permite un área máxima de 500mm × 800mm.`,
        },
        {
          Q: `¿Purificador de aire recomendado y tamaño de la brida del ventilador?`,
          A: `Purificador recomendado: AtomStack D4.<br/>
  
  Diámetro de la brida del ventilador: 75mm.<br/>
`,
        },
        {
          Q: `¿Velocidad del ventilador y eficiencia de eliminación de polvo/humo?`,
          A: `Velocidad del ventilador: 6500 RPM, suficiente para eliminar eficientemente el humo y polvo internos.`,
        },
        {
          Q: `¿Nivel de protección y aislamiento de gases peligrosos?`,
          A: `Diseño cerrado, certificado IEC/EN60825-1 Clase 1, aísla eficazmente los gases y humos tóxicos cuando se usa con el purificador D4 o con ventilación exterior.<br/>
`,
        },
        {
          Q: `¿Con qué frecuencia se debe cambiar el agua del tanque?`,
          A: `Llena el agua hasta el MÁXIMO cuando llegue al MÍNIMO.<br/>
  
  Cámbiala cada 200 horas de operación o si el agua está sucia.<br/>
  
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b634f808-ad89-4ed8-8a0a-e17cdaaae1f2.png?v=1766484100:Fig. 1]`,
        },
        {
          Q: `¿Temperatura de funcionamiento recomendada?`,
          A: `De 5°C a 35°C.<br/>
  
  No utilizar en condiciones de congelación.<br/>
`,
        },
        {
          Q: `¿Se requiere anticongelante en ambientes fríos?`,
          A: `Sí, si la temperatura es <5°C, usa anticongelante no corrosivo. Proporción de mezcla: [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_611a7346-0f46-43ad-9401-4435c3e7c032.png?v=1766484307:Fig. 1]`,
        },
        {
          Q: `¿Puede cortar o grabar cuero? ¿Configuración recomendada?`,
          A: `Sí. Para cuero de 3mm, se recomienda: 80% de potencia, 800mm/min.`,
        },
        {
          Q: `¿Puede operarse mediante aplicación móvil?`,
          A: `Sí, mediante la APP AtomStack, disponible con código QR o en el sitio web de AtomStack.`,
        },
        {
          Q: `¿Puede grabar tazas o botellas de acero inoxidable?`,
          A: `Sí, utilizando los accesorios rotatorios R6, R8 o R8 PRO junto con el elevador H3.`,
        },
        {
          Q: `Software compatible:`,
          A: `1. AtomStack Studio (PC, gratuito, biblioteca oficial)<br/>
  
  /pages/atomstack-studio-software<br/>
  
  2. LightBurn (requiere baud rate 460800 o archivo de configuración desde USB; de pago)<br/>
  
  3. LaserGRBL (no recomendado por problemas de desconexión)<br/>
  
  4. APP AtomStack (móvil, biblioteca gratuita)<br/>
  
  /pages/atomstack-studio-software<br/>
`,
        },
        {
          Q: `¿Asistencia de aire y niveles de ruido?`,
          A: `Flujo de aire: ≥30 L/min<br/>
  
  Ruido ambiental: 45 dB<br/>
  
  Ruido de la máquina: 66 dB<br/>
`,
        },
        {
          Q: `¿Es fácil reemplazar las piezas de repuesto?`,
          A: `Sí, diseño modular e incluye videos instructivos.`,
        },
        {
          Q: `¿Recorrido máximo del eje Z?`,
          A: `Autoenfoque: 40mm<br/>
  
  Manual: 43mm<br/>
`,
        },
        {
          Q: `¿Distancia mínima a la pared con transportador R7?`,
          A: `Al menos 510mm para evitar colisiones.`,
        },
        {
          Q: `¿Vida útil del tubo láser?`,
          A: `10.000 horas, siempre que haya suficiente agua y se mantenga un nivel adecuado.`,
        },
        {
          Q: `Ventajas de Hurricane sobre otras marcas:`,
          A: `Alta potencia: láser CO2 de 55W, 10.6μm, corta/graba acrílico, vidrio, acero inoxidable, madera, cuero, etc.<br/>
  
  Posicionamiento con cámara: posicionamiento visual total de 5MP.<br/>
  
  Detección de llamas: se detiene y activa alarma automáticamente al detectar fuego.<br/>
  
  Supresión activa de fuego: rocía agua desde un depósito conectado por el usuario al detectar fuego.<br/>
  
  Accesorios variados: compatible con rotatorio, transportador (hasta 500mm × 800mm).<br/>
  
  Ajuste óptico fácil: indicador luz roja para alineación segura y precisa.<br/>
  
  Rápido: Hasta 600mm/s de velocidad de grabado.<br/>
  
  Recuperación ante corte eléctrico: reanuda el trabajo tras una pérdida de energía sin perder el progreso.<br/>
  
  Display de temperatura: monitoriza temperatura del agua y de la máquina.<br/>
  
  Seguridad: se detiene si se abre la tapa o se retira el cajón; certificado láser Clase 1.<br/>
  
  Luces indicadoras de estado: muestra claramente el estado de la máquina.<br/>
  
  Procesos por lote: graba todas las piezas de trabajo simultáneamente.<br/>
  
  Compatibilidad de software: perfecto con AtomStack Studio, APP y LightBurn.<br/>
`,
        },
      ],
      // Category 2: Quick Start
      [
        {
          Q: `Guía de Seguridad de Hurricane`,
          A: `Antes de operar el Hurricane, asegúrese de haber leído y comprendido todas las instrucciones de seguridad y procedimientos de operación. Siga estas pautas para un uso seguro y correcto:<br/>

  Revisión antes de usar: Inspeccione la máquina para detectar cualquier daño antes de cada uso. No opere si se encuentran defectos. Llene el tanque de agua hasta la línea MAX antes de encender. Operar con el agua por debajo de la línea MIN puede provocar la explosión del tubo láser.<br/>

  Entorno de trabajo: Mantenga el área de trabajo limpia y organizada.<br/>

  No modificar: No desmonte, modifique ni altere el dispositivo o su sistema operativo.<br/>

  Supervisión: Siempre supervise la máquina durante su funcionamiento.<br/>

  Limpieza: Elimine escombros y residuos con regularidad, ya que el material acumulado puede suponer un peligro de incendio.<br/>

  Temperatura de funcionamiento: Use entre 5°C y 35°C. No utilice en condiciones de congelación.<br/>

  Integridad del dispositivo: Nunca opere con componentes retirados, ya que esto puede exponer el sistema láser y aumentar el riesgo.<br/>

  Restricción de materiales: Evite PVC, vinilo o materiales que contengan cloro, que producen vapores corrosivos y pueden dañar el equipo. Los daños por tales materiales no están cubiertos por la garantía. No corte ni grabe materiales desconocidos.<br/>

  Supervisión adicional: Nunca deje la máquina desatendida. Asegúrese de que funcione normalmente en todo momento.<br/>

  Materiales reflectantes: No procese materiales altamente reflectantes, ya que pueden dañar irreversiblemente la unidad.<br/>
`,
        },
        {
          Q: `Descripción del Panel de Control de Hurricane`,
          A: `1. Botón de Reinicio/Pausa: Durante el grabado, presione este botón para pausar la máquina. Después de cerrar la puerta, presione nuevamente para reanudar el trabajo. Si ocurre una alarma, primero resuélvala y luego pulse este botón para devolver la máquina al estado de espera normal.<br/>

  2. Botón de Autoenfoque: Después de colocar el material, pulse este botón para enfocar automáticamente en el material actual.<br/>

  3. Puerto de llenado de agua: Añada agua de enfriamiento al tanque a través de este puerto.<br/>

  4. Botón de parada de emergencia: Presione en caso de emergencia para cortar la alimentación y detener la máquina inmediatamente.<br/>

  5. Llave: Inserte la llave y gírela en sentido horario para encender, antihorario para apagar el equipo.<br/>

  6. Interruptor principal, fusible y conexión de energía: Controla el encendido/apagado, el fusible y la conexión del cable de alimentación.<br/>

  7. Entrada de agua para extinción activa de incendios: Conecte aquí el depósito de agua (proporcionado por el usuario) usando la manguera suministrada para la función de extinción activa.<br/>

  8. Puerto USB: Para funcionamiento sin conexión y actualizaciones de firmware.<br/>

  9. Puerto de control por computadora: Conexión de datos para control desde un PC, compatible con cable TYPE-C.<br/>

  10. Puerto para accesorios de expansión: Interfaz para accesorios como mordazas, rodillos y transportadores, con función de reconocimiento automático.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_82a83de9-bd9a-4d7c-991a-b1fc7bf86755.png?v=1766546333:Fig. 1]`,
        },
        {
          Q: `Lista de verificación al desempacar`,
          A: `Siga el video de desempaquetado de Hurricane o el manual.<br/>

  Revise el tubo de CO2 para detectar daños antes de encender el equipo (ver Fig.1).<br/>

  Llene el tanque de agua hasta MAX, encienda la máquina y asegúrese de la circulación adecuada del agua.<br/>

  Tipo de agua: Use agua destilada o purificada. Añada anticongelante no corrosivo si la temperatura ambiente es <5°C.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_4a1cc794-7259-4442-8fd3-ca0dae405cd5.png?v=1766546966:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f92b3023-a2ca-4a23-a82c-89a8bce73365.png?v=1766546966:Fig. 2]`,
          video_url: ['https://youtu.be/1wjI3lU64vY'],
        },
        {
          Q: `Conexión al PC`,
          A: `Utilice AtomStack Studio para una conexión plug-and-play.<br/>

  Para LightBurn, establezca la velocidad de baudios en 460800 o importe el archivo de configuración desde la unidad USB incluida (ver Fig.1).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_0e393f5a-eed1-4933-a7a7-aaa64168db62.png?v=1766554386:Fig. 1]`,
        },
        {
          Q: `Ajuste de enfoque`,
          A: `(1) Hurricane puede lograr autoenfoque mediante el botón de autoenfoque en el chasis, haciendo clic en el botón de autoenfoque en el software AtomStack Studio, o ingresando [ESP500] en el cuadro de código del software LightBurn. También es posible enfocar manualmente usando una lente de enfoque fijo.<br/>

  (2) Si la distancia focal de autoenfoque no es de 8mm:<br/>

  Si la distancia focal de autoenfoque no es de 8mm, puede ajustarla modificando el código en LightBurn o LaserGRBL. El valor por defecto del parámetro de autoenfoque es 1.5, y el valor de corrección es 1.5 ± el valor de error. Es decir: Cuando el valor real es mayor a 8mm, el valor de corrección se calcula como: 1.5 - (valor real medido - 8).<br/>

  Cuando el valor real es menor a 8mm, el valor de corrección es: 1.5 + (8 - valor real medido).<br/>

  En la consola de LightBurn, ingrese $autoFocus/depth_max_mm = valor de corrección (1.5 ± error) y pulse Enter. Por ejemplo, si la distancia focal real del autoenfoque es 9mm, el valor de corrección es 1.5-1=0.5.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ca8cbcff-07b3-4884-8769-19c496539799.png?v=1766554905:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_fd36403b-7d96-44db-9e98-ccd1b185d209.png?v=1766554907:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_6df70f6e-2456-4acd-b6b4-9c34f1986ad2.png?v=1766554908:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_68aed1c3-d30f-4823-8a59-202b8fe571f3.png?v=1766554905:Fig. 4]`,
          video_url: ['https://youtu.be/2UeKAdzumsU'],
        },
        {
          Q: `Aplicación de la cámara`,
          A: `Consulte el video de uso de la cámara de Hurricane o el manual de instrucciones.<br/>

  Nota:<br/>

  (1) Es obligatorio usar coordenadas absolutas al emplear la cámara.<br/>

  (2) Se requiere calibración antes de usar, y recalibrar después de cambiar materiales con diferente grosor.<br/>

  (3) Al calibrar, asegúrese de que haya suficiente iluminación dentro de la cámara para que la cámara pueda captar claramente el área de trabajo.<br/>

  (4) La cámara y el transportador no se pueden usar simultáneamente.<br/>

  (5) Al calibrar usando LightBurn, acerque la imagen antes de hacer clic en cualquiera de los cuatro puntos para mejorar la precisión.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e5fe479b-df03-401d-a41d-f2c85dee442e.png?v=1766555325:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_ddc4a41e-1c66-463a-908a-ca35d407ef3a.png?v=1766555326:Fig. 2]`,
          video_url: ['https://youtu.be/dMK7afokbNM'],
        },
        {
          Q: `Accesorio Transportador (R7)`,
          A: `Consulte el video de uso del transportador Hurricane o el manual de instrucciones.<br/>

  Nota:<br/>

  (1) El transportador Hurricane tiene función de reconocimiento automático; simplemente inserte el cable USB incluido.<br/>

  (2) No se pueden usar coordenadas absolutas al usar el transportador.<br/>

  (3) El área de grabado se convierte en 500mm*800mm al utilizar el transportador.<br/>

  (4) El modelo del transportador AtomStack es R7.<br/>

  (5) Se requiere una plataforma elevadora H3 (la base de la máquina en el video) al usar el transportador.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_75293a6f-c693-4cd1-8a23-ebfe32df71a8.png?v=1766555862:Fig. 1]`,
          video_url: ['https://youtu.be/gbH-Sz8lMsk'],
        },
        {
          Q: `Accesorios rotatorios (R6/R8/R8 Pro)`,
          A: `Consulte el video o el manual de uso de los accesorios rotatorios de Hurricane.<br/>

  Nota:<br/>

  (1) Todos los accesorios rotatorios de Hurricane tienen reconocimiento automático; simplemente conecte el cable USB incluido para utilizarlos. Los modelos son R6, R8 y R8 Pro.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_c90267ed-5793-414c-9f24-e744fbc1f1b7.png?v=1766557618:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_fb5a1f94-b202-46c0-a70c-d23a31c71213.png?v=1766557616:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_de0689b5-5b1f-4cac-8628-575380544619.png?v=1766557616:Fig. 3]
  (2) No se puede usar coordenadas absolutas con los accesorios rotatorios.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_499311c9-6b56-40bb-b6aa-dd3edaba24e7.png?v=1766557616:Fig. 4]
  (3) Se requiere una elevadora H3 al hacer uso de accesorios rotatorios.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_185f15e3-04a7-423f-9f11-1841521db604.png?v=1766557618:Fig. 5]
  (4) Al utilizar el software AtomStack Studio, no se requiere configuración de parámetros para el rodillo (R6), pero para el chuck (R8) hay que ingresar la circunferencia o diámetro del material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_b23780f7-5d7a-403a-95ad-627a79d52dd2.png?v=1766557618:Fig. 6]
  (5) Al usar LightBurn, es necesario establecer los parámetros de rotación. Seleccione el tipo de rotación (rodillo para R6, chuck para R8), seleccione el eje Y para la rotación, y fije los parámetros. Para R8, establezca la velocidad de rotación en 160 mm/rev (valor fijo) e ingrese el diámetro o circunferencia del material. Para R6, establezca velocidad en 50 mm/rev (fijo), diámetro de rotación en 16 mm (fijo) e ingrese también el diámetro o circunferencia del material.<br/>

  `,
          video_url: ['https://youtu.be/za1Ponzv68c'],
        },
        {
          Q: `Coordenadas del software`,
          A: `Posición actual: El punto de inicio para el grabado es la ubicación actual del láser. Puede mover el láser manualmente a la posición deseada de grabado.<br/>

  Origen del usuario: El usuario configura el punto de inicio del láser. Consulte el video de configuración de origen.<br/>

  Coordenadas absolutas: El punto de inicio es en la posición 0,0.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_5ff443a4-41fe-4352-883b-3b3c5075a7ee.png?v=1766557941:Fig. 1]`,
        },
        {
          Q: `Supresión activa de incendios`,
          A: `(1) El usuario debe proporcionar su propio tanque de agua para extinción de incendios, que se debe conectar a la entrada trasera correspondiente mediante la manguera suministrada, indicada como puerto "7" en el panel.<br/>

  (2) Debe estar activada la función automática de extinción de incendios.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_b80bf7df-a8e8-4b1a-a2c5-ff25bb546025.png?v=1766558175:Fig. 1]`,
          video_url: ['https://youtu.be/4cdtLDQ9W8w'],
        },
        {
          Q: `Verificación y ajuste del camino óptico`,
          A: `(1) La calibración del trayecto óptico debe comenzar por el sistema de dos espejos, luego con el de tres espejos y, finalmente, con el conjunto de enfoque.<br/>

  (2) Al mover el espejo hacia arriba, abajo, izquierda o derecha, la posición del punto rojo no debe cambiar significativamente.<br/>

  (3) Un error de ≤2mm entre el punto rojo y el punto láser en la superficie del material grabado se considera normal.<br/>

  (4) Al ajustar el sistema de dos espejos, el sistema de tres espejos debe moverse de izquierda a derecha.<br/>

  (5) Al ajustar el sistema de tres espejos, primero puede apretar levemente un tornillo, luego ajustar el ángulo y finalmente apretar el tornillo.<br/>

  (6) Tras el ajuste óptico, retire las herramientas (reflectores) utilizadas para no quemarlas.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e32f5892-fa4b-4786-ae47-af28019cf696.png?v=1766558853:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_9cdc7b5d-219d-4485-bb2d-d03247f3e7d4.png?v=1766558852:Fig. 2]`,
          video_url: ['https://youtu.be/JiPonHiwV8o'],
        },
        {
          Q: `Prueba de grabado por software`,
          A: `Disponible en AtomStack Studio o LightBurn con licencia (v1.3.01+).`,
          video_url: ['https://youtu.be/sUPmUo3cLwE '],
        },
        {
          Q: `Actualización de software, firmware y APP`,
          A: `AtomStack Studio: Actualización automática o compruebe en "Configuración → Buscar actualizaciones".<br/>

  Firmware: Actualice desde Studio, APP o USB con el número de serie (ver Fig.1).<br/>

  APP: Descárguela desde el sitio web de AtomStack o desde el propio APP en Configuración → Acerca de → Actualizar. Enlace de descarga: /pages/atomstack-studio-software<br/>
`,
          video_url: ['https://youtu.be/eLppYJ8egPc'],
        },
      ],
 
      // Category 3: Maintenance & Care
      [
        {
          Q: `¿Cómo limpiar los espejos y la lente de enfoque de Hurricane?`,
          A: `Consulta el video de limpieza de los espejos y la lente de enfoque de Hurricane.<br/>

  Nota: Método de limpieza: Desconecta la corriente. Utiliza etanol anhidro puro al 99 % o un limpiador profesional para lentes ópticas (evita disolventes con amoníaco o acetona). Limpia suavemente con un paño sin pelusa en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) para evitar rayaduras por fricción de vaivén.<br/>

  Frecuencia de limpieza: Para usuarios con alta frecuencia de uso, se recomienda limpiar semanalmente; para usuarios con baja frecuencia de uso, limpiar mensualmente.<br/>

  Precaución: Si el recubrimiento de la lente se desprende (aparición de manchas moradas/doradas), debe reemplazarse inmediatamente y dejar de usarla.<br/>
`,
          video_url: ['https://youtu.be/hahm4Ierh78'],
        },
        {
          Q: `¿Cómo limpiar y mantener la carcasa de Hurricane?`,
          A: `Consulta el video de limpieza y mantenimiento del modelo Hurricane.<br/>

  Nota: Método de limpieza: Desconecta la corriente. Utiliza etanol anhidro puro al 99 % como agente limpiador. Usa un paño sin pelusa ligeramente humedecido para limpiar el polvo dentro del chasis, incluyendo ventiladores, rieles de los ejes X e Y, rejillas de ventilación, etc.<br/>

  Frecuencia de limpieza: Usuarios con alta frecuencia de uso deben limpiar semanalmente, mientras que usuarios con baja frecuencia de uso deben limpiar mensualmente.<br/>
`,
          video_url: ['https://youtu.be/bgNd-1hbwBg'],
        },
        {
          Q: `¿Cómo almacenar y mantener Hurricane cuando no está en uso?`,
          A: `Si no se va a usar durante un periodo prolongado, drena el agua de enfriamiento del tanque siguiendo el video tutorial de drenaje de Hurricane para evitar que el tanque se humedezca o cause otros problemas.<br/>

  Guarda el equipo en un lugar seco. Evita dejar el equipo en ambientes húmedos por periodos prolongados. Enciende la máquina de grabado periódicamente. Se recomienda hacer funcionar el ventilador durante 10 minutos cada semana para evitar la corrosión de los rodamientos.<br/>
`,
          video_url: ['https://youtu.be/b8x8nefCwis'],
        },
        {
          Q: `¿Cómo solucionar cuando Hurricane no responde al encenderlo?`,
          A: `Verifica si el indicador de encendido se ilumina:<br/>

  Si el indicador se enciende pero no hay pitido y el ventilador no gira, puede ser un fallo en la fuente de alimentación de 24V.<br/>

  Si el indicador no se enciende tras encender, continúa con las siguientes comprobaciones.<br/>

  Revisa la conexión del cable de alimentación:<br/>

  Asegúrate de que está bien enchufado y que la regleta o toma de corriente funciona correctamente.<br/>

  Revisa la llave interruptora:<br/>

  Confirma que la llave esté encendida y completamente girada. Gira la llave varias veces para comprobar contactos defectuosos o giro incompleto.<br/>

  Si se detecta mal contacto, es necesario cambiar la llave interruptora.<br/>

  Revisa el pulsador de parada de emergencia:<br/>

  Presiona y gíralo en la dirección indicada. Al soltar, confirma que salga automáticamente.<br/>

  Si no sale, el pulsador de emergencia está fallando.<br/>

  Verifica si el fusible está fundido:<br/>

  Abre la tapa del portafusibles y revisa si el fusible está intacto.<br/>

  (También puedes usar un multímetro en modo diodo o continuidad para comprobar el fusible).<br/>
`,
          video_url: [
            'https://youtu.be/1LsPjzYvUYI',
            'https://youtu.be/zqpqJSsSKz0',
            'https://youtu.be/54GP6qpWLgQ',
            'https://youtu.be/N0VegXMuonM ',
          ],
        },
        {
          Q: `¿Cómo solucionar problemas de conexión con Hurricane?`,
          A: `(1) Confirma la velocidad en baudios: La velocidad de Hurricane es 460800. Si usas AtomStack Studio, no es necesario configurarla; si usas LightBurn o LaserGRBL (no recomendado), deberás modificarla. Si LightBurn no muestra la velocidad, importa el archivo de configuración de LightBurn que viene en la memoria USB incluida con la máquina. Consulta el video de importación de configuración de LightBurn.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_f6eafd18-a167-4a20-b336-3118a5e1dfd1.png?v=1766561698:Fig. 1]
          (2) Confirma la conexión correcta del cable TYPE-C: Conecta en el puerto correcto. Si usas Mac, no conectes directamente al puerto C del cable TYPE-C; debes conectar por estación dock al puerto A del cable TYPE-C.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_2e046248-d3e4-4ecc-b797-f8e8d6c3ebbe.png?v=1766561699:Fig. 2]
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_70674c57-ab89-417e-86f3-dbf74d06fd73.png?v=1766561700:Fig. 3]
  (3) Confirma si el puerto serie está ocupado: Verifica que otro software no esté conectado ya a Hurricane.<br/>

  (4) Confirma si el puerto serie es reconocido: Ve a "Mi PC — Administrar — Administrador de dispositivos" y comprueba si hay un puerto tipo CH340. Si no aparece, instala primero el driver; contacta con atención al cliente para obtenerlo. Consulta el video de instalación de driver. (5) Verifica que el cable Type-C no esté dañado: Prueba cambiando el cable por otro compatible. Si funciona, el cable anterior estaba defectuoso.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_c1813658-ce52-4d90-a6a4-46479a4c8f4e.png?v=1766561699:Fig. 4]
  (6) Confirma que la computadora no tiene funciones bloqueadas: Prueba conectar el Hurricane a otra computadora y verifica si se conecta a Internet. Si es así, la original puede tener servicios deshabilitados. Se recomienda instalar un sistema operativo profesional o contactar al soporte técnico.<br/>

  (7) Si nada de esto resuelve el problema, proporciona el número de serie a atención al cliente para asistencia.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_9cd9185a-ff18-4782-a135-94c95ae5e9ab.png?v=1766561700:Fig. 5]`,
          video_url: ['https://youtu.be/nRU4EVwlIEY '],
        },
        {
          Q: ` ¿Cómo solucionar si la cámara de Hurricane no funciona?`,
          A: `(1) No la reconoce:<br/>

  ① Confirma que la computadora tiene acceso a la cámara: Abre "Configuración - Privacidad - Cámara - Permitir el acceso a la cámara",<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_22770f59-3684-4278-bc83-6b1e4a9c1886.png?v=1766562690:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_f86e8682-20ca-4149-ba83-b97745df96f2.png?v=1766562692:Fig. 2]
  ② Verifica si el software de cámara de la computadora funciona: Abre la app "Cámara", selecciona "Cambiar cámara - USB Camera". Si ves imagen normalmente, es porque la cámara estaba deshabilitada. Si no funciona o no es reconocida, sigue los pasos siguientes.<br/>

  ③ Confirma el cable TYPE-C está bien conectado: Apaga todo, desconecta el cable, cierra el software, vuelve a conectar y reinicia.<br/>

  ④ Confirma si el driver está correcto: Reinstala el driver del puerto serie. Descárgalo o pide copia a atención al cliente. Consulta el video de instalación de drivers. Enlaces de descarga:<br/>

  -Driver para Windows: https://asa.atomstack.com/downloadWindowsDrivers.do3<br/>

  -Driver para Mac: https://asa.atomstack.com/downloadMacDrivers.do3<br/>

  ⑤ Revisa la conexión del cable de la cámara: Abre la tapa en la cámara y revisa que el conector en la placa madre esté pegado y no flojo. Lo mismo para la tapa superior izquierda del equipo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_42c2d9ee-b590-4d1f-9587-5bed5bce57f5.png?v=1766562692:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_b4f6914d-8f74-4688-847a-7184d8fed7f1.png?v=1766562693:Fig. 4]
  ⑥ Si nada de esto lo soluciona, puede ser avería en la placa madre o la cámara. Envía video de los pasos realizados y foto del número de serie a atención al cliente. Consulta los videos de reemplazo de placa madre y cámara.<br/>

  (2) No puede calibrar:<br/>

  ① Confirma que se usan coordenadas absolutas: Deben estar activadas para usar la cámara.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_2a96b9db-5d9e-423c-a0a6-b2769e60eb95.png?v=1766562691:Fig. 5]
  ② Confirma que la luz dentro de la caja sea suficiente: Si la luz es tenue, la cámara puede fallar, especialmente al calibrar con LightBurn. ③ Confirma que la cámara emite imagen normalmente. Si está normal pero el problema sigue, revisa en punto uno.<br/>

  ④ Confirma que el software esté actualizado (AtomStack Studio).<br/>

  ⑤ Prueba si ocurre con otro software para descartar errores.<br/>

  ⑥ Si nada funciona, contacta a atención al cliente y proporciona captura del número de serie.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_56cbe5ba-f9ba-4e68-88e3-823c9f09ecaa.png?v=1766562694:Fig. 6]`,
          video_url: ['https://youtu.be/_RqKuKrk7bU', 'https://youtu.be/UHzgZq9CDHI'],
        },
        {
          Q: `¿Cómo solucionar errores significativos de posicionamiento de la cámara en Hurricane?`,
          A: `(1) Asegúrate de usar coordenadas absolutas: Son obligatorias al usar la cámara.<br/>

  (2) Requisitos de iluminación para calibración: Asegúrate de tener buena luz en el interior, que las luces del gabinete funcionen y la cámara vea correctamente.<br/>

  (3) Confirma que el grosor del material de grabado sea igual al de la calibración: Si no, recalibra.<br/>

  (4) Evita posicionar cerca del borde del gabinete: La exactitud es mejor cerca del centro y menor en los bordes.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_8e4a361b-f280-4b9f-8d1c-bb770da4ab6d.png?v=1766563127:Fig. 1]`,
        },
        {
          Q: `¿Cómo solucionar problemas de potencia en Hurricane cuando no puede cortar materiales?`,
          A: `(1) Verifica los parámetros de software correctos: Consulta la tabla en [link:/pages/product-support] para los parámetros. Si usas LightBurn, nota que el valor máximo de S es inmodificable (1000).<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_50bec36e-5ce9-41f5-9fb8-130d16fa4ad4.png?v=1766563612:Fig. 1]
  (2) Verifica que los espejos reflectores estén limpios: El 1, 2 y 3, sin polvo ni daño. Hazlo con la máquina apagada. Consulta el video de ajuste del trayecto óptico de Hurricane.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_8a7ab435-180a-4ad7-8049-2e6e36c1f51c.png?v=1766563616:Fig. 2]
  (3) Verifica el enfoque: Tras autoenfoque, la distancia debe ser 8 mm. Debes reenfocar al cambiar de material.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_dd438041-0674-43fd-845d-c6d28e770ce6.png?v=1766563616:Fig. 3]
  (4) Confirma que el panel panal esté plano: Que no haya objetos extra y que el material esté bien nivelado.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_8f285c6c-c7fb-4fd8-afec-b7fad625b1c7.png?v=1766563616:Fig. 4]
  (5) Verifica la limpieza de la boquilla de aire: La suciedad puede reducir potencia. Límpiala frecuentemente.<br/>

  (6) Verifica el trayecto óptico: Consulta la sección correspondiente.<br/>

  (7) Considera vida útil: Los tubos láser de CO2 pierden potencia con el tiempo. Sube la potencia o baja la velocidad si es necesario.<br/>

  (8) Si nada de eso funciona, puede ser fallo del tubo láser. Graba video de los pasos y envía foto del número de serie a atención al cliente. Consulta el video de reemplazo de tubo láser.<br/>
  `,
          video_url: ['https://youtu.be/DgAUnWvRwb4', 'https://youtu.be/JiPonHiwV8o '],
        },
        {
          Q: `¿Cómo evitar distorsiones en la imagen durante el grabado con Hurricane?`,
          A: `(1) Verifica que el material no se haya movido durante el grabado: Materiales delgados pueden moverse por el ventilador o el aire asistido.<br/>

  (2) Verifica que la velocidad en el software sea la adecuada: Si la velocidad es muy alta, pueden ocurrir movimientos anómalos.<br/>

  (3) Verifica que los núcleos dobles del eje X e Y estén limpios y sin daños: Revisa visualmente los rieles y núcleos.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9a0aa568-44f6-4369-9493-4f6f0567e85c.png?v=1766565332:Fig. 1]
  (4) Verifica que las correas de los ejes X e Y no estén flojas ni dañadas: Si lo están, cambia la correa. Envía foto clara a atención al cliente. Consulta el video de reemplazo de correa.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_58a63e06-059f-430e-932d-67ffa3c7012b.png?v=1766565328:Fig. 2]
  (5) Verifica que el eje X y la viga inferior estén paralelos: Si la línea recta sólo está un poco torcida, verifica el paralelismo. Usa el video de ajuste estructural de Hurricane.<br/>

  (6) Verifica que el valor de paso esté correcto: En los ajustes de LightBurn o LaserGRBL, $100 y $101 deberían ser 100 (modelos viejos 133.33). Si no sabes distinguir, facilita el número de serie al soporte.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2c94208e-b163-4451-9430-53a3a19415c8.png?v=1766565328:Fig. 3]
  (7) Verifica que los tornillos de las poleas sincronizadoras de los motores X e Y no estén flojos: Utiliza una llave L1.5 para apretarlos. Consulta el video correspondiente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_4ef93e0f-8e67-45e8-a3e6-c521b8cb2c1b.png?v=1766565332:Fig. 4]
  (8) Verifica si se modificaron los parámetros de firmware: Si sí, restáuralos o actualiza el firmware. Puedes pedir confirmación enviando la versión y foto del número de serie al soporte. Puedes actualizar desde AtomStack Studio o la APP.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_41b769a0-efe2-4bc8-bb48-0683201c70b7.png?v=1766565328:Fig. 5]
  (9) Si nada lo soluciona, puede ser fallo de la placa madre. Graba un video del proceso y manda foto del número de serie al soporte. Consulta el video de reemplazo de placa madre.<br/>
  `,
          video_url: [
            'https://youtu.be/_RqKuKrk7bU',
            'https://youtu.be/eLppYJ8egPc',
            'https://youtu.be/EnEi4nS6L7k',
            'https://youtu.be/MA4aSJu5edI',
          ],
        },
        {
          Q: `¿Cómo solucionar líneas de grabado incompletas o sin cerrar en Hurricane?`,
          A: `(1) Verifica la distancia focal del láser: Si cambias el grosor del material, debes reenfocar. Presiona el botón de autoenfoque o mide manualmente que haya 8 mm entre la salida del láser y el material.<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_2e0afe9c-0402-4dfc-bfaa-73ff92dcdd2d.png?v=1766566140:Fig. 1]
          
    (2) Verifica la potencia configurada en el software: Si la potencia está muy baja, aumenta la potencia o reduce la velocidad.<br/>

    (3) Verifica que esté activada la función de potencia constante: (AtomStack Studio, LightBurn).<br/>

    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_2956f96d-4cb4-45bb-98bd-b19c4f1a10a6.png?v=1766566140:Fig. 3]
    [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_bd5fe672-9ca2-43ad-8468-636555f4eacc.png?v=1766566140:Fig. 2]
  (4) Modifica el valor mínimo de energía: Si con potencia constante sigue igual, ve a la configuración de la máquina en LightBurn o LaserGRBL, busca $31 y aumenta su valor hasta que cierre las líneas. Si activar potencia constante lo soluciona, no ajustes $31.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_74235a4f-8157-416b-9ab9-daec9d458a69.png?v=1766566140:Fig. 4]`,
        },
        {
          Q: `¿Cómo solucionar un fallo de reinicio en Hurricane?`,
          A: `(1) Verifica los mensajes del software: Si hay alerta de que se alcanzó el viaje máximo, puede ser fallo del interruptor de límite de los ejes X o Y. Presiona manualmente el interruptor: si no pita o no sale mensaje, el interruptor está fallando. Si funciona, todo ok. Consulta el video de reemplazo de interruptor de límite.
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_30863aa4-6e6e-4a08-bf48-ca2b79352b0f.png?v=1766566480:Fig. 1]
  (2) Verifica si usas un dispositivo rotatorio: Si está conectado, el reinicio fallará porque no tiene interruptor de límite.
  (3) Verifica que los ejes X e Y se mueven correctamente: Observa si ambos ejes se mueven y regresan bien durante el reinicio. Si no, revisa el cableado de motores y el valor de paso. Si el problema sigue, manda video, mensaje de error y foto del número de serie a soporte.
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c70bfbb4-8357-4163-8344-52ebca212b91.png?v=1766566480:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_f6cf1289-81cb-40a3-a326-edec414b7088.png?v=1766566479:Fig. 3]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_44689347-6608-41b1-8d7c-d892ba565e8c.png?v=1766566479:Fig. 4]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0 '],
        },
        {
          Q: `¿Cómo solucionar que Hurricane se detiene durante el grabado y la luz del panel se pone roja?`,
          A: `(1) Mensajes del software:<br/>

  ① Desconexión: Revisa si se movió el cable TYPE-C, si hay fluctuaciones de voltaje, prueba otro puerto USB o prueba AtomStack Studio o LightBurn. Si nada de eso funciona, la placa madre puede estar dañada. Consulta el video de reemplazo.<br/>

  ② ALARMA 1: Indica que el interruptor de límite fue activado. Revisa si el archivo excede el área de grabado o si hay otros archivos fuera de área. En AtomStack Studio podrás saber qué eje accionó la alarma; en LightBurn escribe "?" tras el mensaje y verás cuál fue. Usa eso y observa el movimiento para determinar la causa.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_6dbeda46-6ea6-455c-8f6d-884b15d23005.png?v=1766566755:Fig. 1]
  ③ ALARMA 12: Alarma de llama. Checa si el material es MDF o balsa, o si hay humo o fuego. Si no, puede ser falsa alarma; consulta la sección de soluciones para alarmas frecuentes incorrectas.<br/>

  ③ ALARMA 13: Alarma por puerta abierta. Verifica si la puerta está abierta o el interruptor de límite no funciona (observa el color de la tira LED de la puerta; si está en rojo intenso, es alarma. Luego de abrir la puerta, pulsa ambos interruptores y revisa si la luz regresa a azul). Consulta la sección de solución para que la máquina se detenga correctamente al abrir la puerta.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_5bbaaee3-a837-4613-b1c2-87a150be0957.png?v=1766566755:Fig. 2]
  ③ Alarma por temperatura del agua: Si el agua está demasiado fría o caliente, aparecerá mensaje y la tira LED se pondrá roja. Si está muy fría, sube la temperatura ambiente; si es muy caliente, agrega agua o enfría el ambiente.<br/>

  (2) Si no hay mensaje: Prueba desconectando y reconectando el cable TYPE-C o cámbialo por otro. Prueba con AtomStack Studio o LightBurn o usa otro puerto USB. Si sigue igual, reinstala el firmware (ojo, no se puede instalar dos veces el mismo; pide ayuda a soporte). Si aún falla, cambia la placa madre.<br/>
  `,
          video_url: ['https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `¿Cómo solucionar cuando al hacer clic en "Start Engraving" en el software Hurricane no responde?`,
          A: `(1) Verifica que todas las operaciones sean normales: Primero verifica el cable TYPE-C y que la puerta esté cerrada.<br/>

  (2) Revisa si el software da algún mensaje: Si hay mensaje, sigue la solución según el código mostrado. Si no hay mensajes, reinicia Hurricane, el software y reconecta.<br/>

  (3) Prueba con otro software: Intenta con AtomStack Studio o LightBurn. Si ninguno funciona, prueba otro cable TYPE-C, otro puerto USB o actualizar el driver.<br/>

  (4) Si nada funciona, intenta reinstalar el firmware. Consulta los videos correspondientes. (No puedes instalar dos veces el mismo firmware; facilita la información de versión a soporte). Si aún así sigue el problema, reemplaza la placa madre y da el número de serie a atención al cliente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_19e97e20-1e56-430f-9279-43e6cf4323df.png?v=1766567510:Fig. 1]`,
        },
        {
          Q: `¿Cómo solucionar que el tubo láser de Hurricane no emite luz durante el grabado?`,
          A: `(1) Verifica que el tubo no esté dañado: Desconecta la fuente de energía, retira la tapa trasera y observa visualmente si el tubo está dañado y si el flujo de agua es normal (¡alta tensión! No lo toques con el equipo encendido). Si está dañado, manda foto clara del daño y número de serie al soporte. Consulta el video de revisión y reemplazo.<br/>

  (2) Verifica los cables de los electrodos: Revisa que los positivos y negativos estén bien ajustados. Si están flojos, aprieta los tornillos.<br/>

  (3) Verifica las terminales de la fuente láser: Desconecta la energía, abre la tapa lateral derecha y superior derecha, y revisa si los terminales están flojos. Reconecta la energía. En espera, el LED WF es amarillo y el TL está apagado; si está emitiendo luz, WF es amarillo y TL verde. Si el LED está mal, cambia la fuente láser. Consulta el video de reemplazo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_19e97e20-1e56-430f-9279-43e6cf4323df.png?v=1766567510:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_c4d8cf34-aad0-4c4f-9d01-b3d2cb2e07b1.png?v=1766567510:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_91489143-372c-49f1-9b95-c1291e37e40d.png?v=1766567510:Fig. 3]`,
          video_url: ['https://youtu.be/DgAUnWvRwb4', 'https://youtu.be/YiustdhrW9I'],
        },
        {
          Q: `¿Cómo solucionar fallos de autoenfoque automático en Hurricane?`,
          A: `(1) Verifica que haya material puesto: Si no, la varilla de disparo puede meterse en el panal y no accionar el interruptor de límite, causando fallo.<br/>

          (2) Confirma la versión de firmware mediante AtomStack Studio o la APP.<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e5a1fd06-3578-4a94-b80a-f60e1086cc96.png?v=1766568031:Fig. 1]
  (3) Verifica que la función de autoenfoque está activada: Confírmalo en software o APP, ver Fig. 57.<br/>

  (4) Verifica cables en la placa adaptadora del eje Z: Checa que no estén flojos o rotos. Si están rotos, manda foto y número de serie al soporte.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_d24740ed-e8a0-4fd0-b6e6-e32b601585a5.png?v=1766568034:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_bd9adfc2-1a2c-4eab-ac2a-1fe54ffa654a.png?v=1766568033:Fig. 3]
  (5) Verifica el microinterruptor de límite o el cableado: Aprieta manualmente el microinterruptor y revisa que suene y de mensaje en software. Si no, puede estar roto. Consulta reemplazo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_60b2805c-6247-48b9-9430-6881c6d8f3be.png?v=1766568033:Fig. 4]
  (6) Verifica que el eje Z suba y baje desde el software: Usa las flechas y confirma que funciona. Si solo sube o baja pero nunca va en ambos sentidos y no hay obstrucción mecánica, puede ser la placa madre.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._5_3fdc47cb-6a20-44f3-98ca-f3155e0cec7d.png?v=1766568030:Fig. 5]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._6_9acfe571-4234-4b33-9ddc-1052714e0f96.png?v=1766568032:Fig. 6]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0', 'https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `¿Cómo solucionar si tras autoenfoque la distancia focal no es 8 mm en Hurricane?`,
          A: `(1) Verifica que el autoenfoque toque la superficie del material: Si no hay material, la varilla no accionará correctamente el enfoque.<br/>

  (2) Verifica si al modificar el valor de corrección de enfoque se soluciona: Si no es exactamente 8 mm, puedes ajustarlo enviando el código adecuado en LightBurn o LaserGRBL: Valor predeterminado del parámetro es 1.5; el valor corregido es 1.5 ± error. Si la distancia supera los 8 mm aplica 1.5 - (valor medido - 8); si es menor, 1.5 + (8 - valor medido). En la consola de LightBurn, escribe: $autoFocus/depth_max_mm=valor_corregido y pulsa Enter. Ejemplo: si da 9 mm, el valor es 0.5. Consulta la sección correspondiente.<br/>

  (3) Si nada resuelve, manda video, imagen del valor corregido y valor real tras el enfoque al soporte.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_fd144ff5-a62b-4e40-a3dc-8432c11d71eb.png?v=1766569681:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_4cd6f34a-21c6-41d5-82b3-58f32259eadb.png?v=1766569680:Fig. 2]`,
        },
        {
          Q: `¿Cómo solucionar si la tira LED interna de Hurricane no enciende?`,
          A: `(1) Verifica la conexión del cable de la tira LED: Asegúrate de que no esté floja ni desconectada. Puedes probar desenchufando y volviéndola a conectar.<br/>

  (2) Verifica que la tira LED tenga alimentación: Desconecta el conector y mide voltaje (DC) entre los dos pines con un multímetro. Debe estar entre 20V y 25V. Si es 0 V o menos de 20 V, el cable está fallando. Consulta el video de reemplazo. Si el voltaje es correcto pero no enciende, la tira está dañada y debe reemplazarse. Consulta el video correspondiente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_35553b89-ef93-41e3-80cd-f4cb705ab4d5.png?v=1766569947:Fig. 1]`,
          video_url: ['https://youtu.be/Ahr0Lsk_ukg', 'https://youtu.be/bpndwH44EI4'],
        },
        {
          Q: `¿Cómo solucionar si la tira RGB en la manija de Hurricane no enciende?`,
          A: `(1) Revisa el conector de la tira RGB: Destornilla la tapa protectora de cable (3 tornillos) y verifica el conector. Prueba quitarlo y volverlo a conectar.<br/>

  (2) Observa si alguna perla LED RGB enciende: Si ninguna enciende, puede fallar el cable de potencia; consulta el video para reemplazo. Si alguna sí enciende, la tira está dañada y debe reemplazarse. Consulta el video correspondiente.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1715bacc-e225-473e-886c-126b1a62508d.png?v=1766570170:Fig. 1]`,
          video_url: ['https://youtu.be/4_-PbyT5Y5c'],
        },
        {
          Q: `¿Cómo solucionar si el humo no se evacua correctamente del gabinete de Hurricane?`,
          A: `Verifica el estado del purificador: Si su desempeño es débil, la extracción de humo se verá afectada. Puedes quitar la manguera de escape y dejar salir el humo directo al exterior para comprobar si el problema es el purificador. Si así funciona, puede que el purificador necesite cambio de filtro.<br/>

  Verifica que el ventilador del gabinete esté limpio: El exceso de polvo reduce la eficiencia de evacuación. Consulta el video de limpieza y mantenimiento.<br/>

  Si tras probar lo anterior sigue igual, el ventilador puede estar dañado. Envía foto clara del número de serie (ver Fig. 1) al soporte y consulta el video de reemplazo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_7091eef1-66ea-4e70-b361-30b654c625e0.png?v=1766570909:Fig. 1]`,
          video_url: ['https://youtu.be/bgNd-1hbwBg', 'https://youtu.be/vOiSigRbspM '],
        },
        {
          Q: `¿Cómo solucionar fallas en la detección de llama en Hurricane si no se activa la alarma?`,
          A: `◆Verifica que la función de detección de llama esté activada en el software: En AtomStack Studio o la APP, revisa que la opción "Detección de llama" esté encendida (ver Fig. 1).<br/>

  ◆Verifica la sensibilidad de detección:<br/>

  En AtomStack Studio o la APP, selecciona el nivel de sensibilidad (bajo, medio, alto), ver Fig. 68. Alternativamente, en LightBurn o LaserGRBL ajusta con el comando Console:<br/>

  $fire_alarm/overflow_value=15   // Número de activaciones sobre el umbral<br/>

  $fire_alarm/threshold_value=74   // Umbral de detección (a mayor valor, más difícil activarla)<br/>

  (ver Fig. 2)<br/>

  Si con el umbral mínimo sigue sin funcionar, la placa de detección está averiada. Consulta el video de reemplazo de placa.<br/>

  Nota: Estas medidas no reemplazan la supervisión constante durante el uso. ¡La seguridad es la principal prioridad!<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_582bf2d4-6ba1-419e-8585-a27a7534c174.png?v=1766571114:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_60ecaf82-3f61-46ef-847e-529def941c8b.png?v=1766571113:Fig. 2]`,
          video_url: ['https://youtu.be/HbQgo9z7gFI '],
        },
        {
          Q: `¿Cómo solucionar que la detección de llama de Hurricane es demasiado sensible?`,
          A: `◆Verifica que el material no sea MDF, balsa o similar:<br/>

  Al grabar o cortar MDF o balsa, se recomienda desactivar la detección de llama (ver Fig. 70). ¡Supervisa la máquina todo el tiempo!<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_9322148c-b704-4730-8618-9391637ab852.png?v=1766571786:Fig. 1]
  ◆Verifica si el archivo de corte tiene líneas muy densas:<br/>

  Los patrones densos pueden disparar la alarma fácilmente. Sube la velocidad o haz varias pasadas.<br/>

  ◆Prueba otros materiales:<br/>

  ①Si el mismo archivo en triplay/contrachapado no da alarma, puedes desactivar la detección sólo para ese material (ver Fig. 1).<br/>

  Nota: Siempre vigila la máquina mientras graba.<br/>

  ②Si aún así hay alarma en triplay, ajusta la sensibilidad en AtomStack Studio o la APP (ver Fig. 1). O con los comandos Console:<br/>

  $fire_alarm/overflow_value=15  // Número de activaciones sobre umbral<br/>

  $fire_alarm/threshold_value=74 // Umbral de detección (a mayor valor, más difícil activar, ver Fig. 2)<br/>

  Nota: Ajustes útiles, pero no reemplazan la vigilancia personal. La seguridad es lo más importante.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_80b84e9c-4281-4c6a-a96f-4a006ab93db7.png?v=1766571786:Fig. 2]`,
        },
        {
          Q: `¿Cómo solucionar que el extintor automático de Hurricane no se activa tras alarma de llama?`,
          A: `◆Verifica que la función de extinción automática esté activada: En AtomStack Studio o la APP, asegúrate de que está activada (ver Fig. 1).<br/>

  ◆Verifica que el tanque de agua externo esté conectado: Es indispensable para la función automática. Conecta la manguera proporcionada al puerto correspondiente (ver puerto 7 en la sección Panel de Hurricane).<br/>

  ◆Si nada de esto lo resuelve, la bomba puede estar dañada. Consulta el vídeo de reemplazo de la bomba.<br/>

  Nota: Tras la activación automática, limpia la boquilla y la lente de enfoque (ver Fig. 2). Consulta el video de limpieza post-extinción.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_92e0f268-d019-4373-b6d0-ae14cbe3b1cb.png?v=1766571916:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_eb50065a-4e2d-4d8f-9f01-bbd16d32ec83.png?v=1766571919:Fig. 2]`,
          video_url: ['https://youtu.be/i_IY9cm-12U', 'https://youtu.be/jrDM2ElT9Rg '],
        },
        {
          Q: `¿Cómo solucionar alarmas de temperatura anormal del agua en Hurricane?`,
          A: `◆Verifica que el software esté actualizado: AtomStack Studio debe ser la versión 2.1.0.0 o superior (ver Fig. 1).<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_4774383e-732d-42bf-94ed-a299499199c4.png?v=1766627935:Fig. 1]
  ◆Verifica el firmware: Proporciona versión actual del firmware y foto del número de serie para confirmación (ver Fig. 2).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_63e8df21-d49a-4e52-8abf-630af3e8c44e.png?v=1766627936:Fig. 2]
  ◆Verifica el nivel de agua: Debe estar por encima del mínimo en el tanque (ver Fig. 3). Si es bajo, rellena.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_68703cb5-ca36-4eb7-931f-ab61e68bf953.png?v=1766627936:Fig. 3]
  ◆Verifica la temperatura ambiente: Usa la máquina entre 5 °C y 35 °C. Si es menor a 5 °C, añade anticongelante al agua; consulta la sección especial. Si es mayor a 35 °C, baja la temperatura del ambiente.<br/>

  ◆Si todo lo anterior es normal, puede fallar el sensor de temperatura. Para confirmarlo, colócalo en agua con hielo y observa las lecturas en AtomStack Studio. Si no responde, cámbialo (consulta el video de reemplazo).<br/>
  `,
          video_url: ['https://youtu.be/elV9U_s_jVk'],
        },
        {
          Q: `¿Cómo solucionar fallos en la detección de apertura de tapa en Hurricane (no se detiene el grabado al abrir)?`,
          A: `◆Verifica que la función esté activada en el software:<br/>

  En LightBurn o LaserGRBL, escribe en la consola:<br/>

  $door/enable=On   // Activa la detección de tapa abierta<br/>

  $door/enable=Off  // Desactiva la detección<br/>

  (ver Fig. 1).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_38109a59-aac0-43a0-a239-35d6aaaf8166.png?v=1766628037:Fig. 1]
  ◆Verifica el cableado del interruptor de límite de la tapa: Revisa que el conector no esté flojo ni roto. Desconecta y vuelve a conectar para probar.<br/>

  ◆Verifica el voltaje del cable del interruptor de tapa: Desconecta y mide con multímetro en DC. Debe tener 3.3V (ver Fig. 2).<br/>

  Si hay voltaje, el interruptor puede estar fallando. Si es 0V, el cable puede estar roto.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_b132e9fa-81d3-4893-9c68-41039dae1dc8.png?v=1766628037:Fig. 2]`,
        },
        {
          Q: `¿Cómo solucionar grabados invertidos con el accesorio rotatorio de Hurricane?`,
          A: `◆Verifica si el diseño está ya invertido:<br/>

          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_1a726801-f384-4094-bd4f-590b6c50f053.png?v=1766628537:Fig. 1]
          [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_2e079269-d98c-4b5b-b393-84f3854e338a.png?v=1766628537:Fig. 2]
  Si lo está, revisa si la opción "Mirror" en software está encendida o apagada. Activa o desactívala según tu diseño. (AtomStack Studio: ver Fig. 1; LightBurn: ver Fig. 2).<br/>

  ◆Verifica si el diseño está volteado de atrás hacia adelante:<br/>

  Si es así, activa la inversión de sentido de referencia de inicio en el eje Y en la configuración (ver Fig. 3).<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_25bf95bf-9e3a-4b9d-b140-40ed6e1a4c1f.png?v=1766628537:Fig. 3]
  ◆Si todo lo anterior no lo soluciona:<br/>

  Actualiza el firmware por AtomStack Studio o la APP. Si no puedes actualizar desde software, manda foto del número de serie (ver Fig.4) a soporte para que te den el firmware correcto para instalar por USB. Consulta los tutoriales correspondientes.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._4_5e32e00b-17ae-4df9-a864-f5e9d0bf8c46.png?v=1766628537:Fig. 4]`,
          video_url: ['https://youtu.be/eLppYJ8egPc'],
        },
        {
          Q: `¿Cómo solucionar distorsión en el grabado usando el rotatorio de Hurricane?`,
          A: `◆Verifica los pasos del motor<br/>

  En LightBurn: ve a Editar → Ajustes de máquina → Outputs Setup y revisa que $101 sea 80 (ver Fig. 1).<br/>

  Nota: Hurricane normalmente detecta esto automáticamente y no requiere ajuste manual.<br/>

  ◆Verifica la forma del objeto:<br/>

  Si el material es un círculo irregular, cilindro o superficie curva, puede haber distorsión. Prueba con una superficie regular (ejemplo: termo).<br/>

  ◆Verifica parámetros recomendados para el rotatorio (consulta la sección correspondiente).<br/>

  Si nada funciona, el motor puede estar fallando. Consulta el video de reemplazo de motor rotatorio R6/R8/R8 PRO.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_bde951fd-6b9f-465f-b323-a3f149c3cbf1.png?v=1766629378:Fig. 1]`,
          video_url: ['https://youtu.be/05TaEjoKVqM'],
        },
        {
          Q: `¿Cómo solucionar si Hurricane no reconoce una memoria USB?`,
          A: `◆Reinicia la máquina:<br/>

  Quita y vuelve a insertar la memoria, después reinicia el equipo.<br/>

  ◆Verifica si la memoria está dañada:<br/>

  Prueba la memoria USB en una computadora; si accede a los archivos, está bien.<br/>

  ◆Confirma que la memoria está en el puerto correcto:<br/>

  Debe ir en el puerto USB DRIVE. No lo conectes en el USB KEY.<br/>

  ◆Revisa el estado del puerto USB:<br/>

  Que no esté roto o dañado.<br/>

  ◆Si todo es correcto pero sigue sin funcionar:<br/>

  Puede requerir cambio de placa madre. Consulta el video correspondiente.<br/>
`,
          video_url: ['https://youtu.be/_RqKuKrk7bU'],
        },
        {
          Q: `¿Cómo solucionar fallos al actualizar el firmware en Hurricane?`,
          A: `◆Verifica la memoria USB:<br/>

  Prueba en una computadora que se pueda leer/escribir. Si no, está dañada.<br/>

  ◆Verifica la ubicación de los archivos:<br/>

  La actualización debe estar en la carpeta raíz de la memoria USB, no dentro de otra carpeta.<br/>

  ◆ Intenta actualizar usando AtomStack Studio o la APP.<br/>

  ◆Verifica que el firmware es correcto:<br/>

  El archivo debe tener extensión .bin. Para Hurricane:<br/>

  Números de serie menores que 20250224: C10-0162.bin<br/>

  Números de serie mayores: 16C10-0162.bin<br/>

  Si tienes dudas, manda captura de la versión actual (ver Fig. 1) y foto del número de serie (ver Fig. 2) a soporte.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_e2f8ae59-ffa9-4b51-895a-8af64e1e59c8.png?v=1766629574:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_edb3dbf1-5084-4175-9115-45ea4a835bdc.png?v=1766629573:Fig. 2]
  ◆Si todo lo anterior está bien:<br/>

  Es probable que la placa madre esté defectuosa y deba reemplazarse. Consulta el video de reemplazo de placa madre.<br/>
  `,
          video_url: ['https://youtu.be/_RqKuKrk7bU', 'https://youtu.be/05TaEjoKVqM'],
        },
        {
          Q: `¿Cómo solucionar que la tapa de Hurricane no quede centrada (se desplaza a la izquierda o derecha)?`,
          A: `◆Revisa que las varillas de soporte estén bien: Que los tornillos están completos y sin deformar.<br/>

  ◆Verifica la fuerza de soporte: Asegúrate de que las distancias entre ambas varillas de soporte y las piezas fijas sean iguales. De no ser así, ajusta los bloques de ajuste como en Fig. 1.<br/>

  ◆Verifica que el acrílico de la tapa no esté torcido: Observa alineación, como muestra la Fig. 2.<br/>

  ◆Si todo está bien: Ajusta el ángulo de la bisagra de la tapa. Consulta el video de alineación.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_39a140f8-5861-47ae-9c74-fa4309732aa5.png?v=1766631498:Fig. 1]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_0efc3a55-ee31-49a1-9d09-15b92ae65aba.png?v=1766631498:Fig. 2]`,
          video_url: ['https://youtu.be/hZj2zjqpmwg'],
        },
        {
          Q: `¿Cómo solucionar que la varilla de soporte de la tapa de Hurricane esté rota y no sostenga?`,
          A: `Si la varilla de soporte se rompió y no sostiene la tapa, debe reemplazarse. Graba un video mostrando la falla y toma foto del número de serie (ver Fig. 1) para atención al cliente. Consulta el video de reemplazo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_50e747b8-b0e8-45ad-a707-19ccf1e8453e.png?v=1766631598:Fig. 1]`,
          video_url: ['https://youtu.be/gLb0nQ1_PO0'],
        },
        {
          Q: `¿Cómo solucionar si el interruptor de límite no se activa al insertar la bandeja inferior de Hurricane?`,
          A: `◆Revisa la apariencia del equipo y la bandeja: Busca deformaciones leves por transporte. Si hay, manda foto del número de serie y del daño a soporte.<br/>

  ◆Revisa el interruptor de límite: Revísalo visualmente (ver Fig. 1), presiónalo a mano y asegura temporalmente con cinta. Si así funciona, puede que la bandeja esté mal colocada o haya suciedad. Revisa bien.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_046fec52-5729-4929-bf3e-87aba883ad49.png?v=1766632107:Fig. 1]
  ◆Si todo está bien pero sigue sin funcionar, el interruptor puede estar dañado.<br/>

  Puedes desactivar provisionalmente la detección en LightBurn con:<br/>

  $drawer_alarm/enable=off (ver Fig. 2). Para volver a activar usa $drawer_alarm/enable=on.<br/>

  Manda video del fallo y foto del número de serie (ver Fig. 3) para solicitar reemplazo y consulta el video de reemplazo.<br/>

  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._2_a2d41db2-3c2d-44ae-8f1c-f765fa7a7e49.png?v=1766632106:Fig. 2]
  [img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._3_d6f4721e-eabd-4021-9b89-b62ed1cb0afd.png?v=1766632107:Fig. 3]`,
          video_url: ['https://youtu.be/Fz5ohRUYpd0 '],
        },
        {
          Q: `¿Cómo solucionar si el porta lentes de Hurricane no se puede apretar completamente?`,
          A: `Enciende la máquina y asegúrate de que el láser de posicionamiento rojo funcione. Coloca el porta lentes en el centro del orificio circular. Con una mano sostenlo hacia arriba para que quede bien pegado al marco, mientras que con la otra aprietas la tuerca. Coloca la placa acrílica de enfoque (espejito) encima y mantén el punto rojo centrado. Cuando no puedas apretar más a mano, usa una llave para fijarlo completamente. Consulta el video de instalación.<br/>
`,
          video_url: ['https://youtu.be/El7On8F8R_8'],
        },
        {
          Q: `¿Cómo evitar o solucionar que la lente de enfoque de Hurricane se ensucie fácilmente?`,
          A: `Durante el grabado, retira la boquilla de aire del porta lentes (ver Fig. 1). Recuerda volver a colocarla al cortar.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_136c8f54-c999-491b-a02f-2b1f339f1c3b.png?v=1766632537:Fig. 1]`,
        },
        {
          Q: `¿Cómo tratar las alarmas de software y sus soluciones?`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Fig._1_ec81be34-c3be-4e55-ab72-78acbea40aef.png?v=1766632729:Fig. 1]`,
        },
      ],

    ],
  },
  Atelier: {
    nav: [`Preguntas Pre-venta`, `Inicio Rápido`, `Mantenimiento y Cuidado`],
    nav_desc: [
      `Lo que necesitas saber antes de comprar`,
      `Tus primeros pasos, fácil (Para principiantes)`,
      `Mantén tu máquina en las mejores condiciones`,
    ],
    quantions: [
      // 一、Pre-venta
      [
        {
          Q: `¿Cuál es el área de grabado del Atelier?`,
          A: `Respuesta: 120 mm × 120 mm. Utilizando el alimentador de banda, el área se puede expandir a 350 mm × 120 mm.`,
          video_url: [],
        },
        {
          Q: `¿El Atelier puede grabar metal?`,
          A: `Respuesta: Sí, puede grabar algunos metales como acero inoxidable, hierro y aluminio anodizado negro.`,
          video_url: [],
        },
        {
          Q: `¿El Atelier se puede conectar a una computadora mediante WiFi?`,
          A: `Respuesta: Sí. Primero debes conectar el Atelier para configurar la red utilizando un cable Type-C.`,
          video_url: ['https://youtu.be/oO_HzHC1xNA'],
        },
        {
          Q: `¿Cuál es la potencia del láser del Atelier y se puede reemplazar por otro láser?`,
          A: `Respuesta: La configuración estándar es un láser de diodo de 10W (longitud de onda 455±5 nm). Actualmente, no se puede utilizar con otros láseres.`,
          video_url: [],
        },
        {
          Q: `¿Se puede usar el Atelier con un dispositivo rotatorio?`,
          A: `Respuesta: Sí. Es compatible con los accesorios rotatorios R6, R8 y R8 PRO, con auto-reconocimiento.`,
          video_url: ['https://youtu.be/LYz6q0xJR4c'],
        },
        {
          Q: `¿Se puede expandir el área de grabado del Atelier?`,
          A: `Respuesta: Sí. Utilizando el alimentador de banda R4, el área de grabado se puede expandir a 350 mm × 120 mm.`,
          video_url: [],
        },
        {
          Q: `¿Qué software utiliza el Atelier y se puede usar LightBurn?`,
          A: `Respuesta: Puedes utilizar el software oficial AtomStack Studio (PC o móvil) o LightBurn.<br/>
Al usar LightBurn, puedes importar el archivo de configuración oficial para conectar el dispositivo.<br/>
Selecciona “L1-GALVO” como controlador (ver Figura 12).<br/>
Alternativamente, puedes conectarlo sin importar el archivo de configuración siguiendo los pasos de conexión.<br/>
Consulta la sección “Tutorial de Conexión de Atelier” para obtener orientación.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12_faff6d50-c475-442d-a83d-84fc7c994c84.png?v=1770862276:Figura 12]`,
          video_url: [],
        },
        {
          Q: `¿Cuál es la velocidad máxima de grabado del Atelier?`,
          A: `Respuesta: La velocidad máxima puede alcanzar 240,000 mm/min. Para tareas de grabado reales, sigue los parámetros recomendados en la tabla de parámetros.`,
          video_url: [],
        },
        {
          Q: `¿El Atelier incluye dispositivos para fijar los materiales?`,
          A: `Respuesta: Sí. Se proporcionan dos tiras de posicionamiento, que se pueden asegurar a la base utilizando tornillos.<br/>
También se incluye un rollo de cinta de enmascarar para fijar materiales delgados o ligeros a la base.`,
          video_url: [],
        },
        {
          Q: `¿El Atelier tiene funciones de seguridad?`,
          A: `Respuesta: Sí. La máquina está equipada con un interruptor de encendido para apagar el dispositivo en cualquier momento, y una llave USB para evitar el uso no autorizado, protegiendo a niños o usuarios no capacitados de accidentes.`,
          video_url: [],
        },
        {
          Q: `¿Cuál es la temperatura de funcionamiento normal del Atelier?`,
          A: `Respuesta: La temperatura recomendada de funcionamiento es de 0℃ a 35℃.`,
          video_url: [],
        },
        {
          Q: `¿Cuál es la altura máxima de material que puede grabar el Atelier?`,
          A: `Respuesta: La máquina puede grabar materiales de hasta 105 mm de altura dentro de la cubierta.<br/>
Si se retira la base, teóricamente puede grabar objetos de cualquier altura.`,
          video_url: [],
        },
        {
          Q: `¿Cómo se debe almacenar el Atelier cuando no se utiliza?`,
          A: `Respuesta: Si no se va a utilizar la máquina durante un período prolongado, guárdala en un ambiente seco.<br/>
Se recomienda encender la máquina durante 5 minutos cada mes para mantener la vida útil de los componentes electrónicos.`,
          video_url: [],
        },
      ],

      // 二、Quick start
      [
        {
          Q: `Introducción al área de control del Atelier`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/1_2148a5b1-c245-4307-b071-410a9f55a9f0.png?v=1770862503:Imagen del área de control]<br/>
①Frame/Repetir:<br/>
◆ Pulsación corta: Inicia/Detiene el trazado del borde (ejecuta la tarea de procesamiento más reciente desde la APP).<br/>
◆ Pulsación larga (3 segundos o más): Repetir grabado (ejecuta la tarea de procesamiento más reciente desde la APP).<br/>
◆ Doble clic: Cancelar el grabado.<br/>
②Iniciar/Pausar:<br/>
◆ Pulsación corta: Iniciar grabado / Pausar grabado.<br/>
◆ Pulsación larga (3 segundos o más): Entrar en modo de configuración Wi-Fi.<br/>
◆ Doble clic: Borrar estado de falla.<br/>
③Indicador Wi-Fi<br/>
◆ Apagado: No conectado a la red.<br/>
◆ Blanco intermitente: Configuración Wi-Fi en progreso.<br/>
◆ Verde fijo: Wi-Fi conectado.<br/>
④Indicador de estado<br/>
◆ Blanco fijo: Encendido, en espera.<br/>
◆ Verde fijo: El láser está operando.<br/>
◆ Verde intermitente: Pausado.<br/>
◆ Rojo fijo: Alarma / Falla.<br/>
◆ Azul fijo: Modo accesorio.<br/>
⑤ Perilla de enfoque: Ajusta la altura de la plataforma galvo para el enfoque.<br/>
⑥ Puerto de accesorios: Conecta accesorios como rodillos o platos.<br/>
⑦ Llave USB: Ranura para llave USB. La máquina solo puede iniciar si la llave USB está insertada (preinstalada de fábrica).<br/>
El láser no funcionará sin la llave USB.<br/>
⑧ Computadora: Puerto de conexión con la computadora, se conecta a la PC mediante cable Type-C.<br/>
⑨ Alimentación: Puerto de entrada de energía.<br/>
⓪ Emergencia: Parada de emergencia / Encendido-apagado.`,
          video_url: [],
        },
        {
          Q: `Instalación del Atelier`,
          A: `Nota:<br/>
◆ Instale primero el tubo de extracción.<br/>
◆ Instale la tira de posicionamiento según las necesidades de uso.`,
          video_url: ['https://youtu.be/ovEHZU1Rdb0'],
        },
        {
          Q: `Conexión de red del Atelier`,
          A: `Nota:<br/>
◆ Cuando use AtomStack Studio en PC o móvil, no se requiere configuración adicional;<br/>
el dispositivo está listo para usarse una vez conectado.<br/>
◆ Atelier soporta conexión Wi-Fi móvil y conexión mediante hotspot del móvil.<br/>
Durante la transferencia de archivos, no cambie la APP a segundo plano.<br/>
◆ Cuando use el software LightBurn, primero debe importar el archivo de configuración o establecer el “Origen” en la esquina superior izquierda en "Configuración de dispositivo".<br/>
De lo contrario, el grabado podría aparecer invertido (al revés). Asegúrese de que la velocidad (baudrate) esté en 460800, como se muestra en la Figura 1.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_e6b79b34-865e-4fc6-bf6c-11a7ea5c2b67.png?v=1770862535:Figura 1]<br/>
<br/>
◆ Si el borde del cuadro aparece curvado durante el trazado, se requiere recalibración.<br/>
Consulte el video de calibración galvo del Atelier.<br/>
◆ Cuando grabe materiales delgados, asegúrese de que el objeto esté bien fijado; de lo contrario, el ventilador interno podría mover el material.<br/>
Puede usar la cinta de enmascarar suministrada o la tira de posicionamiento provista.<br/>
◆ Al grabar bordes, no active la opción de "overscan". Si aparece la advertencia “límite de borde excedido” al iniciar, ajuste la posición o verifique si el "overscan" está activado.<br/>
Si los resultados del grabado aparecen distorsionados o desalineados, también verifique la advertencia “límite de borde excedido” y si el overscan está activado.`,
          video_url: ['https://youtu.be/zd5E25sBxwQ', 'https://youtu.be/oO_HzHC1xNA'],
        },
        {
          Q: `Tutorial de calibración galvo del Atelier`,
          A: `Nota:<br/>
◆ Preparación: Siga las instrucciones del Capítulo 7, Guía de ajuste de enfoque del Atelier, para asegurar un enfoque correcto y asegurar el material.<br/>
◆ Calibración con AtomStack Studio (PC): Haga clic en “Configuración” → “Calibración” (ver Figura 2).<br/>
Al establecer los factores de escala de los ejes X e Y, primero restablezca los factores de escala a 1.000, haga clic en “Guardar parámetro” para guardar los ajustes, y luego en “Actualizar datos” antes de realizar la calibración.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2_706e629a-1c6e-45e4-8ab2-2a3c9af5cdd2.png?v=1770862569:Figura 2]<br/>
<br/>
◆ Escalado: Haga clic en “Iniciar”, luego mida el tamaño real de los lados del cuadro grabado.<br/>
Ingrese los valores medidos en “Cálculo de coeficiente de tamaño” para obtener el factor de escala.<br/>
Por ejemplo, el tamaño predeterminado del archivo de grabado es 100 mm × 100 mm, pero el resultado grabado real es 112 mm × 117 mm.<br/>
Tras introducir los valores, el factor de escala del eje X es 0.893 (ver Figura 3).<br/>
El eje Y se ajusta de la misma manera.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3_0cde4161-89a1-4026-964c-9b35b8e2baf9.png?v=1770862595:Figura 3]<br/>
<br/>
Nota: Tras introducir los datos de calibración, haga clic en “Guardar parámetro”. Si necesita modificar los parámetros de calibración, haga clic en “Actualizar datos”.<br/>
Al completar la calibración, realice una prueba de grabado y confirme que el patrón grabado coincida en tamaño con el archivo de grabado.<br/>
Si los tamaños no coinciden, revise los parámetros de calibración.<br/>
◆ Curvatura: Si el borde aparece curvado al hacer clic en “Frame” (ver Figura 4), debe ajustarse el parámetro de curvatura. Por ejemplo, si el valor de curva del eje Y es 1.060, ingrese ese valor en la configuración de curvatura del eje Y.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4_cbb5d80f-665c-4839-a275-f161f0bf80dd.png?v=1770862629:Figura 4]`,
          video_url: ['https://youtu.be/JG4nHUhGzj0'],
        },
        {
          Q: `Tutorial de operación rotatoria del Atelier`,
          A: `Nota:<br/>
◆ Selección de rodillo:<br/>
①El Atelier solo tiene un puerto de expansión de salida (con auto-reconocimiento), por lo que solo se pueden usar los accesorios rotativos R6, R8 y R8 PRO.<br/>
②Deben instalarse los elevadores roscados (ver Figura 5).<br/>
③Utilice el cable USB provisto (ver Figura 6) para conectar al Puerto de Accesorio de la máquina para el reconocimiento automático.<br/>
④No es compatible con los accesorios rotativos R1, R1 Pro, R2, R3 Pro, R1-B, ni R2-B.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_dbda708e-9c1e-472b-bb2b-05d1bd9f2dc7.png?v=1770862657:Figura 5]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6_9dd10060-f603-4f8b-8078-4ba381db892d.png?v=1770862827:Figura 6]<br/>
<br/>
◆ Ajustes de AtomStack Studio: Cuando use AtomStack Studio, los parámetros deben configurarse para el dispositivo detectado.<br/>
Rodillo (R6): No requiere configuración de parámetros.<br/>
Chuck (R8): Configure la circunferencia o diámetro del material (ver Figura 7).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7_100944dc-d342-486d-ae07-3d46e6aa0f17.png?v=1770862859:Figura 7]<br/>
<br/>
◆ Ajustes de LightBurn: Al utilizar LightBurn, los parámetros rotatorios necesitan ser configurados.<br/>
Tipo de rodillo: seleccione Rodillo para R6, Chuck para R8. Eje rotatorio: seleccione el eje Y.<br/>
Configuración de parámetros: para R8 (Chuck), establezca la velocidad de rotación en 160 mm por vuelta (fijo).<br/>
Ingrese el diámetro o la circunferencia del material. Para R6 (Rodillo): establezca la velocidad de rotación en 50 mm por vuelta (fijo), diámetro de rodillo en 16 mm (fijo), e ingrese el diámetro o circunferencia del material.<br/>
(Ver Figura 8)<br/>
◆ Ajuste de enfoque: Después de colocar el material, es necesario volver a enfocar. Para instrucciones de enfoque, consulte la sección "Enfoque del Atelier".<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8_a2880d6c-f18f-4a3f-93e6-aded2afd7e8b.png?v=1770862884:Figura 8]`,
          video_url: ['https://youtu.be/LYz6q0xJR4c'],
        },
        {
          Q: `Funcionamiento del alimentador de banda del Atelier`,
          A: `◆ Al usarlo, asegúrese de que el puerto USB del alimentador de banda quede mirando hacia afuera del usuario (hacia el lado derecho de la máquina).<br/>
◆ El alimentador debe colocarse de manera horizontal, con la ranura inferior alineada con la base del Atelier.<br/>
Asegúrelo con los tornillos suministrados para evitar movimiento vertical. Consulte el manual del R4 (ver Figura 9).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9_a5d0b454-998e-46a0-a152-7c7732a592e8.png?v=1770863006:Figura 9]<br/>
<br/>
◆ AtomStack Studio: El dispositivo se reconocerá automáticamente después de la conexión. Haga clic en OK para comenzar (ver Figura 10).<br/>
◆ LightBurn: Configure manualmente el tamaño de trabajo de la máquina en 350 mm × 120 mm para usar el alimentador de banda (ver Figura 11).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10_b3dc56f8-774a-4b80-8508-480d456d9da1.png?v=1770863036:Figura 10]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11_f11923e2-d54b-47ff-93be-3784ae4c094e.png?v=1770863056:Figura 11]`,
          video_url: ['https://youtu.be/rnfUL5g5HSY'],
        },
        {
          Q: `Enfoque del Atelier`,
          A: `◆ El enfoque óptimo se logra cuando coinciden los dos pequeños puntos rojos (aproximadamente a 151 mm).`,
          video_url: ['https://youtu.be/lR7-7GcWdTs'],
        },
        {
          Q: `Tutorial de prueba de parámetros de grabado en software`,
          A: `Nota: Esta función requiere el software LightBurn original (versión 1.3.01 o superior) o AtomStack Studio.`,
          video_url: ['https://youtu.be/dDkXqGKlZRM'],
        },
      ],
 

      // 三、Maintenance&Care
      [
        {
          Q: `Limpieza de la cubierta del Atelier`,
          A: `◆ Limpieza del vidrio sellado del Galvo: Utilice etanol anhidro al 99% o un limpiador profesional para lentes ópticas (evite solventes que contengan amoníaco o acetona).<br/>
Limpie suavemente en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) usando un paño sin pelusa para evitar rayaduras producidas por movimientos de ida y vuelta.<br/>
Después de la limpieza, inspeccione la superficie bajo luz intensa para asegurarse de que no queden marcas de agua ni fibras.<br/>
Usuarios de alta frecuencia: Limpiar una vez por semana.<br/>
Usuarios de baja frecuencia: Limpiar una vez al mes.<br/>
◆ Limpieza de la cámara: Utilice etanol anhidro al 99% o un limpiador profesional para lentes ópticas (evite solventes que contengan amoníaco o acetona).<br/>
Limpie suavemente en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) usando un paño sin pelusa para evitar rayaduras.<br/>
◆ Limpieza del marco: Utilice un paño sin pelusa con alcohol para limpiar el polvo del marco.`,
          video_url: ['https://youtu.be/kSaJD2YV8AU'],
        },
        {
          Q: `Limpieza del ventilador del Atelier`,
          A: `◆ Desmontaje del ventilador: Abra la puerta de la máquina y eleve la plataforma galvo a la posición más alta.<br/>
Retire los dos tornillos de la tapa del ventilador y quite la cubierta.<br/>
Luego retire los cuatro tornillos que fijan el ventilador y saque el ventilador.<br/>
◆ Limpieza del ventilador: Primero, use un cepillo o herramienta similar para quitar el polvo de la superficie del ventilador.<br/>
Luego limpie con alcohol y un paño sin pelusa. No utilice agentes de limpieza corrosivos.<br/>
◆ Frecuencia de limpieza:<br/>
Usuarios de alta frecuencia: Limpiar una vez al mes.<br/>
Usuarios de baja frecuencia: Limpiar una vez cada tres meses.`,
          video_url: ['https://youtu.be/hlp5k3olzEQ'],
        },
        {
          Q: `Ninguna de las luces indicadoras se enciende después de encender el Atelier.`,
          A: `Solución:<br/>
◆ Verifique el voltaje de salida del adaptador: Use un multímetro para medir si el voltaje de salida del adaptador de corriente es de 24V (ver Figura 13).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure13.png?v=1770863151:Figura 13]<br/>
<br/>
◆ Verifique el cableado del interruptor de encendido: Si el adaptador de corriente funciona normalmente, abra la tapa superior del Atelier y compruebe si el cableado del interruptor de encendido está correctamente conectado (ver Figura 14).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_14.png?v=1770863175:Figura 14]<br/>
<br/>
◆ Verifique el interruptor de encendido:<br/>
Si el cableado está correctamente conectado, desenchufe el adaptador y desconecte el cableado del interruptor.<br/>
Utilice un cable para realizar un puente entre los terminales y luego vuelva a enchufar el adaptador para ver si la máquina enciende.<br/>
Si la máquina enciende al hacer el puente, el interruptor está defectuoso.<br/>
Si el problema persiste, podría ser un fallo de la placa base.<br/>
Por favor, proporcione el número de serie del dispositivo (ver Figura 15) y un video del problema para que soporte técnico lo asista.<br/>
Referencias: Video de puente del interruptor de encendido del Atelier<br/>
Video de reemplazo de la placa base del Atelier<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure15.png?v=1770863331:Figura 15]`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/rKdxv6VTsoM'],
        },
        {
          Q: `Después de encender el interruptor del Atelier, la luz indicadora de estado se vuelve roja.`,
          A: `Solución:<br/>
◆ Confirme que la llave USB está insertada: Verifique si la llave USB está conectada al puerto correspondiente en la parte trasera del Atelier.<br/>
Si lo está, tóquela suavemente y compruebe si emite un pitido y la luz indicadora cambia a blanco.<br/>
Si la operación vuelve a la normalidad al tocar, ajuste suavemente la llave USB para que quede presionada contra la pared interna del puerto.<br/>
Si estas medidas no solucionan el problema de contacto, proporcione el número de serie (ver Figura 16) y un video del fallo, y envíelos al servicio técnico.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16_ee0ee9e4-766c-42ff-ba9a-0b4dca393b71.png?v=1770863379:Figura 16]<br/>
<br/>
◆ Confirme que la puerta de la cubierta está cerrada correctamente:<br/>
Abra y cierre de nuevo la puerta, y revise si la luz indicadora vuelve a la normalidad.<br/>
También puede desactivar la función “Detección de puerta” en AtomStack Studio (ver Figura 17). Si la luz vuelve a la normalidad tras desactivar esta función, indica un fallo del interruptor de puerta (sensor Hall).<br/>
Proporcione el número de serie y un video del fallo al servicio técnico.<br/>
Consulte el video de reemplazo del sensor Hall del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17_bd6bbf03-6e12-4bee-a2d9-16293071c760.png?v=1770863426:Figura 17]<br/>
<br/>
◆ Intente reinstalar el firmware:<br/>
Si tanto la llave USB como el interruptor de puerta están bien, proporcione el número de serie al servicio técnico para solicitar el firmware más reciente e intente actualizarlo.<br/>
◆ Si nada de lo anterior soluciona el problema, reemplace la placa base:<br/>
Proporcione el número de serie, el video del fallo y los pasos realizados al servicio técnico.<br/>
Consulte el video de reemplazo de la placa base del Atelier.`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/ug5x1HLtO2Q'],
        },
        {
          Q: `El Atelier no puede conectarse a la red.`,
          A: `Solución:<br/>
◆ Verifique el estado de energía de la máquina:<br/>
-- Al encender, si la luz de estado está blanca — funcionamiento normal.<br/>
-- Al encender, si la luz de estado está roja — estado de alarma, solucione según la sección “Luz de estado en rojo al encender”.<br/>
-- Al encender, si la luz no se ilumina — revise la sección “La luz de estado no se enciende al encender”.<br/>
◆ Confirme el ajuste de baudios:<br/>
Al usar AtomStack Studio, no es necesario configurarlo.<br/>
En LightBurn, configure la tasa a 460800 (ver Figura 18), o bien importe el archivo de configuración.<br/>
Siga la guía para importar el archivo de configuración y asegúrese de seleccionar el controlador L1-GALVO.<br/>
No se recomienda usar LaserGRBL.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_18.png?v=1770863476:Figura 18]<br/>
<br/>
◆ Verifique que la computadora reconozca el puerto serie:<br/>
Abra el Administrador de Dispositivos y compruebe que aparezca el puerto serie (CH340) asociado al grabador (puede conectar y desconectar el cable Type-C para comprobarlo).<br/>
Si no es reconocido, o muestra advertencias, instale el controlador.<br/>
El puerto serie debe verse como en la Figura 19.<br/>
Consulte el video de instalación del controlador de puertos.<br/>
Enlaces de descarga:<br/>
---Windows: [link:https://asa.atomstack.com/downloadWindowsDrivers.do3]<br/>
---Mac: [link:https://asa.atomstack.com/downloadMacDrivers.do3]<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19_56d7291d-5b97-4500-983b-d8c0b15e4be1.png?v=1770863519:Figura 19]<br/>
<br/>
◆ Verifique si hay otros programas usando el puerto:<br/>
Cierre cualquier otro software conectado al puerto de la máquina.<br/>
◆ Verifique el sistema operativo:<br/>
En Windows, puede conectar directamente por Type-C.<br/>
En Mac, por permisos, debe usar un adaptador y conectar con el puerto A del cable Type-C suministrado (ver Figura 20). Algunos cables son solo de carga y no transmiten datos.<br/>
En computadoras Huawei, el puerto C también requiere adaptador; el puerto A se puede conectar directamente.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20_075f24fe-daf7-4f5e-b87d-545bb350d07a.png?v=1770863545:Figura 20]<br/>
<br/>
◆ Pruebe con otro software:<br/>
Intente conectar con AtomStack Studio o LightBurn.<br/>
◆ Verifique el funcionamiento del cable:<br/>
Pruebe otro cable Type-C que soporte datos. Si la máquina conecta con otro cable, el problema era el cable.<br/>
Envíe video del fallo y el número de serie (ver Figura 21) al servicio técnico.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21_1482627c-639b-4766-9866-027ebfa9014c.png?v=1770863589:Figura 21]<br/>
<br/>
◆ Pruebe en otra computadora:<br/>
Conecte la máquina en otro equipo para ver si conecta normalmente.<br/>
Para Windows 7, pruebe varios puertos USB y asegúrese de instalar el controlador en cada uno.<br/>
◆ Si todas las acciones anteriores fallan, considere un fallo de placa base:<br/>
Envíe los pasos de prueba, video del fallo y el número de serie al servicio técnico.<br/>
Consulte la guía de reemplazo de la placa base del Atelier.`,
          video_url: ['https://youtu.be/7ALKWXmGKM0', 'https://youtu.be/E1XWMmM23Eo'],
        },
        {
          Q: `La lente de enfoque del Atelier está sucia o dañada.`,
          A: `Solución:<br/>
Cuando hay una caída significativa de potencia o un gran cambio en el punto láser, debe revisarse la lente.<br/>
◆ Suciedad/Contaminación:<br/>
Primero, límpiela con etanol anhidro al 99% o un limpiador profesional para lentes ópticas (evite solventes con amoníaco/acetona).<br/>
Al limpiar, use paño sin pelusa y limpie en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera), evitando frotar ida y vuelta.<br/>
Después de la limpieza, verifique la lente con luz lateral intensa para que no queden marcas de agua o fibras.<br/>
Consulte la guía de limpieza de la lente del Atelier.<br/>
◆ Daño:<br/>
Si la lente está dañada, debe cambiarse todo el módulo láser, ya que es un componente sellado.<br/>
La probabilidad de daño es muy baja.<br/>
Salvo gran variación en el punto láser, no desmonte el láser para revisar la lente de enfoque.<br/>
Consulte la guía de reemplazo del láser del Atelier.`,
          video_url: ['https://youtu.be/qNJhnsqfoPw', 'https://youtu.be/boATg0ZkuuQ'],
        },
        {
          Q: `La capacidad de corte láser del Atelier ha disminuido significativamente.`,
          A: `Solución:<br/>
◆ Atenuación normal de potencia:<br/>
Con el uso, es normal que la potencia disminuya.<br/>
Puede compensarse subiendo la potencia o bajando la velocidad.<br/>
◆ Verifique la distancia fija de enfoque:<br/>
Enfoque de nuevo el láser usando la perilla sobre la máquina para superponer los puntos rojos sobre el material.<br/>
La distancia de enfoque fija es 151 mm (desde la plataforma galvo hasta la superficie del material).<br/>
◆ Verifique los parámetros:<br/>
Confirme que los parámetros sean los recomendados.<br/>
La unidad de velocidad debe ser mm/min.<br/>
Cómo consultar la tabla de parámetros:<br/>
① Escanee el QR de la máquina.<br/>
② Visite el sitio oficial: [link:/pages/product-support]<br/>
③ Solicítelo a atención al cliente.<br/>
◆ Verifique el ajuste S-value max en el software:<br/>
Si usa LightBurn, compruebe si se modificó el valor S-max. Debe estar en 1000 y no cambiarse (ver Figura 22).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22_ed10fad9-0f48-4e40-b7c9-0cc3fbd60912.png?v=1770863633:Figura 22]<br/>
<br/>
◆ Verifique el vidrio sellado:<br/>
Revise si el vidrio sellado en el área galvo está limpio (ver Figura 23).<br/>
Si está manchado, límpielo con alcohol y paño sin pelusa.<br/>
Consulte el apartado “Limpieza de la cubierta” para el método correcto.<br/>
Si el vidrio está muy dañado o no puede limpiarse, reemplácelo.<br/>
Consulte la guía de reemplazo del vidrio del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23_5eb6993d-a0fd-4e32-88ba-d473b979c1a1.png?v=1770863701:Figura 23]<br/>
<br/>
◆ Pruebe la salida del adaptador:<br/>
Con multímetro en modo DC, mida si entrega 24V.<br/>
Si no es correcto, envíe video y número de serie al servicio técnico.<br/>
◆ Pruebe el estado del módulo láser:<br/>
Use 100% de potencia y velocidad de 200 mm/min para cortar una pasada en contrachapado de 3mm.<br/>
Si no corta o no deja marca, revise el módulo láser.<br/>
Abra la tapa y retire el láser de acuerdo al video de limpieza de la lente.<br/>
No deje que entre polvo en el conjunto galvo.<br/>
--Revise la lente láser:<br/>
Revise si está limpia y, si está sucia, límpiela con etanol anhidro al 99% o limpiador profesional óptico (evite solventes con amoníaco o acetona).<br/>
Limpie con paño sin pelusa siempre en una sola dirección.<br/>
Verifique bajo luz lateral que no queden restos.<br/>
Si está dañada, debe cambiarse el módulo láser.<br/>
Envíe fotos claras del daño y el número de serie al soporte.<br/>
--Pruebe el punto láser:<br/>
Si la lente está limpia, apunte el módulo láser al techo y dispare para ver si la mancha es normal.<br/>
Si está difuso o anormal, envíe fotos claras al soporte.<br/>
Consulte la guía de inspección de punto láser.<br/>
◆ Si no hay anomalías en lo anterior, se considera fallo del módulo láser:<br/>
Envíe video de prueba de corte (mostrando parámetros, proceso, resultado y número de serie, ver Figura 24) al soporte.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24_09418fe9-8822-4d03-8b8d-7459a7ac8dcc.png?v=1770863728:Figura 24]`,
          video_url: [
            'https://youtu.be/qNJhnsqfoPw',
            'https://youtu.be/m1rLu7p973o',
            'https://youtu.be/yE9WElqNGYs',
          ],
        },
        {
          Q: `Mala calidad de grabado en el Atelier.`,
          A: `Solución:<br/>
◆ Verifique la distancia fija de enfoque:<br/>
Enfoque el láser para que los dos puntos rojos se superpongan en la superficie del material.<br/>
La distancia de enfoque fija es 151 mm (de la plataforma galvo a la superficie del material).<br/>
◆ Verifique los parámetros:<br/>
Confirme que los parámetros coincidan con la tabla recomendada.<br/>
La unidad de velocidad debe ser mm/minuto.<br/>
Cómo consultar la tabla de parámetros:<br/>
① Escanee el QR en la máquina.<br/>
② Visite el sitio oficial: [link:/pages/product-support]<br/>
③ Solicítela a atención al cliente.<br/>
◆ Verifique el valor S-max en el software:<br/>
Si usa LightBurn, chequee que el valor S-max no haya sido modificado.<br/>
Debe permanecer en 1000, este valor no debe cambiarse (ver Figura 25).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25_4d2572ca-baa5-46db-94a6-d4e4aa5f5d93.png?v=1770863756:Figura 25]<br/>
<br/>
◆ Atenuación normal:<br/>
Con el uso, la potencia baja normalmente.<br/>
Puede compensarse subiendo la potencia o bajando la velocidad.<br/>
◆ Revise el vidrio sellado:<br/>
Compruebe si el vidrio sellado del área del escáner galvo está limpio, como se muestra en la Figura 26.<br/>
Si está sucio, límpielo con alcohol y paño sin pelusa.<br/>
Consulte "Limpieza de la cubierta" para el método correcto.<br/>
Si el vidrio está dañado o no puede limpiarse, debe reemplazarse.<br/>
Consulte la guía de reemplazo.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26_b865dc27-6950-40c7-b94d-413f3d0656f7.png?v=1770863789:Figura 26]<br/>
<br/>
◆ Revise el material:<br/>
El material debe ser apto para láser azul de diodo.<br/>
La superficie del material no debe tener capa de pintura.<br/>
Si la tiene, intente grabar nuevamente.<br/>
◆ Chequee el módulo láser:<br/>
Use 100% de potencia y 200 mm/min para cortar en una pasada un contrachapado de 3 mm. Si no corta o no deja marca, revise el módulo láser.<br/>
Retire el láser según el video de limpieza de la lente.<br/>
Evite que entre polvo en el galvo.<br/>
--Verifique la lente:<br/>
Si está sucia, límpiela con etanol anhidro al 99% o limpiador profesional (evitando amoníaco o acetona).<br/>
Use paño sin pelusa en una sola dirección.<br/>
Revise con luz lateral intensa.<br/>
Si está dañada, reemplace el módulo.<br/>
Envíe fotos y el número de serie al soporte.<br/>
--Pruebe el haz láser:<br/>
Si la lente está limpia, apunte al techo y dispare para revisar el haz.<br/>
Si hay algún defecto, envíe fotos al soporte.<br/>
Consulte la guía de inspección del haz.<br/>
◆ Si todo está en orden y sigue fallando, se considera un fallo de módulo láser:<br/>
Envíe video de prueba de corte (muestra parámetros, proceso, resultado y número de serie, ver Figura 27) a soporte.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27_2a56db95-37f9-4b5d-befd-7dc4d574da63.png?v=1770863814:Figura 27]`,
          video_url: [
            'https://youtu.be/qNJhnsqfoPw',
            'https://youtu.be/m1rLu7p973o',
            'https://youtu.be/yE9WElqNGYs',
            'https://youtu.be/boATg0ZkuuQ',
          ],
        },
        {
          Q: `El resultado del grabado en el Atelier sale distorsionado.`,
          A: `Solución:<br/>
◆ Confirme el peso del material:<br/>
Materiales livianos pueden moverse por la succión del extractor.<br/>
Asegúrelos usando cinta adhesiva incluida o las tiras de posicionamiento.<br/>
◆ Confirme que el galvo esté calibrado:<br/>
Genere un archivo cuadrado y realice un grabado para comprobar el resultado.<br/>
Si hay distorsión, calibre en AtomStack Studio o LightBurn.<br/>
--Calibración en AtomStack Studio:<br/>
Abra el software, haga clic en "Configuraciones" → "Calibración" (ver Figura 28).<br/>
Coloque el material y enfoque.<br/>
Pulse "Comenzar" para grabar un cuadrado de 100 × 100 mm.<br/>
Mida las longitudes reales de los lados y escríbalos en el área de “Cálculo de coeficiente de tamaño”.<br/>
Por ejemplo, si el cuadrado mide 112 mm × 117 mm, ingréselos para obtener el coeficiente (ver Figura 29).<br/>
Repita para ambos ejes.<br/>
Consulte el video de calibración de galvo.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28_a48c32b3-9165-4afa-a207-625453de0d73.png?v=1770863843:Figura 28]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29_8aaeb10b-0e64-459c-8898-f282d17ec641.png?v=1770863923:Figura 29]<br/>
<br/>
--Si el marco en Y sale curvo:<br/>
Ajuste el parámetro “Curva”. Valor predeterminado: 1.060 (ver Figura 28).<br/>
--Calibración en LightBurn:<br/>
Consulte el video de calibración del Atelier.<br/>
Nota: En LightBurn, vaya a “Configuración de dispositivo” y establezca el “Origen” en la esquina superior izquierda (ver Figura 30).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30_ef63a7b0-3306-4e94-aaf1-a5a6d39fbce9.png?v=1770864109:Figura 30]`,
          video_url: ['https://youtu.be/JG4nHUhGzj0'],
        },
        {
          Q: `Fallo en la detección de puerta del Atelier – la luz de estado se pone roja incluso con la puerta cerrada.`,
          A: `Solución:<br/>
◆ Confirme que la puerta está totalmente cerrada:<br/>
Cheque que nada la bloquee.<br/>
◆ Revise el sensor Hall:<br/>
En AtomStack Studio, desde la configuración, desactive la “Detección de puerta” (ver Figura 31).<br/>
Si la luz cambia de roja a verde al desactivar, el sensor Hall está fallando.<br/>
Consulte el video de reemplazo del sensor Hall.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31_2f3fafa5-9f55-44f6-9a02-d238cdbff6ef.png?v=1770864146:Figura 31]<br/>
<br/>
◆ Si el problema continúa:<br/>
Envíe una foto del número de serie (ver Figura 32) y un video de la falla al servicio técnico para solicitar el firmware.<br/>
Si tras la actualización el problema persiste, reemplace la placa base.<br/>
Consulte el video de reemplazo de la placa base del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32_6479c466-cf02-4d34-8796-d4940809349a.png?v=1770864172:Figura 32]`,
          video_url: ['https://youtu.be/ug5x1HLtO2Q', 'https://youtu.be/9zmgnkasuN8'],
        },
        {
          Q: `El Atelier se detiene repentinamente durante el uso.`,
          A: `Solución:<br/>
◆ Pruebe la salida del adaptador:<br/>
Use el multímetro (modo DC) para medir si entrega 24V, 3A.<br/>
Si no, envíe un video de prueba y el número de serie (ver Figura 33) al soporte.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33_77d76766-6310-461c-bf20-5a6e6dace014.png?v=1770864276:Figura 33]<br/>
<br/>
◆ Revise si se muestran alertas:<br/>
Observe si la luz se pone roja o el software muestra un error.<br/>
--Alerta de llave USB no insertada:<br/>
Compruebe que la llave USB esté correctamente colocada. Ajústela suavemente y vea si la luz parpadea verde.<br/>
Si parpadea, pulse “Inicio/Pausa” para continuar.<br/>
Si la alerta persiste, envíe video del fallo y número de serie al soporte.<br/>
--Alerta de pérdida de conexión:<br/>
Verifique la conexión Type-C:<br/>
Apague, reconecte el cable y vuelva a encender.<br/>
En Mac, use adaptador y conecte con el puerto A (ver Figura 34).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34_f3f6c28a-8470-46b8-b298-c524b5de42d9.png?v=1770864531:Figura 34]<br/>
<br/>
Pruebe otro puerto COM e instale el driver.<br/>
Preste atención en Windows 7.<br/>
Enlaces driver:<br/>
Windows: [link:https://asa.atomstack.com/downloadWindowsDrivers.do3]<br/>
Mac: [link:https://asa.atomstack.com/downloadMacDrivers.do3]<br/>
Pruebe con AtomStack Studio (PC/móvil) o LightBurn para ver si ocurre lo mismo.<br/>
Si la pérdida de conexión persiste:<br/>
Intente reemplazar la placa base.<br/>
Envíe video, pasos realizados y número de serie al soporte.<br/>
Consulte el video de reemplazo de placa base.<br/>
--Alerta $door/enable=On — Cierre detectado abierto:<br/>
Confirme que la puerta esté completamente cerrada.<br/>
Revise el sensor Hall:<br/>
En AtomStack Studio, desactive “Detección de puerta” (ver Figura 35).<br/>
Si la luz pasa de roja a verde, reemplace el sensor Hall.<br/>
Consulte el video correspondiente.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35_13c163d2-d798-4be5-96f8-2c22d65c1a1d.png?v=1770864570:Figura 35]<br/>
<br/>
◆ Si continúa el problema:<br/>
Intente reemplazo de placa base.<br/>
Envíe video, pasos realizados y número de serie al soporte.<br/>
Consulte el video de reemplazo de placa base.`,
          video_url: ['https://youtu.be/ug5x1HLtO2Q', 'https://youtu.be/9zmgnkasuN8'],
        },
        {
          Q: `Al procesar materiales ligeros en el Atelier, pueden faltar líneas o aparecer distorsionadas.`,
          A: `Solución:<br/>
La causa es que el fuerte flujo de aire del ventilador puede mover los materiales ligeros.<br/>
◆ Use la cinta adhesiva incluida para fijar el material en la base.<br/>
◆ Use las tiras de posicionamiento incluidas para sujetarlo.<br/>
Dichas tiras tienen limitaciones, por lo que la fijación debe realizarse según el tamaño del material.`,
          video_url: [],
        },
        {
          Q: `El Atelier no puede conectar por WiFi.`,
          A: `Solución:<br/>
◆ Revise el router:<br/>
El WiFi del Atelier solo soporta 2.4 GHz. No puede conectarse a redes 5 GHz.<br/>
Cambie el router a 2.4 GHz e intente de nuevo.<br/>
◆ Conexión por punto móvil:<br/>
Si no hay router 2.4 GHz ni WiFi disponibles, use un hotspot del móvil.<br/>
Consulte el video de conexión móvil del Atelier.<br/>
◆ Revise la señal WiFi:<br/>
Con el móvil, vea si aparece una red Atelier_*** y revise su intensidad.<br/>
--Señal fuerte:<br/>
Intente con otro móvil o apague los datos móviles y vuelva a intentar.<br/>
--No aparece la red:<br/>
Si no aparece en ningún dispositivo, envíe video del fallo y el número de serie al soporte para solicitar el firmware correspondiente.<br/>
Flashee el firmware y pruebe de nuevo.<br/>
Si sigue sin funcionar, contacte para coordinar el reemplazo de la placa base.<br/>
Consulte el video correspondiente.<br/>
--Señal débil:<br/>
Revise la antena WiFi abriendo la tapa superior del Atelier.<br/>
Asegúrese de que esté bien conectada a la placa base.<br/>
Desconecte y vuelva a conectar si es necesario.<br/>
Si sigue débil, la antena está fallando.<br/>
Envíe video del fallo y el número de serie (ver Figura 36) a soporte.<br/>
Consulte el video de reemplazo de antena WiFi del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36_c122b3c4-ea4c-4532-8fe2-f336352953fc.png?v=1770864652:Figura 36]`,
          video_url: [
            'https://youtu.be/zd5E25sBxwQ',
            'https://youtu.be/9zmgnkasuN8',
            'https://youtu.be/uDOd9II1hM0',
          ],
        },
        {
          Q: `El Atelier no cierra líneas vectoriales durante el grabado.`,
          A: `Solución:<br/>
◆ Revise el archivo de grabado:<br/>
Cree un archivo de líneas cuadradas o circulares y realice una prueba.<br/>
Si cierra correctamente, el problema está en el archivo original.<br/>
◆ Revise el enfoque:<br/>
Enfoque de nuevo usando la perilla superior lateral para superponer los puntos rojos sobre la superficie del material.<br/>
La distancia de enfoque es 151 mm (plataforma galvo - superficie).<br/>
◆ Revise parámetros:<br/>
Confirme que los parámetros coincidan con la tabla recomendada.<br/>
La velocidad debe estar en mm/min.<br/>
Cómo consultar la tabla:<br/>
① Escanee el QR en la máquina.<br/>
② Visite el sitio oficial: [link:/pages/product-support]<br/>
③ Solicítela a soporte.<br/>
Si está correcto, intente bajar la velocidad o subir la potencia.<br/>
◆ Active “Potencia Constante”:<br/>
En AtomStack Studio, ver Figura 37; en LightBurn, ver Figura 38.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37_44be103b-0474-42ba-8f83-07ae75eda279.png?v=1770864720:Figura 37]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38_820056db-4aac-4430-b18c-bff4f04c6240.png?v=1770864757:Figura 38]<br/>
<br/>
◆ Aumente el valor mínimo de potencia $31:<br/>
Con AtomStack Studio o LightBurn, envíe el comando $31=* (“*” representa el valor; auméntelo de a poco hasta cerrar las líneas).<br/>
Por ejemplo, si no cierra con $31=0, pruebe $31=10. Si sigue sin cerrar, suba a $31=20 y así, hasta que cierre.<br/>
Consulte el video tutorial para ajustar el valor mínimo de potencia del Atelier.`,
          video_url: ['https://youtu.be/TTSdmaT2zQM'],
        },
        {
          Q: `El rendimiento de extracción de aire del Atelier es pobre y el interior se llena de humo.`,
          A: `Solución:<br/>
◆ Revise el conducto de extracción:<br/>
Cheque si hay obstrucciones o dobleces.<br/>
◆ Revise el ventilador:<br/>
Abra la cubierta y quite la tapa del ventilador desatornillando los dos tornillos.<br/>
--Si hay mucho polvo:<br/>
Limpie según el video de limpieza del ventilador.<br/>
--Si el ventilador no gira:<br/>
Abra la tapa superior y compruebe que el conector esté bien enchufado. Reconéctelo si es necesario.<br/>
Si sigue sin girar, desconecte el ventilador y use dos cables para conectarlo directamente al adaptador (ver Figura 39) para probar.<br/>
Si así tampoco gira, envíe video y número de serie (ver Figura 40) a soporte.<br/>
Para reemplazo, consulte el video de ventilador del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39_e1fc50e8-3112-44b3-8926-8fc48b4e2fe7.png?v=1770864850:Figura 39]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40_8e1ec6f8-3901-4a8d-bca6-f2630a4783d9.png?v=1770864894:Figura 40]`,
          video_url: ['https://youtu.be/hlp5k3olzEQ', 'https://youtu.be/HFsPMotcA1A'],
        },
        {
          Q: `El resultado usando el giratorio en el Atelier es un espejo o sale invertido.`,
          A: `Solución:<br/>
◆ Revise si el archivo de grabado está espejado.<br/>
Si es así, compruebe si la función "espejo" está activada en el software. Si está activada, desactívela.<br/>
Si está desactivada, pruebe activarla. Para referencia: ver Figura 41 en AtomStack Studio y Figura 42 en LightBurn.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41_aaf5a1a7-eb83-406e-b27f-7b60562d0552.png?v=1770865117:Figura 41]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42_3a6a44d5-40fd-4230-8a04-1e8e020cbfe9.png?v=1770865147:Figura 42]<br/>
<br/>
◆ Restaurar ajustes de fábrica:<br/>
--En AtomStack Studio:<br/>
En versión 2.20 o superior, haga clic 7 veces consecutivas en el número de versión para entrar en modo desarrollador (ver Figura 43).<br/>
Abra el menú, ingrese a “Registro de puerto serie”, luego pulse “Restablecer” (ver Figura 44).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43_3eb70034-fe8c-4e05-b100-70b19b40dbd4.png?v=1770865182:Figura 43]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44_bfb80b37-1b7d-44c4-b388-94a377c08583.png?v=1770865330:Figura 44]<br/>
<br/>
--En LightBurn:<br/>
En la consola, ingrese $RST=* para restaurar ajustes de fábrica (ver Figura 45).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45_d661adb5-0c64-408c-83ee-e12ae4e1a25b.png?v=1770865410:Figura 45]`,
          video_url: [],
        },
        {
          Q: `El Atelier no funciona bien tras conectar el accesorio giratorio.`,
          A: `Solución:<br/>
◆ Revise la conexión:<br/>
El Atelier solo soporta los giratorios R6 / R8 / R8 PRO, conectados por el cable USB incluido (ver Figura 46).<br/>
Atención: No debe conectarse a otro puerto; debe ir al de Accesorios.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46_43116779-a3f6-4244-8027-aa40881de75e.png?v=1770865449:Figura 46]<br/>
<br/>
◆ Revise la configuración:<br/>
--En LightBurn:<br/>
Tipo de giratorio: R6 = Rodillo, R8 = Chuck.<br/>
Eje rotativo: seleccione Y.<br/>
Parámetros:<br/>
R8: Velocidad = 160 mm/vuelta (fija), ingrese diámetro o circunferencia.<br/>
R6: Velocidad = 50 mm/vuelta (fija), diámetro de rodillo = 16 mm (fijo), ingrese diámetro o circunferencia (ver Figura 47).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47_a9d294ce-3fa0-4914-9bb3-e266dc1669b4.png?v=1770865492:Figura 47]<br/>
<br/>
--En AtomStack Studio:<br/>
Rodillo (R6): No requiere ajuste de parámetros.<br/>
Chuck (R8): Debe ingresar circunferencia o diámetro (uno solo, ver Figura 48).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48_c6ce5c97-5e03-4a1a-b623-8b4374768370.png?v=1770865593:Figura 48]`,
          video_url: [],
        },
        {
          Q: `El Atelier no reconoce USB o tarjetas TF.`,
          A: `Solución:<br/>
◆ Pruebe la función de reconocimiento:<br/>
Como están conectadas internamente a la placa base, solo puede comprobarlo desde AtomStack Studio en Archivo → Abrir Proyecto para ver si la función se realiza correctamente.<br/>
¿El tamaño del almacenamiento es compatible?<br/>
(ver Figura 49)<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49_74b36bfd-66b9-44de-8170-975c1a331755.png?v=1770865631:Figura 49]<br/>
<br/>
◆ Reinsertar USB/TF:<br/>
Apague la máquina, abra la tapa y retire e inserte nuevamente la unidad o tarjeta.<br/>
Consulte el video de reemplazo USB/TF.<br/>
◆ Formatee la memoria:<br/>
Si sigue fallando, formatéela en la PC a FAT32.<br/>
◆ Pruebe con otra memoria:<br/>
Si una nueva funciona, la original está defectuosa.<br/>
Envíe video y número de serie (ver Figura 50) a soporte.<br/>
◆ Reemplace la placa base si es necesario:<br/>
Si la memoria funciona bien en el PC, pero no en la máquina y ya fue formateada, cambie la placa base.<br/>
Para el cambio, consulte el video de reemplazo de placa base.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50_854a04a9-18a0-4681-89e9-83f76f516de4.png?v=1770865654:Figura 50]`,
          video_url: ['https://youtu.be/9zmgnkasuN8', 'https://youtu.be/21p5wdVDJG4'],
        },
        {
          Q: `Falló la actualización de firmware del Atelier.`,
          A: `Solución:<br/>
Si una actualización enviada por AtomStack Studio falla, intente lo siguiente:<br/>
◆ El Atelier no reconoce la USB/TF:<br/>
Consulte la sección “El Atelier no reconoce USB o tarjetas TF”.<br/>
◆ No se puede flashear el mismo firmware varias veces:<br/>
Verifique si el firmware que quiere instalar es el mismo que el actual.<br/>
Si no está seguro, envíe captura a soporte para confirmar.<br/>
Ver Figura 51 para revisar la versión.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51_6795977e-5e44-442b-be59-ce1d7f09a082.png?v=1770866777:Figura 51]`,
          video_url: [],
        },
        {
          Q: `Los dos puntos rojos del Atelier no se superponen al enfocar.`,
          A: `Solución:<br/>
◆ Verifique la distancia de enfoque:<br/>
Si el material ya está puesto pero no ha ajustado la altura, hágalo.<br/>
Asegúrese de que el punto de superposición quede alineado con el centro en la misma línea horizontal (ver Figura 52).<br/>
◆ Ajuste el ángulo de las luces:<br/>
Ponga la plataforma galvo a 151 mm desde la base. Luego:<br/>
Ajuste el ángulo de una luz roja para que el punto caiga en la línea horizontal derecha (recomendado 1-2 mm del centro).<br/>
Fije el tornillo y ajuste la otra para que los puntos se superpongan.<br/>
Consulte el video de calibración de posicionamiento del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52_ec916623-fcb5-4b6e-bf3a-c3e76f838900.png?v=1770866866:Figura 52]`,
          video_url: ['https://youtu.be/kuKp-jB_18M'],
        },
        {
          Q: `Desalineamiento de la cámara del Atelier.`,
          A: `Solución:<br/>
◆ Verifique la distancia de enfoque:<br/>
Después de colocar el material, asegúrese de ajustar la altura para superponer los puntos rojos sobre la superficie.<br/>
◆ Realice la alineación de la cámara:<br/>
La cámara viene calibrada de fábrica. En AtomStack Studio, solo hay que realizar la alineación.<br/>
Use una linterna para iluminar durante la captura, ya que no hay luz interna.<br/>
Cuanto menores sean los valores, mejor.<br/>
En LightBurn siga el procedimiento estándar.<br/>
Consulte el video de calibración de cámara tanto para AtomStack Studio como LightBurn.`,
          video_url: ['https://youtu.be/uUKBUhv837Y', 'https://youtu.be/6BWuEGxefzY'],
        },
        {
          Q: `Falla de la cámara del Atelier.`,
          A: `Solución:<br/>
◆ Verifique si está deshabilitada:<br/>
Abra el Administrador de dispositivos para ver si está restringida o deshabilitada.<br/>
Quite restricciones o active los permisos (ver Figura 53).<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53_b22082de-42e1-475b-b039-b35a76fbe95b.png?v=1770866893:Figura 53]<br/>
<br/>
◆ Verifique la conexión cámara-placa base:<br/>
Si la cámara no capta imagen, vea si el cable está flojo (ver Figura 54).<br/>
Use pinzas para desconectarlo y conectarlo de nuevo, luego pruebe.<br/>
◆ Reemplace la cámara si es necesario:<br/>
Si sigue sin funcionar, la cámara está defectuosa.<br/>
Reemplácela según el video de reemplazo de cámara del Atelier.<br/>
<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54_ab23d953-1f2c-41e9-a735-c11b38361e70.png?v=1770866919:Figura 54]`,
          video_url: ['https://youtu.be/tkjkBDb5_pI'],
        },
      ],
 
    ],
  },
  Glacier: {
    nav: [`Preguntas previas a la venta`, `Inicio rápido`, `Mantenimiento y cuidado`],
    nav_desc: [
      `Lo que debes saber antes de comprar`,
      `Tus primeros pasos simplificados (Para principiantes) `,
      `Mantén tu máquina en óptimas condiciones`,
    ],
    quantions: [
      // Categoría 1: Preguntas previas a la venta (Parte III)
      [
        {
          Q: `1. ¿Cuál es el área de trabajo de Glacier?`,
          A: `El área de trabajo es de 800 mm × 800 mm.`,
          video_url: [],
        },
        {
          Q: `2. ¿Cuál es la potencia del láser de Glacier?`,
          A: `Está disponible con láseres de diodo azul de 90 W y 120 W, y un láser infrarrojo de 4 W (el láser infrarrojo debe comprarse por separado).`,
          video_url: [],
        },
        {
          Q: `3. ¿Se puede ajustar la potencia del láser de Glacier?`,
          A: `Sí.<br/>
* Láser de 120 W: niveles seleccionables de 40 W / 80 W / 100 W / 120 W<br/>
* Láser de 90 W: niveles seleccionables de 35 W / 70 W / 90 W`,
          video_url: [],
        },
        {
          Q: `4. ¿Puede Glacier grabar y cortar materiales metálicos?`,
          A: `Puede grabar metal, pero no se recomienda cortar metal.<br/>
Los cabezales láser de diodo azul de 90 W y 120 W pueden grabar algunos metales como acero inoxidable, hierro, aluminio anodizado y latón.<br/>
El cabezal láser infrarrojo de 4 W puede grabar la mayoría de los metales.`,
          video_url: [],
        },
        {
          Q: `5. ¿Puede Glacier conectarse a una computadora mediante Wi-Fi?`,
          A: `Sí. Debe usar el cliente AtomStack Studio. Primero conecte la máquina con un cable Tipo-C para configurar la red. Una vez establecida la conexión, puede usar el modo Wi-Fi para operar. Consulte el video tutorial de conexión de Glacier.`,
          video_url: ['https://youtu.be/_VUVhREwP_8'],
        },
        {
          Q: `6. ¿Puede Glacier grabar termos o tazas?`,
          A: `Sí. Debe usarlo con el accesorio giratorio R6 / R8 / R8 Pro. Consulte la sección "Uso del accesorio giratorio de Glacier" para más detalles.`,
          video_url: [],
        },
        {
          Q: `7. ¿Hay una carcasa protectora disponible para Glacier?`,
          A: `Sí. La carcasa protectora B4 está disponible. Consulte el video de instalación de la carcasa B4 para las instrucciones de configuración.`,
          video_url: ['https://youtu.be/0k7GQdiZ-Q4'],
        },
        {
          Q: `8. ¿Hay un panel de panal compatible para Glacier?`,
          A: `Sí. Puede usar dos paneles de panal F8 combinados (los paneles F8 están diseñados para ser conectables).`,
          video_url: [],
        },
        {
          Q: `9. ¿Glacier incluye asistencia de aire? ¿Cuáles son los niveles de flujo de aire y ruido?`,
          A: `Sí, se incluye un sistema de asistencia de aire.<br/>
* Flujo de aire: 50 L/min<br/>
* Nivel de ruido: 73 dBA (medido cuando el ruido ambiental es de 48 dBA)`,
          video_url: [],
        },
        {
          Q: `10. ¿Puede Glacier usar módulos láser de otras marcas?`,
          A: `No. Se recomienda usar el módulo láser infrarrojo ATOMSTACK de 4 W.`,
          video_url: [],
        },
        {
          Q: `11. ¿Puede Glacier usar accesorios giratorios?`,
          A: `Sí, admite accesorios giratorios R6 / R8 / R8 Pro. Consulte la sección "Uso del accesorio giratorio de Glacier".<br/>
Notas:<br/>
◆ Al usar el mandril R8:<br/>
* Objetos cilíndricos: 0–80 mm de diámetro<br/>
* Objetos esféricos: 25–80 mm de diámetro<br/>
* Objetos en forma de anillo: 10–70 mm de diámetro<br/>
* Peso máximo soportado: 1.5 kg`,
          video_url: [],
        },
        {
          Q: `12. ¿Qué software de control se puede usar con Glacier?`,
          A: `Se recomienda usar AtomStack Studio o la aplicación AtomStack.<br/>
También puede usar LightBurn, pero deberá importar el archivo de configuración. Consulte la sección "Conexión de Glacier".`,
          video_url: [],
        },
        {
          Q: `13. ¿Glacier tiene funciones de seguridad?`,
          A: `Sí.<br/>
◆ Interruptor de parada de emergencia e interruptor de encendido: permite cortar la alimentación inmediatamente en situaciones de emergencia.<br/>
◆ Fusible de seguridad: corta automáticamente la alimentación si la corriente excede el valor nominal, protegiendo la máquina de daños.<br/>
◆ Carcasa de seguridad: la carcasa protectora B4 opcional ayuda a prevenir la contaminación lumínica, el humo y el polvo que afecten el entorno de trabajo.`,
          video_url: [],
        },
        {
          Q: `14. ¿Cuál es la temperatura de funcionamiento recomendada para Glacier?`,
          A: `La temperatura de trabajo recomendada es de 10–35 °C.<br/>
Si la temperatura desciende por debajo de 5 °C, se debe agregar anticongelante al enfriador.`,
          video_url: [],
        },
        {
          Q: `15. ¿Cuál es el recorrido máximo del eje Z de Glacier?`,
          A: `90 mm`,
          video_url: [],
        },
        {
          Q: `16. ¿Cuál es la velocidad máxima de grabado de Glacier?`,
          A: `La velocidad máxima de grabado puede alcanzar 24,000 mm/min.<br/>
Para parámetros detallados:<br/>
① Escanee el código QR de la máquina.<br/>
② Visite el sitio web oficial: https://atomstack.com/pages/product-support<br/>
③ Contacte al soporte al cliente para obtener la hoja de parámetros.`,
          video_url: [],
        },
        {
          Q: `17. ¿Cómo se debe almacenar Glacier cuando no está en uso?`,
          A: `Si la grabadora no se usará durante mucho tiempo, colóquela en un lugar seco. Se recomienda encender la máquina y hacerla funcionar durante unos 5 minutos una vez al mes para mantener la vida útil de los componentes electrónicos.`,
          video_url: [],
        },
      ],
      // Categoría 2: Inicio rápido (Parte I)
      [
        {
          Q: `1. Descripción de la interfaz de control de Glacier`,
          A: `[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_1_217b4b2d-fbcd-470b-815f-3116d3e07b74.png?v=1785143121:Glacier]<br/>
1) Interruptor de parada de emergencia:<br/>
En una emergencia, presione el interruptor de parada de emergencia para cortar la alimentación. La máquina dejará de funcionar para proteger tanto al personal como al equipo.<br/>
2) Llave USB:<br/>
Puerto de la llave USB. La máquina solo se puede usar después de insertar la llave USB (ya viene insertada de fábrica). Si la llave USB no está insertada, la máquina no puede emitir láser.<br/>
3) Botón de enfoque automático:<br/>
◆ Presione una vez para realizar el enfoque automático.<br/>
◆ Mantenga presionado más de 5 segundos para iniciar la configuración de Wi-Fi.<br/>
4) Indicador de temperatura del láser:<br/>
◆ Verde fijo: estado normal, 16 °C ≤ temperatura del láser ≤ 40 °C.<br/>
◆ Amarillo fijo: estado de advertencia, 40 °C ≤ temperatura del láser ≤ 50 °C.<br/>
◆ Rojo intermitente: estado de alarma, temperatura del láser < 16 °C o > 50 °C, acompañado de una alarma sonora.<br/>
5) Indicador de alarma de arranque del enfriador:<br/>
◆ Verde fijo: arranque normal.<br/>
◆ Rojo intermitente: estado de alarma, como alarma de flujo o alarma de nivel bajo de agua, acompañado de una alarma sonora.<br/>
6) Indicador de conexión Wi-Fi:<br/>
◆ Verde fijo: Wi-Fi conectado normalmente.<br/>
◆ Azul intermitente: emparejamiento/configuración de Wi-Fi en curso.<br/>
◆ Rojo intermitente: fallo de conexión Wi-Fi, acompañado de una alarma sonora.<br/>
7) Indicador de estado de la máquina:<br/>
◆ Verde fijo: modo de espera.<br/>
◆ Verde intermitente: máquina en funcionamiento.<br/>
◆ Rojo intermitente: estado de alarma, como temperatura anormal del láser, mal funcionamiento del enfriador, alarma de detección de llama, alarma de interruptor de límite, etc., acompañado de una alarma sonora.<br/>
8) USB DRIVE:<br/>
Puerto para unidad flash USB.<br/>
9) COMPUTER:<br/>
Puerto para computadora. Conéctese a la computadora mediante un cable Tipo-C.<br/>
10) ACCESSORY:<br/>
Puerto de accesorios de expansión con función de reconocimiento automático. Puede conectar accesorios como R6, R8, R8 Pro, R5, etc., que admiten reconocimiento automático.<br/>
11) SCREEN:<br/>
Puerto de pantalla táctil. Conecte la pantalla táctil mediante un cable HDMI.<br/>
12) AIR ASSIST:<br/>
Puerto de salida de alimentación de la asistencia de aire. Puede controlar automáticamente el encendido y apagado de la asistencia de aire.<br/>
13) FIRE SAFETY:<br/>
Puerto de salida de alimentación del extintor activo. Cuando ocurre una alarma de llama, si hay una bomba extintora instalada, se activará la función de extinción y la bomba extinguirá el fuego automáticamente.<br/>
Nota: La asistencia de aire incluida con la grabadora no tiene esta función.<br/>
14) WATER COOLING:<br/>
Puerto del enfriador. Conéctelo a la caja de control mediante un cable VGA.<br/>
15) Interruptor de alimentación de la grabadora:<br/>
Se utiliza para encender o apagar la grabadora.<br/>
16) Fusible de la grabadora:<br/>
Se funde automáticamente cuando la corriente del circuito supera los 15 A.<br/>
17) Puerto del cable de alimentación de la grabadora:<br/>
Se utiliza para conectar a la red eléctrica. Asegúrese de que el voltaje coincida con los requisitos del equipo.<br/>
18) Puerto del cable de alimentación del enfriador:<br/>
Se utiliza para conectar a la red eléctrica. Asegúrese de que el voltaje coincida con los requisitos del equipo.<br/>
19) Fusible del enfriador:<br/>
Se funde automáticamente cuando la corriente supera los 5 A.<br/>
20) Interruptor de alimentación del enfriador:<br/>
Se utiliza para encender o apagar el enfriador.<br/>
21) ALARM:<br/>
Puerto de conexión para dispositivos de alarma.<br/>
22) DATA:<br/>
Interfaz de comunicación entre el enfriador y la caja de control, conectada mediante un cable VGA.<br/>
23) INLET:<br/>
Puerto de retorno de agua para la circulación.<br/>
24) OUTLET:<br/>
Puerto de salida de agua para la circulación.<br/>
25) Puerto de llenado de agua:<br/>
Entrada de agua para el tanque del enfriador.<br/>
26) Indicador de nivel de agua:<br/>
Ventana para observar el nivel de agua del enfriador. Asegúrese de que el nivel de agua no baje de la marca mínima.<br/>
27) Puerto de drenaje del tanque:<br/>
Salida de drenaje del tanque del enfriador.<br/>
28) Interruptor giratorio:<br/>
Se utiliza para encender la asistencia de aire y ajustar el nivel de flujo de aire.`,
          video_url: [],
        },
        {
          Q: `2. Video de desempaque de Glacier`,
          A: `Consulte el video de desempaque de Glacier o el manual del usuario.<br/>
Antes de encender la máquina, confirme lo siguiente:<br/>
◆ Compatibilidad de voltaje:<br/>
Antes de conectar la alimentación, confirme que la especificación de voltaje de la máquina recibida coincida con el voltaje de la red eléctrica local. Glacier admite dos especificaciones de voltaje: 230 V y 115 V.<br/>
Si la máquina recibida está configurada a 115 V, pero su voltaje local es de 220 V, ajuste el selector de voltaje de la siguiente manera: use un destornillador o pinzas para mover el interruptor hacia la izquierda o derecha a la posición de voltaje adecuada, como se muestra en la Figura 1.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_2_48ba89ec-45da-4fc6-83cc-e1f578e8273f.png?v=1785143122:Figura 1]<br/>
◆ Conexiones de agua:<br/>
No hay requisito específico para conectar los puertos de entrada y salida de agua del láser. Sin embargo, la entrada y salida del enfriador deben conectarse según las etiquetas de los puertos.<br/>
◆ Llenado del enfriador:<br/>
Antes de encender, llene el enfriador de agua con agua destilada, agua purificada o agua de alta pureza. El nivel de agua debe estar por encima de la marca mínima, como se indica en la escala del enfriador.<br/>
◆ Inspección de las mangueras de agua:<br/>
Asegúrese de que las mangueras de agua del enfriador no estén dobladas, dañadas ni tengan fugas. No agregue líquidos corrosivos al sistema.<br/>
◆ Entorno de trabajo:<br/>
Asegúrese de que el entorno de trabajo esté bien ventilado y de que no se acumulen materiales inflamables en el área de trabajo.<br/>
◆ Ubicación de la máquina:<br/>
Durante el funcionamiento, la máquina debe colocarse en posición horizontal. Está estrictamente prohibido inclinarla, voltearla o colocarla boca abajo.<br/>
◆ Llave USB:<br/>
Asegúrese de que la llave USB esté insertada.<br/>
◆ Seguridad del láser:<br/>
Nunca mire directamente al láser sin protección. Se deben usar gafas de seguridad láser durante el funcionamiento y no deje la máquina desatendida mientras esté funcionando.`,
          video_url: ['https://youtu.be/Ym8gOrVkKls'],
        },
        {
          Q: `3. Conexión y operación de Glacier`,
          A: `Consulte el video tutorial de conexión de Glacier.<br/>
Notas:<br/>
◆ Instalación del controlador CH340:<br/>
Al usar la máquina por primera vez, la computadora necesita instalar el controlador de puerto serie CH340.<br/>
◆ Uso de AtomStack Studio:<br/>
Al usar AtomStack Studio, la máquina se puede conectar y usar directamente sin configuración adicional.<br/>
◆ Uso de LightBurn:<br/>
Al usar LightBurn, asegúrese de que la velocidad en baudios esté configurada en 460800, como se muestra en la Figura 2, o importe el archivo de configuración de la máquina.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_3_37cbd55a-1320-483a-ac00-5c271d40e635.png?v=1785143121:Figura 2]<br/>
◆ Conexión Wi-Fi:<br/>
Para habilitar la conexión Wi-Fi, mantenga presionado el botón de enfoque automático durante más de 5 segundos para iniciar el emparejamiento Wi-Fi, como se muestra en la Figura 3.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_4_901a6cfa-bb16-4ad6-ad41-6c7b0c9addb6.png?v=1785143121:Figura 3]`,
          video_url: ['https://youtu.be/_VUVhREwP_8'],
        },
        {
          Q: `4. Cambio de potencia del láser de Glacier`,
          A: `Consulte el video tutorial de cambio de potencia del láser de Glacier.<br/>
Notas:<br/>
◆ Módulo láser de 120 W:<br/>
En modo normal, el láser de 120 W puede cambiar entre 100 W, 80 W y 40 W.<br/>
Para alcanzar 120 W, se debe habilitar el Modo Overclock. Sin embargo, no se recomienda el uso prolongado del modo overclock.<br/>
◆ Módulo láser de 90 W:<br/>
En modo normal, el láser de 90 W puede cambiar entre 70 W y 35 W.<br/>
Para alcanzar 90 W, se debe habilitar el Modo Overclock. Sin embargo, no se recomienda el uso prolongado del modo overclock.<br/>
◆ Operación de software:<br/>
El cambio de potencia del láser de Glacier debe realizarse dentro del software.<br/>
El cambio de potencia en AtomStack Studio se muestra en la Figura 4, y en LightBurn se muestra en la Figura 5.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_0954cc22-3b09-40bc-9bf3-d849d773c1c4.png?v=1785143121:Figura 4]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_5_1217b2e2-50b4-4c02-8404-5c5ee5f6acdc.png?v=1785144369:Figura 5]`,
          video_url: ['https://youtu.be/B4427uS23xM'],
        },
        {
          Q: `5. Enfoque automático y enfoque manual de Glacier`,
          A: `Consulte el video tutorial de enfoque automático y enfoque manual de Glacier.<br/>
Notas:<br/>
◆ Enfoque automático:<br/>
Al usar el enfoque automático, presione el botón de enfoque una vez brevemente para iniciar el proceso. No mantenga presionado el botón de enfoque.<br/>
◆ Enfoque manual:<br/>
Al usar el enfoque manual, coloque la pieza de enfoque de 20 mm entre el material de trabajo y el borde inferior del marco del módulo láser.<br/>
La distancia focal de corte recomendada es de 16 mm, y la distancia focal de corte mínima (extrema) es de 4 mm.`,
          video_url: ['https://youtu.be/k8c02BDPcAY'],
        },
        {
          Q: `6. Cómo agregar anticongelante a Glacier`,
          A: `Consulte el video tutorial de llenado de anticongelante de Glacier.<br/>
Notas:<br/>
Cuando la temperatura ambiente es superior a 5 °C, no se requiere anticongelante.<br/>
La proporción de mezcla recomendada de temperatura ambiente, anticongelante y agua de refrigeración es la siguiente:<br/>
[table:antifreeze_ratio]`,
          tables: {
            antifreeze_ratio: {
              headers: [
                'Temperatura ambiental mínima anual',
                'Proporción de mezcla recomendada (Concentrado anticongelante : Agua purificada)',
                'Concentrado anticongelante',
                'Agua de refrigeración',
              ],
              rows: [
                ['Temperatura ambiente＞5', '0', '0', '1800'],
                ['-10≤Temperatura ambiente＜5', '2:8', '360', '1440'],
                ['-20≤Temperatura ambiente＜-10', '3:7', '540', '1260'],
                ['-30≤Temperatura ambiente＜-20', '4:6', '720', '1080'],
                ['-40≤Temperatura ambiente＜-30', '5:5', '900', '900'],
                ['-50≤Temperatura ambiente＜-40', '6:4', '1080', '720'],
              ],
            },
          },
          video_url: ['https://youtu.be/g-ykAcasOUs'],
        },
        {
          Q: `7. Uso del accesorio giratorio de Glacier`,
          A: `Consulte el video tutorial del accesorio giratorio de Glacier.<br/>
Notas:<br/>
◆ La caja de control de Glacier incluye un puerto "ACCESSORY", por lo que es compatible con todos los accesorios giratorios de AtomStack. Sin embargo, debido a la compatibilidad con los elevadores, solo se recomiendan los dispositivos giratorios AtomStack R6, AtomStack R8 y AtomStack R8 Pro (los elevadores apropiados deben comprarse por separado).<br/>
◆ Use el cable de conexión USB incluido (como se muestra en la Figura 6) para conectar el accesorio giratorio R6, R8 o R8 Pro.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_6_4aafc00a-72ff-45e6-8548-8e15d2f7886b.png?v=1785144897:Figura 6]<br/>
◆ Configuración del software AtomStack:<br/>
Al usar AtomStack Studio, seleccione el dispositivo detectado en el software.<br/>
* Rodillo (R6): No se requiere configuración de parámetros.<br/>
* Mandril (R8): Debe configurar la circunferencia o el diámetro del material, como se muestra en la Figura 7.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_7_9375ec8f-a162-418d-b862-42ae88e95d7b.png?v=1785144897:Figura 7]<br/>
◆ Configuración de LightBurn: Al usar LightBurn, los parámetros del giratorio deben configurarse manualmente.<br/>
Configuraciones requeridas:<br/>
* Tipo de giratorio (R6: tipo rodillo  R8: tipo mandril)<br/>
* Eje giratorio (Seleccione el eje Y)<br/>
Configuración de parámetros<br/>
R8 (Mandril):<br/>
* Pasos por rotación: 160 mm por rotación (valor fijo)<br/>
* Ingrese el diámetro o la circunferencia del material<br/>
R6 (Rodillo):<br/>
* Pasos por rotación: 50 mm por rotación (valor fijo)<br/>
* Diámetro de rotación: 16 mm (valor fijo)<br/>
* Ingrese el diámetro o la circunferencia del material<br/>
Vea la Figura 8.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_8_9f35988e-1324-4e6b-b4f6-2a8163d30c5c.png?v=1785144897:Figura 8]<br/>
Notas:<br/>
◆ Al usar el mandril R8, el rango de diámetro de objetos cilíndricos admitido es de 0–80 mm.<br/>
◆ Al usar el mandril R8, el rango de diámetro de objetos esféricos admitido es de 25–80 mm.<br/>
◆ Al usar el mandril R8, el rango de diámetro de objetos circulares admitido es de 10–70 mm.<br/>
◆ La capacidad de carga máxima del mandril R8 es de 1.5 kg.`,
          video_url: ['https://youtu.be/fG3qm02Cg0A'],
        },
        {
          Q: `8. Configuración del origen y posicionamiento de Glacier`,
          A: `Consulte el video tutorial de configuración del origen y posicionamiento de Glacier.<br/>
Notas:<br/>
◆ Al configurar el origen, primero haga clic en Inicio para devolver la máquina a la coordenada 0,0.<br/>
◆ Después de que la máquina haya vuelto a 0,0, no mueva la máquina manualmente. Todos los movimientos deben controlarse a través del software; de lo contrario, la máquina no podrá reconocer las coordenadas con precisión.<br/>
◆ Si la máquina se mueve accidentalmente a mano, debe volver a pasar por el inicio antes de posicionar.`,
          video_url: ['https://youtu.be/QiqDjgCAbRQ'],
        },
        {
          Q: `9. Introducción al sistema de coordenadas del software de Glacier`,
          A: `◆ Posición actual:<br/>
La posición actual del módulo láser se usa como punto de partida para el procesamiento. Puede mover manualmente el módulo láser a la posición de procesamiento deseada.<br/>
◆ Origen de usuario:<br/>
El origen definido por el usuario es una posición de inicio establecida por el usuario para que el láser comience a operar. Consulte el video tutorial de configuración del origen y posicionamiento de Glacier.<br/>
◆ Coordenadas absolutas:<br/>
Usa la posición 0,0 después del inicio como punto de partida, y las coordenadas del objeto de procesamiento determinan dónde comienza a operar el láser.`,
          video_url: ['https://youtu.be/QiqDjgCAbRQ'],
        },
        {
          Q: `10. Prueba de parámetros de grabado de Glacier en el software`,
          A: `Consulte el video tutorial de prueba de parámetros de grabado de Glacier.<br/>
Nota:<br/>
◆ Esta función solo está disponible en LightBurn (versión 1.3.01 o posterior, versión con licencia) o en AtomStack Studio.`,
          video_url: ['https://youtu.be/78ntKGyes_g'],
        },
        {
          Q: `11. Precauciones para el uso prolongado de Glacier`,
          A: `Al usar la máquina durante períodos prolongados, se recomienda pausar la operación durante 5–10 minutos después de cada 2 horas de uso. Esto permite que el sistema de refrigeración se recupere y vuelva a su condición operativa óptima.`,
          video_url: [],
        },
        {
          Q: `12. Materiales prohibidos para procesar con Glacier`,
          A: `Materiales prohibidos:<br/>
* PVC (libera gas de cloro al procesarse)<br/>
* Plásticos que contienen cloro<br/>
* Metales con recubrimientos desconocidos<br/>
* Materiales altamente reflectantes tipo espejo (el láser reflejado puede dañar el módulo láser)<br/>
Nota:<br/>
Antes de procesar materiales desconocidos, se recomienda realizar primero una prueba de baja potencia.`,
          video_url: [],
        },
      ],
      // Categoría 3: Mantenimiento y cuidado (Parte II + Parte IV)
      [
        {
          Q: `1. Resumen del programa de mantenimiento`,
          A: `[table:maintenance_schedule]`,
          tables: {
            maintenance_schedule: {
              headers: ['Elemento', 'Frecuencia de limpieza recomendada'],
              rows: [
                [
                  'Limpieza de la ventana del láser',
                  'Para usuarios frecuentes: limpiar una vez al día. Para usuarios ocasionales: limpiar una vez por semana.',
                ],
                [
                  'Entrada de la asistencia de aire',
                  'Para usuarios frecuentes: limpiar una vez cada medio mes. Para usuarios ocasionales: limpiar una vez al mes.',
                ],
                ['Filtro del enfriador', 'Limpiar cada 20–25 días.'],
                ['Reemplazo del agua de refrigeración', 'Reemplazar cada 45 días.'],
                ['Guía del perfil', 'Limpiar cada 500 horas de funcionamiento.'],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `2. Limpieza de la ventana protectora y la lente de enfoque del láser de Glacier`,
          A: `Consulte el video tutorial de limpieza de la lente del láser de Glacier.<br/>
Notas:<br/>
◆ Riesgos de no limpiar:<br/>
Una ventana protectora contaminada puede bloquear la energía del láser, lo que resulta en una reducción de la potencia de grabado. La acumulación de calor en la ventana puede dañarla y también puede provocar daños en la lente de enfoque.<br/>
◆ Herramientas de limpieza recomendadas:<br/>
Use un paño sin pelusa o hisopos ópticos sin pelusa para limpiar (evite los hisopos de algodón comunes que pueden soltar fibras).<br/>
Use etanol anhidro al 99% o un limpiador de lentes ópticas profesional. Evite disolventes que contengan amoníaco o acetona.<br/>
◆ Método de limpieza:<br/>
Aplique etanol anhidro al 99% o un limpiador de lentes ópticas profesional.<br/>
Al limpiar, use un paño sin pelusa y limpie en una sola dirección (por ejemplo, en espiral desde el centro hacia afuera) para evitar rayones causados por el frotamiento repetido de ida y vuelta.<br/>
◆ Inspección después de la limpieza:<br/>
Después de limpiar, inspeccione la lente bajo una iluminación lateral fuerte para asegurarse de que no haya marcas de agua ni residuos de fibras.<br/>
◆ Frecuencia de limpieza:<br/>
Para usuarios frecuentes, se recomienda limpiar una vez después de cada día de uso.<br/>
Para usuarios ocasionales, se recomienda limpiar una vez por semana.<br/>
◆ Aviso importante:<br/>
La lente de enfoque no es desmontable. No intente abrirla ni desarmarla. El desmontaje no autorizado puede dañar la estructura de sellado del módulo láser y anulará la garantía.<br/>
Después de desatornillar la ventana protectora, la lente de enfoque será visible, como se muestra en la Figura 9.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_9_3ac5f1c9-6fc6-4a3e-a0f2-42d6a4054a74.png?v=1785145364:Figura 9]`,
          video_url: ['https://youtu.be/I0t0Q8YmpPc'],
        },
        {
          Q: `3. Limpieza de la asistencia de aire de Glacier`,
          A: `Consulte el video de limpieza de la asistencia de aire de Glacier para obtener orientación.<br/>
Notas:<br/>
◆ Herramientas de limpieza: paño sin pelusa, etanol anhidro.<br/>
◆ Frecuencia de limpieza: si el entorno de trabajo tiene polvo, se recomienda limpiar una vez cada dos semanas para evitar el sobrecalentamiento o daños causados por la obstrucción de la entrada de la bomba de aire.<br/>
◆ Método de limpieza:<br/>
Primero, use un paño sin pelusa con etanol anhidro para limpiar el polvo de la entrada de aire en la carcasa de la asistencia de aire.<br/>
Luego abra la carcasa y limpie el polvo dentro de la carcasa y la entrada de aire de la propia bomba.<br/>
◆ Precauciones:<br/>
Si el conector de alimentación de la bomba de aire se ha desconectado, asegúrese de distinguir los terminales positivo y negativo al reconectarlo.<br/>
El lado marcado con un punto rojo indica el terminal positivo, como se muestra en la Figura 10.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_10_85f5002a-0ba0-440f-a54a-603865d10182.png?v=1785145364:Figura 10]`,
          video_url: ['https://youtu.be/WgsUUTQJX64'],
        },
        {
          Q: `4. Limpieza del enfriador de Glacier`,
          A: `Consulte el video de limpieza del enfriador de Glacier para obtener orientación.<br/>
Notas:<br/>
◆ Agua de refrigeración compatible: agua purificada, agua destilada o agua de alta pureza.<br/>
◆ Frecuencia de limpieza:<br/>
* Limpiar la pantalla del filtro cada 20–25 días.<br/>
* Reemplazar el agua de refrigeración cada 45 días.<br/>
◆ Herramientas de limpieza: paño sin pelusa, etanol anhidro.<br/>
◆ Método de limpieza:<br/>
Primero, use un paño sin pelusa con etanol anhidro para limpiar suavemente el polvo y las manchas de la carcasa del enfriador. Después de limpiar el exterior, retire las pantallas del filtro en ambos lados y limpie a fondo todo el polvo y los residuos. Finalmente, retire los dos ventiladores traseros y límpielos.<br/>
◆ Precauciones:<br/>
-- No use líquidos corrosivos para la limpieza y no agregue sustancias corrosivas al agua de refrigeración.<br/>
-- No se recomienda el agua del grifo para uso prolongado (puede causar incrustaciones), lo que podría obstruir el canal de agua con el tiempo.<br/>
-- Si la temperatura es inferior a 5 °C y la unidad no se usará durante un período prolongado, drene toda el agua del enfriador para evitar la congelación y las grietas.`,
          video_url: ['https://youtu.be/GaQ6QaJoQR8'],
        },
        {
          Q: `5. Limpieza del marco de la máquina de Glacier`,
          A: `Consulte el video de limpieza del marco de la máquina de Glacier para obtener orientación.<br/>
Notas:<br/>
◆ Herramientas de limpieza:<br/>
Etanol anhidro al 99%, paño sin pelusa y grasa.<br/>
(Para la selección de grasa, se recomienda usar NLGI Grado 2 o 3:<br/>
* Use Grado 2 para entornos por debajo de 15 °C.<br/>
* Use Grado 3 para entornos por encima de 15 °C.)<br/>
◆ Frecuencia de limpieza:<br/>
Se recomienda limpiar cada 500 horas de funcionamiento.<br/>
◆ Método de limpieza:<br/>
Use un paño sin pelusa con etanol anhidro al 99% para limpiar suavemente el polvo del marco de la máquina. Después de limpiar los ejes lineales y las superficies de acero de los rodamientos, aplique una capa uniforme de grasa sobre ellos.<br/>
◆ Precauciones:<br/>
No use líquidos corrosivos para la limpieza. Después de limpiar, los ejes lineales y las superficies de acero de los rodamientos deben lubricarse uniformemente con grasa.`,
          video_url: ['https://youtu.be/NNuQZsqwEXI'],
        },
        {
          Q: `6. Tabla de diagnóstico rápido de fallas`,
          A: `[table:fault_diagnosis]`,
          tables: {
            fault_diagnosis: {
              headers: ['Síntoma', 'Verificaciones prioritarias'],
              rows: [
                [
                  'Atenuación de potencia',
                  'Ventana protectora, lente de enfoque, configuración de parámetros del software, valor máximo S en el software',
                ],
                [
                  'El láser no emite',
                  'Conexiones del cable del láser, configuraciones de salida del software, configuraciones de potencia del software, estado del indicador en la parte superior del láser',
                ],
                [
                  'Fallo de conexión',
                  'Velocidad en baudios, puerto del cable Tipo-C, puerto USB de la computadora, controlador CH340',
                ],
                [
                  'Se detiene durante el grabado',
                  'Cable Tipo-C, puerto USB de la computadora, incapacidad de Windows 11 para ejecutarse en segundo plano, probar con otro software',
                ],
                [
                  'Alarma de grabado',
                  'Material, placa de detección de llama, conexiones de cables, densidad de líneas de grabado',
                ],
                [
                  'Alarma de llama',
                  'Instalación correcta del láser, cableado del motor del eje Z, interruptores de límite superior/inferior, cableado del interruptor de límite, estado de funcionamiento del motor',
                ],
                [
                  'Salida de grabado distorsionada',
                  'Estructura del marco, alineación del eje X, configuración de pasos de los ejes X/Y, verificar las ruedas BOM, verificar los acoplamientos',
                ],
                [
                  'Fallo de conexión de la APP',
                  'Modo Wi-Fi habilitado, nombre de Wi-Fi detectado, apagar los datos móviles, probar con otro teléfono',
                ],
              ],
            },
          },
          video_url: [],
        },
        {
          Q: `7. Contaminación o daño de la lente de enfoque o la ventana protectora del módulo láser de Glacier`,
          A: `Solución:<br/>
Contaminación:<br/>
Primero, limpie según la sección "Limpieza de la ventana protectora y la lente de enfoque del láser de Glacier". Si la mancha no se puede eliminar, se puede reemplazar el vidrio de la ventana protectora (la máquina incluye dos vidrios de repuesto adicionales).<br/>
Daño:<br/>
Si el vidrio de la ventana protectora está dañado, se puede reemplazar (la máquina incluye dos vidrios de repuesto adicionales). Si la lente de enfoque está dañada, se debe reemplazar todo el módulo láser. Por lo tanto, determine la frecuencia de limpieza de la ventana protectora según el uso para evitar daños en la lente de enfoque causados por la contaminación o el daño de la ventana.`,
          video_url: [],
        },
        {
          Q: `8. Disminución significativa del rendimiento de corte del módulo láser de Glacier`,
          A: `Solución:<br/>
1) Atenuación normal de potencia:<br/>
Después de un período de uso, el módulo láser puede experimentar una degradación normal de potencia. Esto se puede compensar aumentando la potencia o reduciendo la velocidad.<br/>
2) Verifique la distancia focal del láser:<br/>
Use una regla o una herramienta similar para medir la distancia entre la parte inferior del módulo láser y la superficie del material. Debe ser de 16 mm o 4 mm.<br/>
3) Verifique el nivel de potencia del láser:<br/>
El módulo láser de Glacier admite múltiples niveles de potencia (consulte la "Guía de cambio de potencia del láser de Glacier"). Confirme la capacidad de corte correspondiente al nivel de potencia seleccionado según la tabla de parámetros.<br/>
4) Verifique la configuración de parámetros:<br/>
Verifique si los parámetros actuales coinciden con el material según la tabla de parámetros y el nivel de potencia seleccionado. Tenga en cuenta que la unidad de velocidad es mm/min.<br/>
Cómo acceder a la tabla de parámetros de Glacier:<br/>
① Escanee el código QR en el cuerpo de la máquina.<br/>
② Visite el sitio web oficial: https://atomstack.com/pages/product-support<br/>
③ Contacte al servicio al cliente para solicitarla.<br/>
5) Confirme el valor máximo de S:<br/>
Al usar el software LightBurn, asegúrese de que el valor máximo de S no haya sido modificado (vea la Figura 11).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_11_70335b12-39ab-4833-a973-423e37377365.png?v=1785146838:Figura 11]<br/>
6) Verifique el estado del módulo láser:<br/>
Corte una tabla de tilo (basswood) de 3 mm a una velocidad de 1200 mm/min y al 100% de potencia para verificar el rendimiento.<br/>
* Si corta por completo en una pasada, la potencia es normal.<br/>
* Si no puede cortar por completo, siga los pasos a continuación:<br/>
◆ Verifique la lente del láser:<br/>
Apague el dispositivo y retire el módulo láser. Inspeccione el vidrio de la ventana protectora y la lente de enfoque para detectar contaminación o daños.<br/>
* Para la contaminación, consulte la sección "Limpieza de la ventana protectora y la lente de enfoque del láser de Glacier".<br/>
* Si las manchas no se pueden eliminar o si hay daños, reemplace la ventana protectora (se incluyen dos piezas de repuesto).<br/>
* Si la lente de enfoque está dañada, se debe reemplazar todo el módulo láser.<br/>
Proporcione fotos claras y el código grabado del módulo láser (vea la Figura 12) al servicio al cliente para obtener ayuda.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_12_36f064d9-e032-4f4e-94af-6879a649dcff.png?v=1785146838:Figura 12]<br/>
◆ Verifique el punto del láser:<br/>
Si la lente está limpia, apunte el láser a un techo o una pared a 2–3 metros de distancia y actívelo brevemente para observar el punto.<br/>
Verifique si el punto está disperso o es anormal. Tome una foto clara del punto (vea la Figura 13) y envíela al servicio al cliente para su confirmación. Consulte la guía "Inspección del punto del láser de Glacier".<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_13_8b6ec425-886f-4ba1-92b5-e47b16344cf9.png?v=1785146838:Figura 13]<br/>
7) Si no se encuentran problemas arriba:<br/>
Grabe un video que muestre el corte de una tabla de tilo de 3 mm a 1200 mm/min y al 100% de potencia, incluyendo claramente:<br/>
* Configuración de parámetros del software<br/>
* Proceso de corte<br/>
* Resultado del corte<br/>
* Pasos de solución de problemas ya realizados<br/>
Envíe el video junto con el código grabado del módulo láser al servicio al cliente para obtener más soporte.`,
          video_url: [],
        },
        {
          Q: `9. El módulo láser se mueve durante el grabado, pero no se emite láser`,
          A: `Solución:<br/>
1) Verifique el cableado del láser:<br/>
Apague la máquina, desconecte el cable del láser y vuelva a conectarlo para ver si vuelve a la normalidad.<br/>
2) Verifique la configuración de parámetros del software:<br/>
Configure los parámetros según la tabla de parámetros. Asegúrese de que la opción "Salida" junto a la capa esté habilitada (no debe estar apagada), como se muestra en la Figura 14.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_14_ca3cbf7c-8651-41b7-8c88-bb7787af18cd.png?v=1785146838:Figura 14]<br/>
3) Verifique las luces indicadoras del láser:<br/>
Observe cuidadosamente si ambas luces indicadoras en la parte superior del módulo láser están encendidas durante el grabado o corte (vea la Figura 15).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_15_d533c52e-ae95-4f1d-b729-6d61d4a5842e.png?v=1785146839:Figura 15]<br/>
◆ Ambas luces encendidas:<br/>
Si tanto la luz indicadora roja como la verde están encendidas, esto indica una falla del módulo láser interno (diodo láser).<br/>
◆ Ambas luces apagadas:<br/>
Esto indica una falla en la placa principal o en el cable de conexión.<br/>
◆ Solo la luz roja encendida:<br/>
Si solo la luz roja está encendida y la verde está apagada, abra la carcasa del módulo láser y desconecte los tres cables de conexión del diodo en la placa del controlador (vea la Figura 16). Luego conecte los dos tubos de refrigeración por agua y ejecute el programa de grabado para verificar si la luz indicadora verde se enciende.<br/>
* Si la luz verde se enciende después de desconectar los cables del diodo, el diodo está defectuoso.<br/>
* Si aún no se enciende, el problema está en la placa del controlador o en el cable de conexión de la placa principal.<br/>
Proporcione un video de solución de problemas junto con el Número de serie de la máquina (vea la Figura 17) y el código grabado del módulo láser (vea la Figura 18) al servicio al cliente para obtener ayuda. Para los procedimientos de reemplazo (cable de conexión de la placa principal, placa del controlador, módulo láser), consulte las siguientes guías:<br/>
* Video de reemplazo del cable de conexión de la placa principal de Glacier<br/>
* Video de reemplazo de la placa del controlador de Glacier<br/>
* Video de reemplazo del módulo láser de Glacier<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_16_4065ec84-e508-4cd4-bf2b-d10c5b308676.png?v=1785146839:Figura 16]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_17_286f0c87-e33d-4329-91f1-76b4979adaf8.png?v=1785146839:Figura 17]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_18_68909cb3-090c-4402-b8c3-149f65145cdd.png?v=1785146838:Figura 18]`,
          video_url: ['https://youtu.be/-8kWd_oX3oo', 'https://youtu.be/G9NPYDo0aTg', 'https://youtu.be/-nmgscPGeKM'],
        },
        {
          Q: `10. Glacier no puede conectarse a una computadora`,
          A: `Solución:<br/>
1) Confirme que la caja de control esté encendida correctamente:<br/>
Verifique si las tres luces indicadoras en la parte frontal de la caja de control están encendidas (vea la Figura 19).<br/>
Si solo la luz del interruptor de alimentación está encendida y las luces indicadoras frontales están apagadas, verifique si el botón de parada de emergencia está presionado y no liberado. Presiónelo, gírelo en el sentido de las agujas del reloj y suéltelo.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_19_ee71e195-f959-4db6-8f19-d5265014ec7b.png?v=1785147594:Figura 19]<br/>
2) Verifique el puerto serie seleccionado:<br/>
* Al usar AtomStack Studio, no se requiere selección.<br/>
* Al usar LightBurn, asegúrese de que el puerto serie correcto esté seleccionado. Puede verificar a qué puerto COM está asignado el CH340 en el Administrador de dispositivos de la computadora (vea la Figura 20).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_20_1d6e8fc8-8fce-4e06-abb2-7fe2e989d3c7.png?v=1785147594:Figura 20]<br/>
3) Verifique el sistema operativo de la computadora:<br/>
* En Windows, puede usar directamente una conexión Tipo-C a USB-A o USB-C.<br/>
* En macOS o HarmonyOS, debe usar un concentrador/estación de acoplamiento (vea la Figura 21) para conectar el puerto USB-A del cable Tipo-C.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_21_a6d56c4a-ace0-4f12-9310-915044d59ae8.png?v=1785147593:Figura 21]<br/>
4) Asegúrese de que ningún otro software esté ocupando la conexión:<br/>
Asegúrese de que ningún otro software esté actualmente conectado a la grabadora.<br/>
5) Verifique la velocidad en baudios:<br/>
* No es necesaria para AtomStack Studio.<br/>
* Para LightBurn, asegúrese de que la velocidad en baudios esté configurada en 460800 (vea la Figura 22).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_22_56cb8b94-b6f2-4679-bbcb-d906083f549a.png?v=1785147593:Figura 22]<br/>
6) Verifique el controlador serie:<br/>
En el Administrador de dispositivos, verifique si hay un puerto serie CH340.<br/>
* Si no, instale el controlador usando los enlaces a continuación:<br/>
* Controlador de Windows: [https://asa.atomstack.com/downloadWindowsDrivers.do3](https://asa.atomstack.com/downloadWindowsDrivers.do3)<br/>
* Controlador de Mac: [https://asa.atomstack.com/downloadMacDrivers.do3](https://asa.atomstack.com/downloadMacDrivers.do3)<br/>
También puede consultar el video tutorial de instalación del controlador serie.<br/>
7) Verifique la configuración del controlador:<br/>
* No es necesaria para AtomStack Studio.<br/>
* Para LightBurn, asegúrese de que se agregue un controlador GRBL (vea la Figura 23), o importe el archivo de configuración de fábrica de Glacier (consulte el video tutorial de conexión de Glacier).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_23_4c00b783-0452-4315-a3da-bb7ebe71fdd8.png?v=1785147593:Figura 23]<br/>
8) Verifique los cables y puertos:<br/>
Intente reemplazar el cable Tipo-C o usar un puerto USB diferente en la computadora.<br/>
9) Pruebe con otro software o computadora:<br/>
Intente usar AtomStack Studio o LightBurn, o pruebe con otra computadora.<br/>
10) Si el problema persiste:<br/>
Proporcione un video de la falla, los pasos de solución de problemas realizados y el Número de serie de la máquina (vea la Figura 24) al servicio al cliente para obtener ayuda.<br/>
Para el reemplazo de la placa principal, consulte el video de reemplazo de la placa principal de Glacier.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_24_493d1e07-f798-41d8-9900-9be4171485f0.png?v=1785147594:Figura 24]`,
          video_url: ['https://youtu.be/_VUVhREwP_8', 'https://youtu.be/BZloFqfgtCE', 'https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `11. Glacier no puede conectarse a un teléfono móvil`,
          A: `Solución:<br/>
1) Confirme que el modo Wi-Fi esté habilitado:<br/>
Mantenga presionado el botón de enfoque automático durante más de 5 segundos para entrar en el modo Wi-Fi. Verifique si el indicador de estado de Wi-Fi parpadea en azul normalmente (vea la Figura 25).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_25_ad4b51d8-2217-48e2-9b5c-0bb4aaf6dd53.png?v=1785147594:Figura 25]<br/>
2) Confirme que se usa la APP correcta:<br/>
Descargue la aplicación AtomStack. Puede descargarla desde el sitio web oficial de AtomStack o escaneando el código QR en la máquina. Para dispositivos iOS, puede buscar "AtomStack" directamente en la App Store.<br/>
3) Apague los datos móviles:<br/>
Desactive los datos móviles en su teléfono e intente reconectarse.<br/>
4) Pruebe con otro teléfono:<br/>
Si otro teléfono puede conectarse correctamente, proporcione la marca y el sistema operativo del teléfono que no puede conectarse al servicio al cliente para obtener más ayuda.<br/>
5) Envíe los registros de la APP:<br/>
Vaya a "Perfil" → "Sugerencias de mejora", marque "Subir registro" y envíe (vea la Figura 26).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_26_edfac542-0597-4ede-9b5c-48fe5351b884.png?v=1785147594:Figura 26]`,
          video_url: [],
        },
        {
          Q: `12. Glacier se detiene repentinamente durante el grabado y solo puede reconectarse después de reiniciar`,
          A: `Solución:<br/>
1) Verifique la conexión del cable Tipo-C:<br/>
Desconecte y vuelva a conectar el cable Tipo-C, luego intente de nuevo.<br/>
2) Confirme el sistema operativo:<br/>
¿Está usando Windows 11? Si es así, asegúrese de que el software no esté ejecutándose en segundo plano. Cambiarlo al segundo plano puede causar que la máquina se detenga u opere a baja potencia debido a problemas de control.<br/>
3) Pruebe usar AtomStack Studio:<br/>
Descárguelo desde el sitio web oficial: https://atomstack.com/pages/atomstack-studio-software<br/>
4) Verifique el estado del software:<br/>
Cuando la máquina se detenga, verifique si la barra de progreso en el software sigue funcionando.<br/>
* Si sigue funcionando, el problema puede deberse a una conexión deficiente o a una desconexión.<br/>
Intente limpiar los puertos (puerto USB en la caja de control), reemplazar el cable Tipo-C o usar un puerto USB diferente en la computadora.<br/>
5) Vuelva a grabar el firmware:<br/>
Proporcione el Número de serie de la máquina (vea la Figura 27) al servicio al cliente para obtener el firmware correcto. Cargue el firmware usando una unidad USB e intente de nuevo.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_27_6e34e8c8-a940-4512-a70e-cbdb95f4a29f.png?v=1785147594:Figura 27]<br/>
6) Si el problema persiste:<br/>
Es posible que sea necesario reemplazar la placa principal.<br/>
Proporcione sus pasos de solución de problemas, un video de la falla y el Número de serie de la máquina al servicio al cliente para obtener ayuda.<br/>
Consulte el video de reemplazo de la placa principal de Glacier para obtener orientación.`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `13. Falla del enfoque automático del eje Z de Glacier`,
          A: `Solución:<br/>
1) Confirme la instalación correcta del módulo láser:<br/>
Al activar el enfoque automático, verifique si la parte inferior del módulo láser puede alcanzar la superficie del material.<br/>
* Si el láser no puede alcanzar el material incluso cuando el eje Z está en su posición más baja:<br/>
* Ajuste manualmente el deslizador del eje Z hacia arriba a una posición media usando la perilla de ajuste.<br/>
* Afloje los tornillos de montaje del módulo láser.<br/>
* Mueva el módulo láser hacia abajo.<br/>
* Vuelva a apretar los tornillos de montaje.<br/>
Consulte el video de ajuste de altura de instalación del láser de Glacier para obtener orientación.<br/>
2) Verifique si el eje Z puede moverse correctamente:<br/>
En AtomStack Studio o LightBurn, use los botones de control arriba/abajo del eje Z (vea las Figuras 28 y 29) y observe si el eje Z se mueve en la dirección correcta.<br/>
* Si hay ruido anormal y sin movimiento:<br/>
* Verifique si el cableado del motor está correctamente conectado.<br/>
* Desconecte y vuelva a conectar el cable del motor para ver si el problema se resuelve.<br/>
* Si el problema persiste, es posible que sea necesario reemplazar la placa principal, el cable de conexión de la placa principal o el motor del eje Z.<br/>
Grabe un video claro del problema y proporciónelo junto con el Número de serie de la máquina (vea la Figura 30) al servicio al cliente para obtener ayuda.<br/>
Para los procedimientos de reemplazo, consulte:<br/>
* Video de reemplazo de la placa principal de Glacier<br/>
* Video de reemplazo del cable de conexión de la placa principal de Glacier<br/>
* Video de reemplazo del motor del eje Z de Glacier<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_28_9815e7d1-8464-4409-b803-eed0fa10e14a.png?v=1785147593:Figura 28]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_29_04e27f83-b22b-409a-bd5b-e9bc42fd5411.png?v=1785147593:Figura 29]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_30_0563f109-c50c-4379-a1bf-7c60bb1a7343.png?v=1785147594:Figura 30]<br/>
3) Verifique los interruptores de límite superior e inferior:<br/>
Observe el proceso de enfoque automático. Si el eje Z alcanza la posición más alta o más baja y continúa moviéndose sin invertir ni detenerse, el problema puede deberse a un interruptor de límite defectuoso.<br/>
Presione manualmente el interruptor de límite superior del eje Z (vea la Figura 31) y el interruptor de límite inferior del módulo láser (vea la Figura 32) para verificar si se activa una alarma.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_31_1e14c2a0-583b-4fd8-93c7-bd80907f5481.png?v=1785201370:Figura 31]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_32_d536004e-83d1-4499-a206-74daafd86319.png?v=1785201370:Figura 32]<br/>
◆ Sin respuesta del interruptor de límite superior:<br/>
* Si la palanca de activación no vuelve a su posición al presionarla, el interruptor de límite está defectuoso.<br/>
Proporcione un video corto y el Número de serie al servicio al cliente para obtener ayuda.<br/>
* Desconecte y vuelva a conectar el cable del interruptor de límite.<br/>
* Si el problema persiste después de los pasos anteriores, reemplace la placa principal, el cable de conexión de la placa principal o el interruptor de límite superior del eje Z.<br/>
◆ Sin respuesta del interruptor de límite inferior:<br/>
* Si la palanca de activación no vuelve a su posición al presionarla, el interruptor de límite está defectuoso.<br/>
Grabe un video de la falla y proporcione el Número de serie al servicio al cliente.<br/>
* Si el grabado funciona normalmente pero el interruptor de límite no se puede activar:<br/>
* Verifique si el cable del módulo láser está dañado.<br/>
* Desconecte el conector en la parte posterior de la caja de control e inspeccione si hay pines doblados o rotos (vea la Figura 33).<br/>
* Si no se encuentran problemas, es probable que la placa del interruptor de límite inferior esté defectuosa y deba reemplazarse.<br/>
Consulte el video de reemplazo del interruptor de límite inferior del módulo láser de Glacier para obtener instrucciones.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_33_763adacb-fdd4-441d-800e-996418c30c19.png?v=1785201370:Figura 33]`,
          video_url: ['https://youtu.be/snlP-YrBWtc', 'https://youtu.be/G9NPYDo0aTg', 'https://youtu.be/-8kWd_oX3oo'],
        },
        {
          Q: `14. Movimiento anormal o ruido agudo del eje X o del eje Y de Glacier`,
          A: `Solución:<br/>
1) Verifique la estructura de la máquina:<br/>
◆ Verificación del paralelismo del eje X:<br/>
Use una regla para medir la distancia entre ambos extremos del eje X y la viga transversal inferior. Si las distancias son inconsistentes, el eje X no es paralelo al marco, lo que puede hacer que el soporte del eje X se incline y aumente la fricción con los rieles del eje Y, dificultando el movimiento.<br/>
◆ Verifique las correas dentadas del eje Y:<br/>
Presione las dos correas del eje Y con los dedos para verificar si tienen la elasticidad y tensión adecuadas.<br/>
* Si se sienten flojas, afloje los dos tornillos de fijación de la polea tensora de la correa en ambos lados cerca de la viga transversal superior.<br/>
* Tire del bloque tensor para tensar la correa y luego vuelva a apretar los tornillos (vea la Figura 34).<br/>
◆ Si solo el eje X tiene movimiento o ruido anormal:<br/>
Ajuste las ruedas excéntricas de los deslizadores de la guía del eje X según el video de ajuste estructural de Glacier (vea la Figura 35).<br/>
◆ Si el ruido de fricción ocurre en ambos extremos del eje guía:<br/>
Asegúrese de que los acoplamientos en los extremos del eje no estén demasiado cerca de los soportes del eje.<br/>
* Si están demasiado cerca, ajuste el espaciado en consecuencia (vea la Figura 36).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_34_503d1392-9774-4342-b5e7-ed7c7b0fbb16.png?v=1785201369:Figura 34]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_35_412b1b40-3857-4ff1-bb50-329172982e28.png?v=1785201370:Figura 35]<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_36_aa584dad-6952-4026-b5af-190d23dec7fd.png?v=1785201482:Figura 36]<br/>
2) Verifique el cableado del motor:<br/>
Desconecte y vuelva a conectar los cables del motor para ver si el problema se resuelve.<br/>
3) Verifique el estado del marco:<br/>
Inspeccione cuidadosamente los perfiles del eje X y del eje Y para detectar deformaciones, óxido u objetos extraños.<br/>
* Si se encuentra deformación u óxido, tome fotos claras y proporciónelas junto con el Número de serie de la máquina al servicio al cliente para obtener ayuda.<br/>
* Consulte el video de desempaque de Glacier para obtener instrucciones de reemplazo del perfil.<br/>
4) Si el problema persiste:<br/>
Grabe un video de la falla y proporciónelo junto con el Número de serie de la máquina (vea la Figura 37) al servicio al cliente para obtener más soporte.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_37_1de2ff80-2e71-40ff-939e-89eaf1f1e8bc.png?v=1785201482:Figura 37]`,
          video_url: ['https://youtu.be/JwJ4aAmCTPA', 'https://youtu.be/Ym8gOrVkKls'],
        },
        {
          Q: `15. Salida de grabado distorsionada de Glacier`,
          A: `Solución:<br/>
Confirme el tipo de distorsión:<br/>
Grabe un círculo y verifique si está completamente cerrado.<br/>
◆ Completamente cerrado pero aparece como una elipse:<br/>
Esto puede deberse a una configuración incorrecta de los pasos de la máquina.<br/>
* Primero, restaure la configuración de fábrica a través del software.<br/>
* En LightBurn o LaserGRBL, vaya a la configuración de la máquina y verifique si los valores de $100 y $101 están configurados en 100.<br/>
* Si no, cambie ambos valores a 100 (vea la Figura 38).<br/>
◆ Formas abiertas, desalineación o líneas onduladas: estos problemas pueden deberse a problemas estructurales de la máquina. Consulte los siguientes métodos de ajuste estructural.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_38_355a6e36-aada-4b6d-9716-a10e936a4a88.png?v=1785201482:Figura 38]<br/>
Verifique la estructura de la máquina:<br/>
Consulte el video de ajuste estructural de Glacier.<br/>
◆ Verificación del paralelismo del eje X: use una regla para medir si las distancias desde ambos extremos del eje X a la viga transversal inferior son las mismas, para determinar si el eje X es paralelo a las vigas transversales superior e inferior. Si no es paralelo, el marco de soporte del eje X puede inclinarse, aumentando la fricción con los rieles de guía del eje Y y dificultando el movimiento. El método de ajuste es el siguiente:<br/>
-- Herramienta necesaria: llave hexagonal (Allen) L2.0<br/>
-- Pasos:<br/>
Cerca de la viga transversal inferior, localice el motor del eje Y y los dos ejes lineales. Use una llave hexagonal L2.0 para aflojar los tornillos de fijación de los dos acoplamientos de eje en los ejes lineales que están más lejos del motor (vea la Figura 39).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_39_50f4943b-9b6d-4836-a812-3252ea87e32f.png?v=1785201482:Figura 39]<br/>
② Mueva el eje X hacia arriba para que la cadena de cables del eje X quede al ras contra la viga transversal superior (si la cadena no puede permanecer en su lugar, puede asegurarla con una cuerda). Luego apriete los tornillos de fijación previamente aflojados en los acoplamientos del eje.<br/>
③ Después de completar la operación, mida si las distancias desde ambos extremos del eje X a la viga transversal superior o inferior son iguales. Si no, repita los pasos anteriores.<br/>
◆ Verifique las poleas dentadas y los tornillos del acoplamiento: use una llave hexagonal (Allen) L2.0 para verificar si los tornillos de fijación en los acoplamientos y las poleas dentadas están flojos.<br/>
◆ Verifique las correas dentadas del eje Y: presione las dos correas dentadas del eje Y con dos dedos para sentir si tienen buena elasticidad y tensión adecuada. Si se sienten flojas, se requiere ajuste. El método es el siguiente:<br/>
-- Herramienta necesaria: llave hexagonal (Allen) L2.5<br/>
-- Pasos:<br/>
① En los lados de los dos ejes Y cerca del extremo de la viga transversal superior, use una llave hexagonal L2.5 para aflojar los dos tornillos del tensor de la correa dentada (vea la Figura 40).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_40_075d5b20-89e6-4131-bec8-e28940c7fe97.png?v=1785201482:Figura 40]<br/>
② Tire del tensor de la correa dentada con la mano hacia la viga transversal superior para tensar la correa hasta que tenga la tensión y elasticidad adecuadas, luego apriete los dos tornillos de fijación del tensor.<br/>
③ Aplique el mismo método de ajuste al otro eje Y.<br/>
◆ Verifique la correa dentada del eje X: presione la correa dentada del eje X con dos dedos para verificar si tiene buena elasticidad y tensión adecuada. Si se siente floja, se requiere ajuste. El método es el siguiente:<br/>
-- Herramientas necesarias: llaves hexagonales (Allen) L2.0 y L3.0<br/>
-- Pasos:<br/>
① Localice el tensor de la correa dentada en el lado superior derecho del eje X (vea la Figura 41). Use una llave hexagonal L2.0 para aflojar los dos tornillos de fijación en la parte superior.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_41_32a1a5b5-b716-4546-a420-e754124e1720.png?v=1785204756:Figura 41]<br/>
② Use una llave hexagonal L3.0 para girar el tornillo lateral y tensar o aflojar la correa dentada.<br/>
◆ Verifique el deslizador de la guía del eje X: agite suavemente el módulo láser con la mano para verificar si hay juego. Si se tambalea o si el movimiento del eje X es difícil, las ruedas excéntricas del deslizador de la guía del eje X deben ajustarse.<br/>
-- Herramientas necesarias: llave hexagonal (Allen) L2.0, pinzas de punta fina o una herramienta similar<br/>
-- Pasos:<br/>
① Afloje los tornillos de fijación laterales para retirar el módulo láser.<br/>
② Gire la perilla de ajuste manual del eje Z para mover el deslizador del eje Z a la posición más alta. Verá dos ruedas excéntricas circulares (vea la Figura 42).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_42_6b8ab935-00f0-45f0-92e1-2b58759fbd30.png?v=1785204757:Figura 42]<br/>
③ Use una llave hexagonal L2.0 para retirar los tornillos de fijación que aseguran las ruedas excéntricas (vea la Figura 43).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_43_937ed9f1-265e-4728-858d-a9c2e4859228.png?v=1785204756:Figura 43]<br/>
④ Use pinzas de punta fina o una herramienta similar para insertar en los dos orificios de la rueda excéntrica y girarla para ajustar (en el sentido de las agujas del reloj para apretar, en sentido contrario para aflojar). Primero aflójela, luego mueva suavemente el eje Z con la mano para que se alinee naturalmente. Después, apriete la rueda excéntrica en el sentido de las agujas del reloj y finalmente vuelva a instalar los tornillos de fijación.<br/>
⑤ Después de volver a instalar los tornillos, mueva el eje Z hacia la izquierda y la derecha con la mano para verificar si el movimiento es suave, sin tambaleos ni atascos. Si se encuentra alguna anomalía, vuelva a ajustar.<br/>
⑥ Después de completar el ajuste, vuelva a instalar el módulo láser.`,
          video_url: ['https://youtu.be/JwJ4aAmCTPA', ''],
        },
        {
          Q: `16. Glacier activa con frecuencia alarmas de llama durante el procesamiento.`,
          A: `Soluciones:<br/>
1) Verifique el material:<br/>
Si el material es inflamable (como MDF, balsa, etc.), puede causar falsas alarmas de llama. Puede desactivar la función de detección de llama a través de la pantalla táctil, la aplicación móvil o el software AtomStack Studio (vea la Figura 44). Al cortar, se recomienda aumentar adecuadamente la velocidad de corte y usar múltiples pasadas al procesar materiales gruesos.<br/>
Nota: Después de desactivar la función de detección de llama, se requiere una supervisión cercana por parte del operador.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_44_42861e58-6505-4e14-9fb1-6f8c08a20f39.png?v=1785204756:Figura 44]<br/>
2) Verifique el archivo de grabado:<br/>
Si el patrón procesado tiene líneas muy densas cuando se activa la alarma de llama, pueden ocurrir falsas alarmas. Debe aumentar la velocidad, aumentar el número de pasadas o desactivar la función de detección de llama.<br/>
Nota: Se requiere una supervisión cercana del operador durante la operación.<br/>
3) Verifique la placa de detección de llama:<br/>
Realice el procesamiento a un nivel de potencia más bajo. Si la alarma de llama se sigue activando con frecuencia a baja potencia, es posible que la placa de detección de llama esté defectuosa y deba reemplazarse. Consulte el video de reemplazo de la placa de detección de llama de Glacier para obtener orientación.`,
          video_url: ['https://youtu.be/AFZaVnvNV5I'],
        },
        {
          Q: `17. Glacier choca con el marco durante el trazado de límites o el grabado.`,
          A: `Soluciones:<br/>
1) Verifique el tamaño del archivo:<br/>
El tamaño del archivo de grabado importado al software no debe exceder el área de trabajo de Glacier, y el archivo no debe contener coordenadas negativas. Puede volver a abrir el software y usar sus herramientas de dibujo para crear un pequeño patrón de prueba y verificar si el problema persiste.<br/>
2) Verifique si hay problemas de software:<br/>
Intente conectar y operar la máquina usando AtomStack Studio para ver si ocurre el mismo problema. Asegúrese de usar una versión con licencia de LightBurn.<br/>
3) Verifique el movimiento:<br/>
Use los controles direccionales (arriba, abajo, izquierda, derecha) en el software para verificar si la distancia y la dirección del movimiento de la grabadora son correctas. Si ocurre un movimiento anormal, inspeccione cuidadosamente si algún cable está dañado y si los conectores del motor están correctamente enchufados.<br/>
4) Restaure la configuración de fábrica:<br/>
Realice un restablecimiento de fábrica en AtomStack Studio o LightBurn. Los pasos son los siguientes:<br/>
◆ Restablecimiento de fábrica en AtomStack Studio: para la versión 2.20 y superiores, toque "Número de versión: V2.20" (número de versión del cliente) siete veces consecutivas para entrar en el Modo Desarrollador. Vuelva a la barra de menú, abra "Registro del puerto serie" (Modo Desarrollador) y haga clic en "Restablecer" para restaurar la configuración de fábrica. Consulte el video de restablecimiento de fábrica de AtomStack Studio para obtener orientación.<br/>
◆ Restablecimiento de fábrica en LightBurn: ingrese el comando \`$RST=*\` en la "Consola" para restaurar la configuración de fábrica (vea la Figura 45).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_45_ccd64f20-81d8-4ef4-a373-2e1d3fa17aab.png?v=1785204756:Figura 45]`,
          video_url: ['https://youtu.be/aYFFaF1ds4Q'],
        },
        {
          Q: `18. El soporte de montaje del módulo láser de Glacier está flojo.`,
          A: `Solución:<br/>
Ajuste las ruedas excéntricas del deslizador de la guía del eje X.<br/>
1) Herramientas necesarias: llave hexagonal (Allen) L2.0, pinzas de punta fina o una herramienta similar<br/>
2) Pasos:<br/>
◆ Afloje los tornillos de fijación laterales para retirar el módulo láser.<br/>
◆ Gire la perilla de ajuste manual del eje Z para mover el deslizador del eje Z a la posición más alta. Verá dos ruedas excéntricas circulares (vea la Figura 46).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_46_4062a245-79e0-4fc4-87af-1e6ad571de09.png?v=1785205822:Figura 46]<br/>
◆ Use una llave hexagonal L2.0 para retirar los tornillos de fijación que aseguran las ruedas excéntricas (vea la Figura 47).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_47_4f424350-a03b-4721-89c4-af6a284005e0.png?v=1785205822:Figura 47]<br/>
◆ Use pinzas de punta fina o una herramienta similar para insertar en los dos orificios de la rueda excéntrica y girarla para ajustar (en el sentido de las agujas del reloj para apretar, en sentido contrario para aflojar). Primero aflójela, luego mueva suavemente el eje Z con la mano para permitir que se alinee naturalmente. Después, apriete la rueda excéntrica en el sentido de las agujas del reloj y finalmente vuelva a instalar los tornillos de fijación.<br/>
◆ Después de volver a instalar los tornillos, mueva el eje Z hacia la izquierda y la derecha con la mano para verificar si el movimiento es suave, sin tambaleos ni atascos. Si se encuentra alguna anomalía, vuelva a ajustar.<br/>
◆ Después de completar el ajuste, vuelva a instalar el módulo láser.`,
          video_url: [],
        },
        {
          Q: `19. Al grabar a través de la aplicación móvil, Glacier indica que no hay una unidad USB insertada.`,
          A: `Soluciones:<br/>
1) Reinicie la máquina: Apague la alimentación y cierre la aplicación móvil. Reinicie tanto la máquina como la aplicación, luego intente de nuevo.<br/>
2) Pruebe con otro teléfono: Use un dispositivo móvil diferente para probar. Si el otro teléfono funciona normalmente, proporcione el modelo del teléfono y suba los registros a nuestro sistema (vea la Figura 48).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_48_f5414ecb-219a-4475-ba3c-2f64c5b9d33c.png?v=1785205822:Figura 48]<br/>
3) Verifique la unidad USB: Retire la unidad USB de la caja de control e insértela en una computadora para verificar si los datos se pueden leer y escribir correctamente.<br/>
◆ Si los datos se pueden leer normalmente: Reemplácela con otra unidad USB (32 GB o menos) e insértela en la caja de control de la máquina para probar. Si el grabado funciona normalmente después del reemplazo, la unidad USB original está defectuosa.<br/>
◆ Si los datos no se pueden leer normalmente: Formatee la unidad USB en una computadora a FAT32, luego vuelva a insertarla en la caja de control y pruebe de nuevo. Si el problema persiste, pruebe con otra unidad USB (32 GB o menos).<br/>
◆ Si los datos se pueden leer normalmente, pero reemplazarla con otra unidad USB (32 GB o menos) aún no resuelve el problema, es posible que el puerto USB de la placa principal esté defectuoso. Proporcione los pasos detallados de solución de problemas, un video y el Número de serie de la máquina (vea la Figura 49), y envíelos al soporte al cliente para obtener ayuda. Para el reemplazo de la placa principal, consulte el video de reemplazo de la placa principal de Glacier.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_49_f08fa36c-0d32-44d1-bfb5-907f6de16255.png?v=1785205821:Figura 49]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `20. Después de conectarse, Glacier indica continuamente que no hay una llave USB insertada.`,
          A: `Soluciones:<br/>
1) Vuelva a conectar la llave USB: Apague la máquina, retire la llave USB y vuelva a insertarla. Encienda la máquina y verifique si funciona normalmente.<br/>
2) Use la llave USB de repuesto: Apague la máquina, retire la llave USB actual e inserte la llave USB de repuesto proporcionada para verificar si funciona correctamente.<br/>
3) Si el problema persiste con la llave USB de repuesto: Si la alarma continúa, es posible que la placa principal esté defectuosa. Proporcione los pasos de solución de problemas realizados, un video del problema y el Número de serie de la máquina (vea la Figura 50), y envíelos al soporte al cliente para obtener ayuda. Para el reemplazo de la placa principal, consulte el video de reemplazo de la placa principal de Glacier.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_50_0dc483ae-dde6-4176-bf33-9bfabd753f40.png?v=1785205821:Figura 50]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `21. Después de encender, el módulo láser de Glacier no se puede mover manualmente a la posición de grabado deseada.`,
          A: `Soluciones:<br/>
Verifique la función "Reanudación tras apagado": Después de conectarse a través de AtomStack Studio o la aplicación móvil, toque el ícono en la esquina superior derecha para entrar en la información del dispositivo. Verifique si la función "Reanudación tras apagado" está habilitada (cuando esta función está habilitada, el cabezal láser debe moverse usando los controles direccionales en el software) (vea la Figura 51).<br/>
Si está habilitada, desactívela. Después de desactivarla, podrá mover manualmente el módulo láser a la posición de grabado deseada mientras la máquina está encendida.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_51_bee2632b-2752-4695-b6a4-fb74729eb9a8.png?v=1785205992:Figura 51]<br/>
2) Si la función "Reanudación tras apagado" no está habilitada y el módulo láser aún no se puede mover manualmente después de encender, es posible que la placa principal esté defectuosa. Proporcione un video del problema (el video debe incluir los pasos de solución de problemas descritos en el punto (1)), junto con el Número de serie de la máquina (vea la Figura 52), y envíelos al soporte al cliente para obtener ayuda. Para el reemplazo de la placa principal, consulte el video de reemplazo de la placa principal de Glacier.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_52_83a13642-dd84-4b80-8cd8-9771dbbe6af9.png?v=1785205992:Figura 52]`,
          video_url: ['https://youtu.be/G9NPYDo0aTg'],
        },
        {
          Q: `22. Mal funcionamiento de la asistencia de aire de Glacier.`,
          A: `Soluciones:<br/>
1) Confirme que la grabadora esté funcionando: Si la asistencia de aire está conectada al puerto AIR ASSIST en la placa principal, solo se activará durante las operaciones de grabado o corte.<br/>
2) Verifique el interruptor giratorio: Asegúrese de que el interruptor giratorio de la asistencia de aire esté encendido. Tenga en cuenta que girar el interruptor en el sentido de las agujas del reloj enciende la asistencia de aire y ajusta el caudal de aire.<br/>
3) Verifique la fuente de alimentación: Use una fuente de alimentación de CC 24 V para alimentar la asistencia de aire directamente y verifique si puede arrancar normalmente.<br/>
Si no arranca cuando se alimenta desde la placa principal durante el grabado o corte, pero puede arrancar cuando se alimenta directamente con una fuente de CC 24 V, el problema puede estar en la placa principal o en el cable de alimentación de la bomba de aire. Puede usar un multímetro para probar la continuidad del cable de alimentación de la bomba de aire y enviar los resultados al soporte al cliente para obtener más ayuda.<br/>
4) Verifique el estado de funcionamiento después del arranque: Después de iniciar el grabado o de suministrar alimentación a la asistencia de aire por separado, gire el interruptor giratorio para verificar si la asistencia de aire vibra.<br/>
◆ Sin respuesta en absoluto: El interruptor giratorio puede estar defectuoso. Envíe un video del problema junto con el Número de serie de la máquina (vea la Figura 53) al soporte al cliente. Para el reemplazo, consulte el video de reemplazo del interruptor giratorio de la asistencia de aire.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_53_55f46b4e-2f8b-4a9d-a1e7-b103b445faf6.png?v=1785205992:Figura 53]<br/>
◆ Hay vibración pero sin flujo de aire o flujo de aire muy débil: La bomba de aire puede estar defectuosa y necesita ser reemplazada. Envíe un video del problema junto con el Número de serie de la máquina al soporte al cliente. Para el reemplazo, consulte el video de reemplazo de la bomba de la asistencia de aire.`,
          video_url: ['https://youtu.be/BZh7FTwe9tw', 'https://youtu.be/qG9kFGDaoMU'],
        },
        {
          Q: `23. La pantalla del enfriador de Glacier está agrietada.`,
          A: `Solución:<br/>
Si la pantalla del enfriador está dañada, se debe reemplazar el ensamblaje de la pantalla. Proporcione fotos del empaque, fotos del daño y el Número de serie de la máquina (vea la Figura 54), y envíelas al soporte al cliente para obtener ayuda. Para el reemplazo, consulte el video de reemplazo de la pantalla del enfriador de Glacier.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_54_85ba8926-6e5d-46e7-a0e5-6f5d00752a62.png?v=1785205992:Figura 54]`,
          video_url: ['https://youtu.be/22_egYEreCs'],
        },
        {
          Q: `24. Al usar el accesorio giratorio con Glacier, gira continuamente al iniciar.`,
          A: `Solución:<br/>
Este comportamiento generalmente es causado por la función de inicio en LightBurn. Abra "Configuración del dispositivo" y, en "Otras opciones", desactive la función "Inicio automático al encender" (vea la Figura 55).<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_55_b42e3eff-bbaf-49dc-88c4-206ed4360a46.png?v=1785205992:Figura 55]`,
          video_url: [],
        },
        {
          Q: `25. Actualización de firmware de Glacier.`,
          A: `Solución:<br/>
Consulte el video de actualización de firmware de Glacier.<br/>
1) Actualización mediante unidad USB / tarjeta TF: Copie el archivo de firmware de Glacier (en formato .bin) al directorio raíz de una unidad USB o tarjeta TF, luego insértelo en la caja de control para realizar una actualización automática.<br/>
Nota: La misma versión de firmware no se puede actualizar repetidamente, y los archivos de firmware con nombres diferentes no activarán la actualización automática.<br/>
2) Actualización mediante AtomStack Studio: Después de una conexión exitosa, haga clic en el ícono del menú (tres líneas) en la esquina superior derecha del software para entrar en la Información del dispositivo. En la parte inferior, puede verificar la versión actual del firmware.<br/>
Si muestra que la versión ya es la más reciente, no se necesita actualización. Si muestra "Actualizar" (vea la Figura 56), hay una actualización de firmware disponible. Inserte una unidad USB o tarjeta TF, luego haga clic en "Actualizar" y espere a que se complete el proceso.<br/>
[img:https://cdn.shopify.com/s/files/1/0790/2586/4977/files/Figure_56_375c4b6f-1552-4aab-9a7d-b094b4e36083.png?v=1785205992:Figura 56]<br/>
3) Actualización mediante la aplicación móvil: Después de conectarse a través de la aplicación móvil, aparecerá automáticamente un aviso si hay una nueva versión de firmware disponible. Para actualizar, inserte una unidad USB o tarjeta TF y toque "Actualizar", luego espere a que se complete.`,
          video_url: ['https://youtu.be/Gt8WUiWozO0'],
        },
        {
          Q: `26. Posibles códigos de alarma de Glacier.`,
          A: `[table:alarm_codes]`,
          tables: {
            alarm_codes: {
              headers: ['Nombre de la alarma', 'Descripción', 'Solución'],
              rows: [
                [
                  'Alarma 1',
                  'Alarma de límite duro',
                  '1. Verifique si se ha activado un interruptor de límite.<br/>2. Presione manualmente el interruptor de límite para verificar su activación correcta.<br/>3. Desconecte el cable del interruptor de límite y verifique si la alarma aún ocurre.',
                ],
                [
                  'Alarma 2',
                  'Alarma de límite suave',
                  'Esta alarma generalmente no ocurre en condiciones normales.',
                ],
                ['Alarma 3', 'Ciclo abortado', 'Normal, no se requiere acción.'],
                [
                  'Alarma 4',
                  'Fallo inicial de la sonda',
                  'Presione manualmente el interruptor de límite para verificar si se puede activar correctamente.',
                ],
                [
                  'Alarma 5',
                  'Fallo de contacto de la sonda',
                  'La sonda no se activó dentro del rango de recorrido durante el enfoque automático.',
                ],
                [
                  'Alarma 6',
                  'Fallo de restablecimiento de inicio',
                  'El inicio falló, posiblemente debido a un interruptor de límite activado.',
                ],
                [
                  'Alarma 7',
                  'Fallo de inicio por puerta',
                  'La puerta de la carcasa se abrió durante el proceso de inicio.',
                ],
                [
                  'Alarma 8',
                  'Fallo de separación al iniciar',
                  'Verifique los interruptores de límite. Esto suele ocurrir debido a errores de enfoque automático. Primero verifique manualmente que todos los interruptores de límite se puedan activar.',
                ],
                [
                  'Alarma 9',
                  'Fallo de aproximación al iniciar',
                  'No se detectó ningún interruptor de límite dentro de la distancia de búsqueda. Verifique manualmente que todos los interruptores de límite funcionen correctamente.',
                ],
                [
                  'Alarma 11',
                  'Alarma de inclinación de la máquina',
                  'Se ha activado la protección contra inclinación de la máquina.',
                ],
                [
                  'Alarma 12',
                  'Llama detectada',
                  'Llama detectada. Verifique si el material es inflamable (por ejemplo, MDF, balsa), si el patrón es demasiado denso o si la luz solar directa está causando una falsa alarma.',
                ],
                [
                  'Alarma 14',
                  'Bloqueo de seguridad',
                  'La llave USB no está insertada o tiene mal contacto.',
                ],
                [
                  'Alarma 17',
                  'Bluetooth habilitado',
                  'El dispositivo está en modo de configuración de red; todas las demás operaciones están deshabilitadas.',
                ],
                [
                  'Alarma 19',
                  'Alarma de sobre temperatura',
                  'La temperatura del láser excede el límite. Verifique el sistema de refrigeración.',
                ],
                [
                  'Alarma 20',
                  'Alarma del enfriador',
                  'Se ha activado la alarma del enfriador. Verifique el código de error del enfriador.',
                ],
              ],
            },
          },
          video_url: [],
        },
      ],
    ],
  },

};
